const female = {
    "ادرک": {
        "root": "farsi"
    },
    "اردویسور": {
        "root": "farsi"
    },
    "ارشیت": {
        "root": "farsi"
    },
    "امرداد": {
        "root": "farsi"
    },
    "امستریس": {
        "root": "farsi"
    },
    "اهونور": {
        "root": "farsi"
    },
    "استاتیرا": {
        "root": "farsi"
    },
    "ابتسام": {
        "root": "farsi"
    },
    "ابریشم": {
        "root": "farsi"
    },
    "ابناس": {
        "root": "farsi"
    },
    "احترام": {
        "root": "farsi"
    },
    "احلام": {
        "root": "farsi"
    },
    "اختر": {
        "root": "farsi"
    },
    "اخگر": {
        "root": "farsi"
    },
    "ادرینا": {
        "root": "farsi"
    },
    "ادلیا": {
        "root": "farsi"
    },
    "ارانوس": {
        "root": "farsi"
    },
    "ارتاش": {
        "root": "farsi"
    },
    "اردیبهشت": {
        "root": "farsi"
    },
    "ارزنده": {
        "root": "farsi"
    },
    "ارزینه": {
        "root": "farsi"
    },
    "ارسا": {
        "root": "farsi"
    },
    "ارسان": {
        "root": "farsi"
    },
    "ارشامه": {
        "root": "farsi"
    },
    "ارشنوش": {
        "root": "farsi"
    },
    "ارشیدا": {
        "root": "farsi"
    },
    "ارشین": {
        "root": "farsi"
    },
    "ارغنون": {
        "root": "farsi"
    },
    "ارغوان": {
        "root": "farsi"
    },
    "ارکیده": {
        "root": "farsi"
    },
    "ارمغان": {
        "root": "farsi"
    },
    "ارمیتا": {
        "root": "farsi"
    },
    "ارناز": {
        "root": "farsi"
    },
    "ارنواز": {
        "root": "farsi"
    },
    "اروس": {
        "root": "farsi"
    },
    "اروشا": {
        "root": "farsi"
    },
    "اروشه": {
        "root": "farsi"
    },
    "ارون": {
        "root": "farsi"
    },
    "اریحا": {
        "root": "farsi"
    },
    "اریدیس": {
        "root": "farsi"
    },
    "اریکا": {
        "root": "farsi"
    },
    "ارین": {
        "root": "farsi"
    },
    "ارینا": {
        "root": "farsi"
    },
    "اسپانتا": {
        "root": "farsi"
    },
    "اسپنتا": {
        "root": "farsi"
    },
    "اسپنوی": {
        "root": "farsi"
    },
    "استر": {
        "root": "farsi"
    },
    "اسرا": {
        "root": "farsi"
    },
    "اسرین": {
        "root": "farsi"
    },
    "اسفنددخت": {
        "root": "farsi"
    },
    "اسما": {
        "root": "farsi"
    },
    "اسنا": {
        "root": "farsi"
    },
    "اشااونی": {
        "root": "farsi"
    },
    "اشتار": {
        "root": "farsi"
    },
    "اشرف": {
        "root": "farsi"
    },
    "اشک": {
        "root": "farsi"
    },
    "اشلی": {
        "root": "farsi"
    },
    "اشوچهر": {
        "root": "farsi"
    },
    "اشودخت": {
        "root": "farsi"
    },
    "اشوروی": {
        "root": "farsi"
    },
    "اشوزاد": {
        "root": "farsi"
    },
    "اشومهر": {
        "root": "farsi"
    },
    "اصیلا": {
        "root": "farsi"
    },
    "اطلس": {
        "root": "farsi"
    },
    "اطلسی": {
        "root": "farsi"
    },
    "اطهر": {
        "root": "farsi"
    },
    "اعظم": {
        "root": "farsi"
    },
    "افرا": {
        "root": "farsi"
    },
    "افروز": {
        "root": "farsi"
    },
    "افروغ": {
        "root": "farsi"
    },
    "افرینا": {
        "root": "farsi"
    },
    "افسار": {
        "root": "farsi"
    },
    "افسانه": {
        "root": "farsi"
    },
    "افسر": {
        "root": "farsi"
    },
    "افسرخاتون": {
        "root": "farsi"
    },
    "افسردخت": {
        "root": "farsi"
    },
    "افسون": {
        "root": "farsi"
    },
    "افشان": {
        "root": "farsi"
    },
    "افشید": {
        "root": "farsi"
    },
    "افق": {
        "root": "farsi"
    },
    "اقاقی": {
        "root": "farsi"
    },
    "اقاقیا": {
        "root": "farsi"
    },
    "اقدس": {
        "root": "farsi"
    },
    "اقلیما": {
        "root": "farsi"
    },
    "اقلیمیا": {
        "root": "farsi"
    },
    "اکرم": {
        "root": "farsi"
    },
    "اکلیل": {
        "root": "farsi"
    },
    "الارا": {
        "root": "farsi"
    },
    "الاهه": {
        "root": "farsi"
    },
    "الحان": {
        "root": "farsi"
    },
    "السا": {
        "root": "farsi"
    },
    "الکا": {
        "root": "farsi"
    },
    "اللهنظر": {
        "root": "farsi"
    },
    "الما": {
        "root": "farsi"
    },
    "الماس": {
        "root": "farsi"
    },
    "الماسخاتون": {
        "root": "farsi"
    },
    "المیرا": {
        "root": "farsi"
    },
    "المینا": {
        "root": "farsi"
    },
    "النا": {
        "root": "farsi"
    },
    "الناز": {
        "root": "farsi"
    },
    "الهام": {
        "root": "farsi"
    },
    "الهه": {
        "root": "farsi"
    },
    "الیزه": {
        "root": "farsi"
    },
    "الیسا": {
        "root": "farsi"
    },
    "الیکا": {
        "root": "farsi"
    },
    "الیما": {
        "root": "farsi"
    },
    "الین": {
        "root": "farsi"
    },
    "الینا": {
        "root": "farsi"
    },
    "امالبنین": {
        "root": "farsi"
    },
    "اماندا": {
        "root": "farsi"
    },
    "امانه": {
        "root": "farsi"
    },
    "امل": {
        "root": "farsi"
    },
    "امیتیس": {
        "root": "farsi"
    },
    "امیده": {
        "root": "farsi"
    },
    "امیرا": {
        "root": "farsi"
    },
    "امیردخت": {
        "root": "farsi"
    },
    "امیره": {
        "root": "farsi"
    },
    "امیل": {
        "root": "farsi"
    },
    "امیله": {
        "root": "farsi"
    },
    "امیندخت": {
        "root": "farsi"
    },
    "امینا": {
        "root": "farsi"
    },
    "امینه": {
        "root": "farsi"
    },
    "انار": {
        "root": "farsi"
    },
    "انارام": {
        "root": "farsi"
    },
    "انارگل": {
        "root": "farsi"
    },
    "اندیشه": {
        "root": "farsi"
    },
    "انسیه": {
        "root": "farsi"
    },
    "انگاره": {
        "root": "farsi"
    },
    "انگبین": {
        "root": "farsi"
    },
    "انگیزه": {
        "root": "farsi"
    },
    "انوشا": {
        "root": "farsi"
    },
    "انوشک": {
        "root": "farsi"
    },
    "انوشکا": {
        "root": "farsi"
    },
    "انوشکزاد": {
        "root": "farsi"
    },
    "انوشه": {
        "root": "farsi"
    },
    "انوشهدخت": {
        "root": "farsi"
    },
    "انوشهروان": {
        "root": "farsi"
    },
    "انیبا": {
        "root": "farsi"
    },
    "انیتا": {
        "root": "farsi"
    },
    "انیران": {
        "root": "farsi"
    },
    "انیس": {
        "root": "farsi"
    },
    "انیسا": {
        "root": "farsi"
    },
    "انیسون": {
        "root": "farsi"
    },
    "انیسه": {
        "root": "farsi"
    },
    "اوراشی": {
        "root": "farsi"
    },
    "اوران": {
        "root": "farsi"
    },
    "اورانوس": {
        "root": "farsi"
    },
    "اورنینا": {
        "root": "farsi"
    },
    "اوریسا": {
        "root": "farsi"
    },
    "اورینا": {
        "root": "farsi"
    },
    "اولدوز": {
        "root": "farsi"
    },
    "اویتا": {
        "root": "farsi"
    },
    "اویسا": {
        "root": "farsi"
    },
    "اوینار": {
        "root": "farsi"
    },
    "ایپک": {
        "root": "farsi"
    },
    "ایدا": {
        "root": "farsi"
    },
    "ایده": {
        "root": "farsi"
    },
    "ایران": {
        "root": "farsi"
    },
    "ایرانناز": {
        "root": "farsi"
    },
    "ایرانا": {
        "root": "farsi"
    },
    "ایرانبانو": {
        "root": "farsi"
    },
    "ایراندخت": {
        "root": "farsi"
    },
    "ایرانشید": {
        "root": "farsi"
    },
    "ایرانه": {
        "root": "farsi"
    },
    "ایرسا": {
        "root": "farsi"
    },
    "ایرن": {
        "root": "farsi"
    },
    "ایزدچهر": {
        "root": "farsi"
    },
    "ایسیه": {
        "root": "farsi"
    },
    "ایشتار": {
        "root": "farsi"
    },
    "ایلار": {
        "root": "farsi"
    },
    "ایلانا": {
        "root": "farsi"
    },
    "ایلناز": {
        "root": "farsi"
    },
    "ایلیکا": {
        "root": "farsi"
    },
    "ایلیم": {
        "root": "farsi"
    },
    "ایما": {
        "root": "farsi"
    },
    "ایمنه": {
        "root": "farsi"
    },
    "ایناز": {
        "root": "farsi"
    },
    "ایناس": {
        "root": "farsi"
    },
    "ایواز": {
        "root": "farsi"
    },
    "ایوان": {
        "root": "farsi"
    },
    "آبانآسا": {
        "root": "farsi"
    },
    "آباندخت": {
        "root": "farsi"
    },
    "آباندیس": {
        "root": "farsi"
    },
    "آبانسا": {
        "root": "farsi"
    },
    "آبانفام": {
        "root": "farsi"
    },
    "آبانمهر": {
        "root": "farsi"
    },
    "آبانک": {
        "root": "farsi"
    },
    "آبانه": {
        "root": "farsi"
    },
    "آبتاب": {
        "root": "farsi"
    },
    "آبدیس": {
        "root": "farsi"
    },
    "آبرخ": {
        "root": "farsi"
    },
    "آبرنگ": {
        "root": "farsi"
    },
    "آبرود": {
        "root": "farsi"
    },
    "آبروشن": {
        "root": "farsi"
    },
    "آبرون": {
        "root": "farsi"
    },
    "آبسالان": {
        "root": "farsi"
    },
    "آبشار": {
        "root": "farsi"
    },
    "آبشن": {
        "root": "farsi"
    },
    "آبگل": {
        "root": "farsi"
    },
    "آبگون": {
        "root": "farsi"
    },
    "آبگینه": {
        "root": "farsi"
    },
    "آبلوج": {
        "root": "farsi"
    },
    "آبناز": {
        "root": "farsi"
    },
    "آبنوس": {
        "root": "farsi"
    },
    "آبنوش": {
        "root": "farsi"
    },
    "آبیژ": {
        "root": "farsi"
    },
    "آپادیپا": {
        "root": "farsi"
    },
    "آپام": {
        "root": "farsi"
    },
    "آپاما": {
        "root": "farsi"
    },
    "آپامنه": {
        "root": "farsi"
    },
    "آپامه": {
        "root": "farsi"
    },
    "آپگیا": {
        "root": "farsi"
    },
    "آپگیتی": {
        "root": "farsi"
    },
    "آپیشن": {
        "root": "farsi"
    },
    "آتاناز": {
        "root": "farsi"
    },
    "آتر": {
        "root": "farsi"
    },
    "آترا": {
        "root": "farsi"
    },
    "آتری": {
        "root": "farsi"
    },
    "آتریسا": {
        "root": "farsi"
    },
    "آترینا": {
        "root": "farsi"
    },
    "آتسا": {
        "root": "farsi"
    },
    "آتشپاره": {
        "root": "farsi"
    },
    "آتشدخت": {
        "root": "farsi"
    },
    "آتشفام": {
        "root": "farsi"
    },
    "آتشک": {
        "root": "farsi"
    },
    "آتشگون": {
        "root": "farsi"
    },
    "آتشه": {
        "root": "farsi"
    },
    "آتشی": {
        "root": "farsi"
    },
    "آتشیزه": {
        "root": "farsi"
    },
    "آتشین": {
        "root": "farsi"
    },
    "آتلاز": {
        "root": "farsi"
    },
    "آتنا": {
        "root": "farsi"
    },
    "آتنایا": {
        "root": "farsi"
    },
    "آتنه": {
        "root": "farsi"
    },
    "آتور": {
        "root": "farsi"
    },
    "آتورینا": {
        "root": "farsi"
    },
    "آتوسا": {
        "root": "farsi"
    },
    "آتوشه": {
        "root": "farsi"
    },
    "آتیس": {
        "root": "farsi"
    },
    "آتیه": {
        "root": "farsi"
    },
    "آدا": {
        "root": "farsi"
    },
    "آدخت": {
        "root": "farsi"
    },
    "آدنا": {
        "root": "farsi"
    },
    "آدنیس": {
        "root": "farsi"
    },
    "آدورینا": {
        "root": "farsi"
    },
    "آدونیس": {
        "root": "farsi"
    },
    "آدیشه": {
        "root": "farsi"
    },
    "آذار": {
        "root": "farsi"
    },
    "آذر": {
        "root": "farsi"
    },
    "آذربانو": {
        "root": "farsi"
    },
    "آذربو": {
        "root": "farsi"
    },
    "آذربویه": {
        "root": "farsi"
    },
    "آذرجهان": {
        "root": "farsi"
    },
    "آذرخاتون": {
        "root": "farsi"
    },
    "آذردخت": {
        "root": "farsi"
    },
    "آذررخ": {
        "root": "farsi"
    },
    "آذرک": {
        "root": "farsi"
    },
    "آذرگل": {
        "root": "farsi"
    },
    "آذرگون": {
        "root": "farsi"
    },
    "آذرماه": {
        "root": "farsi"
    },
    "آذرمه": {
        "root": "farsi"
    },
    "آذرمهر": {
        "root": "farsi"
    },
    "آذرمیدخت": {
        "root": "farsi"
    },
    "آذرمینا": {
        "root": "farsi"
    },
    "آذرنوش": {
        "root": "farsi"
    },
    "آذرهمایون": {
        "root": "farsi"
    },
    "آذریون": {
        "root": "farsi"
    },
    "آذین": {
        "root": "farsi"
    },
    "آذیندخت": {
        "root": "farsi"
    },
    "آذینگل": {
        "root": "farsi"
    },
    "آرا": {
        "root": "farsi"
    },
    "آراسته": {
        "root": "farsi"
    },
    "آراشید": {
        "root": "farsi"
    },
    "آراگل": {
        "root": "farsi"
    },
    "آرالیا": {
        "root": "farsi"
    },
    "آرام": {
        "root": "farsi"
    },
    "آرامدخت": {
        "root": "farsi"
    },
    "آرامدل": {
        "root": "farsi"
    },
    "آرامش": {
        "root": "farsi"
    },
    "آرامه": {
        "root": "farsi"
    },
    "آرامیس": {
        "root": "farsi"
    },
    "آرایه": {
        "root": "farsi"
    },
    "آرتادخت": {
        "root": "farsi"
    },
    "آرتنوس": {
        "root": "farsi"
    },
    "آرتونیس": {
        "root": "farsi"
    },
    "آرتهدخت": {
        "root": "farsi"
    },
    "آرتیستون": {
        "root": "farsi"
    },
    "آرتیمیس": {
        "root": "farsi"
    },
    "آرتینا": {
        "root": "farsi"
    },
    "آرزو": {
        "root": "farsi"
    },
    "آرژان": {
        "root": "farsi"
    },
    "آرسینه": {
        "root": "farsi"
    },
    "آرشیدا": {
        "root": "farsi"
    },
    "آرشین": {
        "root": "farsi"
    },
    "آرگون": {
        "root": "farsi"
    },
    "آرمانا": {
        "root": "farsi"
    },
    "آرمتی": {
        "root": "farsi"
    },
    "آرمه": {
        "root": "farsi"
    },
    "آرمیتا": {
        "root": "farsi"
    },
    "آرمیتان": {
        "root": "farsi"
    },
    "آرمیتی": {
        "root": "farsi"
    },
    "آرمیدخت": {
        "root": "farsi"
    },
    "آرمیس": {
        "root": "farsi"
    },
    "آرمیلا": {
        "root": "farsi"
    },
    "آرمینا": {
        "root": "farsi"
    },
    "آرمیندخت": {
        "root": "farsi"
    },
    "آرمینه": {
        "root": "farsi"
    },
    "آرنوش": {
        "root": "farsi"
    },
    "آرنوشا": {
        "root": "farsi"
    },
    "آرنیکا": {
        "root": "farsi"
    },
    "آروا": {
        "root": "farsi"
    },
    "آروشا": {
        "root": "farsi"
    },
    "آرویشه": {
        "root": "farsi"
    },
    "آریادخت": {
        "root": "farsi"
    },
    "آریانا": {
        "root": "farsi"
    },
    "آریاناز": {
        "root": "farsi"
    },
    "آریانوش": {
        "root": "farsi"
    },
    "آریژه": {
        "root": "farsi"
    },
    "آریسا": {
        "root": "farsi"
    },
    "آریسان": {
        "root": "farsi"
    },
    "آریشیدا": {
        "root": "farsi"
    },
    "آرینا": {
        "root": "farsi"
    },
    "آریندخت": {
        "root": "farsi"
    },
    "آزادچهر": {
        "root": "farsi"
    },
    "آزاددخت": {
        "root": "farsi"
    },
    "آزاده": {
        "root": "farsi"
    },
    "آزادهخوی": {
        "root": "farsi"
    },
    "آزاله": {
        "root": "farsi"
    },
    "آزالیا": {
        "root": "farsi"
    },
    "آزرم": {
        "root": "farsi"
    },
    "آزرمخاتون": {
        "root": "farsi"
    },
    "آزرمدخت": {
        "root": "farsi"
    },
    "آزرمیدخت": {
        "root": "farsi"
    },
    "آزیتا": {
        "root": "farsi"
    },
    "آزین": {
        "root": "farsi"
    },
    "آسا": {
        "root": "farsi"
    },
    "آسادخت": {
        "root": "farsi"
    },
    "آساره": {
        "root": "farsi"
    },
    "آسانا": {
        "root": "farsi"
    },
    "آسکی": {
        "root": "farsi"
    },
    "آسمان": {
        "root": "farsi"
    },
    "آسمانهور": {
        "root": "farsi"
    },
    "آسنا": {
        "root": "farsi"
    },
    "آسنات": {
        "root": "farsi"
    },
    "آسودا": {
        "root": "farsi"
    },
    "آسوده": {
        "root": "farsi"
    },
    "آسیا": {
        "root": "farsi"
    },
    "آسیمن": {
        "root": "farsi"
    },
    "آسیه": {
        "root": "farsi"
    },
    "آشتی": {
        "root": "farsi"
    },
    "آشنا": {
        "root": "farsi"
    },
    "آشوب": {
        "root": "farsi"
    },
    "آشورینا": {
        "root": "farsi"
    },
    "آشیان": {
        "root": "farsi"
    },
    "آصفه": {
        "root": "farsi"
    },
    "آطوسا": {
        "root": "farsi"
    },
    "آغابانو": {
        "root": "farsi"
    },
    "آفاق": {
        "root": "farsi"
    },
    "آفت": {
        "root": "farsi"
    },
    "آفتاب": {
        "root": "farsi"
    },
    "آفتابدخت": {
        "root": "farsi"
    },
    "آفریده": {
        "root": "farsi"
    },
    "آفرین": {
        "root": "farsi"
    },
    "آفرینگل": {
        "root": "farsi"
    },
    "آفرینماه": {
        "root": "farsi"
    },
    "آفرینمهر": {
        "root": "farsi"
    },
    "آفرینناز": {
        "root": "farsi"
    },
    "آفریننوش": {
        "root": "farsi"
    },
    "آفریندخت": {
        "root": "farsi"
    },
    "آفسانه": {
        "root": "farsi"
    },
    "آفشید": {
        "root": "farsi"
    },
    "آقبانو": {
        "root": "farsi"
    },
    "آقگل": {
        "root": "farsi"
    },
    "آگاهدخت": {
        "root": "farsi"
    },
    "آگرین": {
        "root": "farsi"
    },
    "آلا": {
        "root": "farsi"
    },
    "آلاگل": {
        "root": "farsi"
    },
    "آلاله": {
        "root": "farsi"
    },
    "آلانقوا": {
        "root": "farsi"
    },
    "آلانگوا": {
        "root": "farsi"
    },
    "آلاوه": {
        "root": "farsi"
    },
    "آلبا": {
        "root": "farsi"
    },
    "آلتنای": {
        "root": "farsi"
    },
    "آلتون": {
        "root": "farsi"
    },
    "آلتین": {
        "root": "farsi"
    },
    "آلتینگلین": {
        "root": "farsi"
    },
    "آلما": {
        "root": "farsi"
    },
    "آلماز": {
        "root": "farsi"
    },
    "آلند": {
        "root": "farsi"
    },
    "آلنوش": {
        "root": "farsi"
    },
    "آلوگونه": {
        "root": "farsi"
    },
    "آلیس": {
        "root": "farsi"
    },
    "آلیسا": {
        "root": "farsi"
    },
    "آلیش": {
        "root": "farsi"
    },
    "آماتیس": {
        "root": "farsi"
    },
    "آماستریس": {
        "root": "farsi"
    },
    "آمال": {
        "root": "farsi"
    },
    "آماندانا": {
        "root": "farsi"
    },
    "آمتیس": {
        "root": "farsi"
    },
    "آمستریس": {
        "root": "farsi"
    },
    "آمنه": {
        "root": "farsi"
    },
    "آموتیا": {
        "root": "farsi"
    },
    "آمیتریس": {
        "root": "farsi"
    },
    "آمیتیدا": {
        "root": "farsi"
    },
    "آمیتیس": {
        "root": "farsi"
    },
    "آن": {
        "root": "farsi"
    },
    "آنا": {
        "root": "farsi"
    },
    "آناشید": {
        "root": "farsi"
    },
    "آنالی": {
        "root": "farsi"
    },
    "آناهیتا": {
        "root": "farsi"
    },
    "آناهید": {
        "root": "farsi"
    },
    "آندیا": {
        "root": "farsi"
    },
    "آنسه": {
        "root": "farsi"
    },
    "آنو": {
        "root": "farsi"
    },
    "آنوش": {
        "root": "farsi"
    },
    "آنوشا": {
        "root": "farsi"
    },
    "آنیا": {
        "root": "farsi"
    },
    "آنیتا": {
        "root": "farsi"
    },
    "آنیس": {
        "root": "farsi"
    },
    "آنیسا": {
        "root": "farsi"
    },
    "آوا": {
        "root": "farsi"
    },
    "آوات": {
        "root": "farsi"
    },
    "آوادان": {
        "root": "farsi"
    },
    "آوادخت": {
        "root": "farsi"
    },
    "آوازه": {
        "root": "farsi"
    },
    "آوام": {
        "root": "farsi"
    },
    "آوانوش": {
        "root": "farsi"
    },
    "آوشن": {
        "root": "farsi"
    },
    "آون": {
        "root": "farsi"
    },
    "آویده": {
        "root": "farsi"
    },
    "آویزند": {
        "root": "farsi"
    },
    "آویزه": {
        "root": "farsi"
    },
    "آویسا": {
        "root": "farsi"
    },
    "آویشن": {
        "root": "farsi"
    },
    "آویشه": {
        "root": "farsi"
    },
    "آوین": {
        "root": "farsi"
    },
    "آوینا": {
        "root": "farsi"
    },
    "آهار": {
        "root": "farsi"
    },
    "آهنگ": {
        "root": "farsi"
    },
    "آهو": {
        "root": "farsi"
    },
    "آهید": {
        "root": "farsi"
    },
    "آی": {
        "root": "farsi"
    },
    "آیاوز": {
        "root": "farsi"
    },
    "آیبیبی": {
        "root": "farsi"
    },
    "آیپارا": {
        "root": "farsi"
    },
    "آیپری": {
        "root": "farsi"
    },
    "آیترکیماه": {
        "root": "farsi"
    },
    "آیخانم": {
        "root": "farsi"
    },
    "آیسودا": {
        "root": "farsi"
    },
    "آینشان": {
        "root": "farsi"
    },
    "آیاتای": {
        "root": "farsi"
    },
    "آیتا": {
        "root": "farsi"
    },
    "آیتای": {
        "root": "farsi"
    },
    "آیتک": {
        "root": "farsi"
    },
    "آیتن": {
        "root": "farsi"
    },
    "آیجان": {
        "root": "farsi"
    },
    "آیدا": {
        "root": "farsi"
    },
    "آیدان": {
        "root": "farsi"
    },
    "آیدک": {
        "root": "farsi"
    },
    "آیدن": {
        "root": "farsi"
    },
    "آیدنگ": {
        "root": "farsi"
    },
    "آیرین": {
        "root": "farsi"
    },
    "آیسا": {
        "root": "farsi"
    },
    "آیسان": {
        "root": "farsi"
    },
    "آیسل": {
        "root": "farsi"
    },
    "آیگل": {
        "root": "farsi"
    },
    "آیگوزل": {
        "root": "farsi"
    },
    "آیگین": {
        "root": "farsi"
    },
    "آیلار": {
        "root": "farsi"
    },
    "آیلما": {
        "root": "farsi"
    },
    "آیلی": {
        "root": "farsi"
    },
    "آیلین": {
        "root": "farsi"
    },
    "آیما": {
        "root": "farsi"
    },
    "آینا": {
        "root": "farsi"
    },
    "آیناز": {
        "root": "farsi"
    },
    "آینور": {
        "root": "farsi"
    },
    "آیه": {
        "root": "farsi"
    },
    "آییژ": {
        "root": "farsi"
    },
    "آیین": {
        "root": "farsi"
    },
    "بابان": {
        "root": "farsi"
    },
    "بابوس": {
        "root": "farsi"
    },
    "بابیلان": {
        "root": "farsi"
    },
    "باپیو": {
        "root": "farsi"
    },
    "باتوف": {
        "root": "farsi"
    },
    "باتینک": {
        "root": "farsi"
    },
    "باتینوک": {
        "root": "farsi"
    },
    "بادام": {
        "root": "farsi"
    },
    "بادامک": {
        "root": "farsi"
    },
    "بادر": {
        "root": "farsi"
    },
    "باران": {
        "root": "farsi"
    },
    "بارش": {
        "root": "farsi"
    },
    "بارلی": {
        "root": "farsi"
    },
    "بارنک": {
        "root": "farsi"
    },
    "بارنگ": {
        "root": "farsi"
    },
    "باروشه": {
        "root": "farsi"
    },
    "باریز": {
        "root": "farsi"
    },
    "باریزان": {
        "root": "farsi"
    },
    "بارین": {
        "root": "farsi"
    },
    "بازان": {
        "root": "farsi"
    },
    "بازنه": {
        "root": "farsi"
    },
    "بازو": {
        "root": "farsi"
    },
    "بازور": {
        "root": "farsi"
    },
    "باژوران": {
        "root": "farsi"
    },
    "باژیر": {
        "root": "farsi"
    },
    "باستیان": {
        "root": "farsi"
    },
    "باستینگ": {
        "root": "farsi"
    },
    "باسکار": {
        "root": "farsi"
    },
    "باشن": {
        "root": "farsi"
    },
    "باشیلا": {
        "root": "farsi"
    },
    "باغان": {
        "root": "farsi"
    },
    "بافرین": {
        "root": "farsi"
    },
    "باکوت": {
        "root": "farsi"
    },
    "بالیده": {
        "root": "farsi"
    },
    "بالین": {
        "root": "farsi"
    },
    "بامک": {
        "root": "farsi"
    },
    "بامی": {
        "root": "farsi"
    },
    "بامیک": {
        "root": "farsi"
    },
    "بامین": {
        "root": "farsi"
    },
    "بانو": {
        "root": "farsi"
    },
    "بانواز": {
        "root": "farsi"
    },
    "بانوگشسب": {
        "root": "farsi"
    },
    "باوان": {
        "root": "farsi"
    },
    "باور": {
        "root": "farsi"
    },
    "باوشین": {
        "root": "farsi"
    },
    "باوند": {
        "root": "farsi"
    },
    "باوین": {
        "root": "farsi"
    },
    "بایخ": {
        "root": "farsi"
    },
    "بتسابه": {
        "root": "farsi"
    },
    "بتمان": {
        "root": "farsi"
    },
    "بتول": {
        "root": "farsi"
    },
    "بتین": {
        "root": "farsi"
    },
    "بچکول": {
        "root": "farsi"
    },
    "بختآفرید": {
        "root": "farsi"
    },
    "بختوان": {
        "root": "farsi"
    },
    "بختور": {
        "root": "farsi"
    },
    "بخشین": {
        "root": "farsi"
    },
    "بدری": {
        "root": "farsi"
    },
    "بدنگل": {
        "root": "farsi"
    },
    "بردبار": {
        "root": "farsi"
    },
    "برزآفرید": {
        "root": "farsi"
    },
    "برزی": {
        "root": "farsi"
    },
    "برژان": {
        "root": "farsi"
    },
    "برژانگ": {
        "root": "farsi"
    },
    "برژنگ": {
        "root": "farsi"
    },
    "برژول": {
        "root": "farsi"
    },
    "برسومه": {
        "root": "farsi"
    },
    "برسیل": {
        "root": "farsi"
    },
    "برسین": {
        "root": "farsi"
    },
    "برشید": {
        "root": "farsi"
    },
    "برشیو": {
        "root": "farsi"
    },
    "برفآب": {
        "root": "farsi"
    },
    "برفی": {
        "root": "farsi"
    },
    "برفین": {
        "root": "farsi"
    },
    "برقه": {
        "root": "farsi"
    },
    "برگ": {
        "root": "farsi"
    },
    "برگام": {
        "root": "farsi"
    },
    "برلیان": {
        "root": "farsi"
    },
    "بروفه": {
        "root": "farsi"
    },
    "برهون": {
        "root": "farsi"
    },
    "بریا": {
        "root": "farsi"
    },
    "بریار": {
        "root": "farsi"
    },
    "برینداره": {
        "root": "farsi"
    },
    "بریوان": {
        "root": "farsi"
    },
    "بزان": {
        "root": "farsi"
    },
    "بزین": {
        "root": "farsi"
    },
    "بژدار": {
        "root": "farsi"
    },
    "بژن": {
        "root": "farsi"
    },
    "بژول": {
        "root": "farsi"
    },
    "بژوین": {
        "root": "farsi"
    },
    "بژیو": {
        "root": "farsi"
    },
    "بسمه": {
        "root": "farsi"
    },
    "بشدار": {
        "root": "farsi"
    },
    "بشرا": {
        "root": "farsi"
    },
    "بشری": {
        "root": "farsi"
    },
    "بشکو": {
        "root": "farsi"
    },
    "بفران": {
        "root": "farsi"
    },
    "بفرانبار": {
        "root": "farsi"
    },
    "بلار": {
        "root": "farsi"
    },
    "بلالوک": {
        "root": "farsi"
    },
    "بلقیا": {
        "root": "farsi"
    },
    "بلقیس": {
        "root": "farsi"
    },
    "بلنجه": {
        "root": "farsi"
    },
    "بلواژ": {
        "root": "farsi"
    },
    "بلوت": {
        "root": "farsi"
    },
    "بلور": {
        "root": "farsi"
    },
    "بلورین": {
        "root": "farsi"
    },
    "بلوط": {
        "root": "farsi"
    },
    "بلیسه": {
        "root": "farsi"
    },
    "بلین": {
        "root": "farsi"
    },
    "بمانی": {
        "root": "farsi"
    },
    "بناز": {
        "root": "farsi"
    },
    "بنان": {
        "root": "farsi"
    },
    "بناو": {
        "root": "farsi"
    },
    "بناوان": {
        "root": "farsi"
    },
    "بنرخ": {
        "root": "farsi"
    },
    "بنفش": {
        "root": "farsi"
    },
    "بنفشه": {
        "root": "farsi"
    },
    "بنگین": {
        "root": "farsi"
    },
    "بنن": {
        "root": "farsi"
    },
    "بنیا": {
        "root": "farsi"
    },
    "بنیتا": {
        "root": "farsi"
    },
    "بنین": {
        "root": "farsi"
    },
    "بوبک": {
        "root": "farsi"
    },
    "بوته": {
        "root": "farsi"
    },
    "بوختار": {
        "root": "farsi"
    },
    "بوراندخت": {
        "root": "farsi"
    },
    "بورچین": {
        "root": "farsi"
    },
    "بوژنه": {
        "root": "farsi"
    },
    "بوستان": {
        "root": "farsi"
    },
    "بوسه": {
        "root": "farsi"
    },
    "بوکان": {
        "root": "farsi"
    },
    "بوکبویانی": {
        "root": "farsi"
    },
    "بونخوش": {
        "root": "farsi"
    },
    "بوندار": {
        "root": "farsi"
    },
    "بوین": {
        "root": "farsi"
    },
    "بهآفرید": {
        "root": "farsi"
    },
    "بهآفرین": {
        "root": "farsi"
    },
    "بهآیین": {
        "root": "farsi"
    },
    "بهخاتون": {
        "root": "farsi"
    },
    "بهنگار": {
        "root": "farsi"
    },
    "بهار": {
        "root": "farsi"
    },
    "بهارا": {
        "root": "farsi"
    },
    "بهاران": {
        "root": "farsi"
    },
    "بهارآفرین": {
        "root": "farsi"
    },
    "بهاردخت": {
        "root": "farsi"
    },
    "بهاررخ": {
        "root": "farsi"
    },
    "بهارک": {
        "root": "farsi"
    },
    "بهارناز": {
        "root": "farsi"
    },
    "بهاره": {
        "root": "farsi"
    },
    "بهارین": {
        "root": "farsi"
    },
    "بهامین": {
        "root": "farsi"
    },
    "بهانه": {
        "root": "farsi"
    },
    "بهاور": {
        "root": "farsi"
    },
    "بهتا": {
        "root": "farsi"
    },
    "بهدخت": {
        "root": "farsi"
    },
    "بهدیس": {
        "root": "farsi"
    },
    "بهرامه": {
        "root": "farsi"
    },
    "بهرانه": {
        "root": "farsi"
    },
    "بهرخ": {
        "root": "farsi"
    },
    "بهرو": {
        "root": "farsi"
    },
    "بهروزه": {
        "root": "farsi"
    },
    "بهسا": {
        "root": "farsi"
    },
    "بهشت": {
        "root": "farsi"
    },
    "بهشته": {
        "root": "farsi"
    },
    "بهشید": {
        "root": "farsi"
    },
    "بهکامه": {
        "root": "farsi"
    },
    "بهگل": {
        "root": "farsi"
    },
    "بهمندخت": {
        "root": "farsi"
    },
    "بهناز": {
        "root": "farsi"
    },
    "بهنواز": {
        "root": "farsi"
    },
    "بهنوش": {
        "root": "farsi"
    },
    "بهی": {
        "root": "farsi"
    },
    "بهین": {
        "root": "farsi"
    },
    "بهینبانو": {
        "root": "farsi"
    },
    "بهیندخت": {
        "root": "farsi"
    },
    "بهینه": {
        "root": "farsi"
    },
    "بیبیگل": {
        "root": "farsi"
    },
    "بیبیماه": {
        "root": "farsi"
    },
    "بیبیناز": {
        "root": "farsi"
    },
    "بیتوش": {
        "root": "farsi"
    },
    "بیخال": {
        "root": "farsi"
    },
    "بیخم": {
        "root": "farsi"
    },
    "بینظیر": {
        "root": "farsi"
    },
    "بیوینه": {
        "root": "farsi"
    },
    "بیان": {
        "root": "farsi"
    },
    "بیانه": {
        "root": "farsi"
    },
    "بیبون": {
        "root": "farsi"
    },
    "بیتا": {
        "root": "farsi"
    },
    "بیچم": {
        "root": "farsi"
    },
    "بیدخت": {
        "root": "farsi"
    },
    "بیدگل": {
        "root": "farsi"
    },
    "بیرون": {
        "root": "farsi"
    },
    "بیری": {
        "root": "farsi"
    },
    "بیریفان": {
        "root": "farsi"
    },
    "بیژه": {
        "root": "farsi"
    },
    "بیسان": {
        "root": "farsi"
    },
    "بیستان": {
        "root": "farsi"
    },
    "بیسو": {
        "root": "farsi"
    },
    "بیشو": {
        "root": "farsi"
    },
    "بیکژ": {
        "root": "farsi"
    },
    "بیکن": {
        "root": "farsi"
    },
    "بیگرد": {
        "root": "farsi"
    },
    "بیگم": {
        "root": "farsi"
    },
    "بیلو": {
        "root": "farsi"
    },
    "بینا": {
        "root": "farsi"
    },
    "بینور": {
        "root": "farsi"
    },
    "بینیار": {
        "root": "farsi"
    },
    "بیور": {
        "root": "farsi"
    },
    "بیوی": {
        "root": "farsi"
    },
    "پرشاد": {
        "root": "farsi"
    },
    "پاپوک": {
        "root": "farsi"
    },
    "پادمیرا": {
        "root": "farsi"
    },
    "پادنا": {
        "root": "farsi"
    },
    "پادینا": {
        "root": "farsi"
    },
    "پارامیدا": {
        "root": "farsi"
    },
    "پاردیس": {
        "root": "farsi"
    },
    "پارلا": {
        "root": "farsi"
    },
    "پارلار": {
        "root": "farsi"
    },
    "پارمیدا": {
        "root": "farsi"
    },
    "پارمیس": {
        "root": "farsi"
    },
    "پارمین": {
        "root": "farsi"
    },
    "پارنا": {
        "root": "farsi"
    },
    "پارند": {
        "root": "farsi"
    },
    "پاشنگ": {
        "root": "farsi"
    },
    "پاکآفرین": {
        "root": "farsi"
    },
    "پاکرخ": {
        "root": "farsi"
    },
    "پاکسیما": {
        "root": "farsi"
    },
    "پاکگوهر": {
        "root": "farsi"
    },
    "پاکبانو": {
        "root": "farsi"
    },
    "پاکچهر": {
        "root": "farsi"
    },
    "پاکدخت": {
        "root": "farsi"
    },
    "پاکدل": {
        "root": "farsi"
    },
    "پاکروز": {
        "root": "farsi"
    },
    "پاکروی": {
        "root": "farsi"
    },
    "پاکفر": {
        "root": "farsi"
    },
    "پاکناز": {
        "root": "farsi"
    },
    "پاکنوش": {
        "root": "farsi"
    },
    "پاکیزه": {
        "root": "farsi"
    },
    "پامچال": {
        "root": "farsi"
    },
    "پانته": {
        "root": "farsi"
    },
    "پانتهآ": {
        "root": "farsi"
    },
    "پانتی": {
        "root": "farsi"
    },
    "پانی": {
        "root": "farsi"
    },
    "پانیا": {
        "root": "farsi"
    },
    "پانیذ": {
        "root": "farsi"
    },
    "پانیسا": {
        "root": "farsi"
    },
    "پانیک": {
        "root": "farsi"
    },
    "پایون": {
        "root": "farsi"
    },
    "پاییز": {
        "root": "farsi"
    },
    "پاییزان": {
        "root": "farsi"
    },
    "پدیده": {
        "root": "farsi"
    },
    "پرارین": {
        "root": "farsi"
    },
    "پراریندخت": {
        "root": "farsi"
    },
    "پربها": {
        "root": "farsi"
    },
    "پرتو": {
        "root": "farsi"
    },
    "پرخیده": {
        "root": "farsi"
    },
    "پردخت": {
        "root": "farsi"
    },
    "پردیز": {
        "root": "farsi"
    },
    "پردیس": {
        "root": "farsi"
    },
    "پرزاد": {
        "root": "farsi"
    },
    "پرزین": {
        "root": "farsi"
    },
    "پرسا": {
        "root": "farsi"
    },
    "پرستش": {
        "root": "farsi"
    },
    "پرستک": {
        "root": "farsi"
    },
    "پرستو": {
        "root": "farsi"
    },
    "پرستوک": {
        "root": "farsi"
    },
    "پرسون": {
        "root": "farsi"
    },
    "پرسیا": {
        "root": "farsi"
    },
    "پرشت": {
        "root": "farsi"
    },
    "پرشنگ": {
        "root": "farsi"
    },
    "پرک": {
        "root": "farsi"
    },
    "پرگام": {
        "root": "farsi"
    },
    "پرگان": {
        "root": "farsi"
    },
    "پرگشا": {
        "root": "farsi"
    },
    "پرگل": {
        "root": "farsi"
    },
    "پرگون": {
        "root": "farsi"
    },
    "پرمون": {
        "root": "farsi"
    },
    "پرمیس": {
        "root": "farsi"
    },
    "پرن": {
        "root": "farsi"
    },
    "پرنا": {
        "root": "farsi"
    },
    "پرناز": {
        "root": "farsi"
    },
    "پرناک": {
        "root": "farsi"
    },
    "پرند": {
        "root": "farsi"
    },
    "پرندخت": {
        "root": "farsi"
    },
    "پرنددخت": {
        "root": "farsi"
    },
    "پرنددیس": {
        "root": "farsi"
    },
    "پرندک": {
        "root": "farsi"
    },
    "پرندوش": {
        "root": "farsi"
    },
    "پرندین": {
        "root": "farsi"
    },
    "پرنسا": {
        "root": "farsi"
    },
    "پرنوش": {
        "root": "farsi"
    },
    "پرنون": {
        "root": "farsi"
    },
    "پرنیا": {
        "root": "farsi"
    },
    "پرنیان": {
        "root": "farsi"
    },
    "پرنین": {
        "root": "farsi"
    },
    "پرو": {
        "root": "farsi"
    },
    "پروا": {
        "root": "farsi"
    },
    "پروانه": {
        "root": "farsi"
    },
    "پروچستا": {
        "root": "farsi"
    },
    "پروچیستا": {
        "root": "farsi"
    },
    "پرور": {
        "root": "farsi"
    },
    "پروش": {
        "root": "farsi"
    },
    "پروشات": {
        "root": "farsi"
    },
    "پروین": {
        "root": "farsi"
    },
    "پری": {
        "root": "farsi"
    },
    "پریبانو": {
        "root": "farsi"
    },
    "پریپیکر": {
        "root": "farsi"
    },
    "پریتاج": {
        "root": "farsi"
    },
    "پریجان": {
        "root": "farsi"
    },
    "پریدخت": {
        "root": "farsi"
    },
    "پریرو": {
        "root": "farsi"
    },
    "پریروی": {
        "root": "farsi"
    },
    "پریسیما": {
        "root": "farsi"
    },
    "پریگل": {
        "root": "farsi"
    },
    "پریویس": {
        "root": "farsi"
    },
    "پریا": {
        "root": "farsi"
    },
    "پریاس": {
        "root": "farsi"
    },
    "پریان": {
        "root": "farsi"
    },
    "پریچه": {
        "root": "farsi"
    },
    "پریچهر": {
        "root": "farsi"
    },
    "پریچهره": {
        "root": "farsi"
    },
    "پریرخ": {
        "root": "farsi"
    },
    "پریزاد": {
        "root": "farsi"
    },
    "پریزاده": {
        "root": "farsi"
    },
    "پریژه": {
        "root": "farsi"
    },
    "پریسا": {
        "root": "farsi"
    },
    "پریسان": {
        "root": "farsi"
    },
    "پریشا": {
        "root": "farsi"
    },
    "پریفام": {
        "root": "farsi"
    },
    "پریفر": {
        "root": "farsi"
    },
    "پریگون": {
        "root": "farsi"
    },
    "پریماه": {
        "root": "farsi"
    },
    "پریمرز": {
        "root": "farsi"
    },
    "پرین": {
        "root": "farsi"
    },
    "پریناز": {
        "root": "farsi"
    },
    "پرینام": {
        "root": "farsi"
    },
    "پرینوش": {
        "root": "farsi"
    },
    "پریوش": {
        "root": "farsi"
    },
    "پژال": {
        "root": "farsi"
    },
    "پسته": {
        "root": "farsi"
    },
    "پگاه": {
        "root": "farsi"
    },
    "پوپک": {
        "root": "farsi"
    },
    "پوپه": {
        "root": "farsi"
    },
    "پودینه": {
        "root": "farsi"
    },
    "پوران": {
        "root": "farsi"
    },
    "پوراندخت": {
        "root": "farsi"
    },
    "پورچیستا": {
        "root": "farsi"
    },
    "پوروچیستا": {
        "root": "farsi"
    },
    "پوری": {
        "root": "farsi"
    },
    "پولک": {
        "root": "farsi"
    },
    "پونا": {
        "root": "farsi"
    },
    "پونه": {
        "root": "farsi"
    },
    "پیچک": {
        "root": "farsi"
    },
    "پیدرا": {
        "root": "farsi"
    },
    "پیراسته": {
        "root": "farsi"
    },
    "پیرایه": {
        "root": "farsi"
    },
    "پیروزدخت": {
        "root": "farsi"
    },
    "پیمانه": {
        "root": "farsi"
    },
    "پینار": {
        "root": "farsi"
    },
    "پیوند": {
        "root": "farsi"
    },
    "ترنم": {
        "root": "farsi"
    },
    "تندر": {
        "root": "farsi"
    },
    "ترنج": {
        "root": "farsi"
    },
    "تهرت": {
        "root": "farsi"
    },
    "تیتک": {
        "root": "farsi"
    },
    "تابان": {
        "root": "farsi"
    },
    "تابانچهر": {
        "root": "farsi"
    },
    "تاباندخت": {
        "root": "farsi"
    },
    "تابانرخ": {
        "root": "farsi"
    },
    "تابانگل": {
        "root": "farsi"
    },
    "تابانروی": {
        "root": "farsi"
    },
    "تابانمهر": {
        "root": "farsi"
    },
    "تابش": {
        "root": "farsi"
    },
    "تابناک": {
        "root": "farsi"
    },
    "تابنده": {
        "root": "farsi"
    },
    "تابیتا": {
        "root": "farsi"
    },
    "تاپیک": {
        "root": "farsi"
    },
    "تاتیانا": {
        "root": "farsi"
    },
    "تاتینا": {
        "root": "farsi"
    },
    "تاجالزمان": {
        "root": "farsi"
    },
    "تاجالملک": {
        "root": "farsi"
    },
    "تاجالملوک": {
        "root": "farsi"
    },
    "تاجآفرین": {
        "root": "farsi"
    },
    "تاجبانو": {
        "root": "farsi"
    },
    "تاجبیبی": {
        "root": "farsi"
    },
    "تاجخاتون": {
        "root": "farsi"
    },
    "تاجدخت": {
        "root": "farsi"
    },
    "تاجگل": {
        "root": "farsi"
    },
    "تاجماه": {
        "root": "farsi"
    },
    "تاجمهر": {
        "root": "farsi"
    },
    "تارا": {
        "root": "farsi"
    },
    "تارادخت": {
        "root": "farsi"
    },
    "تارادیس": {
        "root": "farsi"
    },
    "تارلا": {
        "root": "farsi"
    },
    "تارمیتا": {
        "root": "farsi"
    },
    "تازه": {
        "root": "farsi"
    },
    "تافته": {
        "root": "farsi"
    },
    "تاکآفرین": {
        "root": "farsi"
    },
    "تاکدخت": {
        "root": "farsi"
    },
    "تالیا": {
        "root": "farsi"
    },
    "تامارا": {
        "root": "farsi"
    },
    "تامیلا": {
        "root": "farsi"
    },
    "تامیما": {
        "root": "farsi"
    },
    "تانسو": {
        "root": "farsi"
    },
    "تانیا": {
        "root": "farsi"
    },
    "تبسم": {
        "root": "farsi"
    },
    "تتسگل": {
        "root": "farsi"
    },
    "تحفه": {
        "root": "farsi"
    },
    "تحفهگل": {
        "root": "farsi"
    },
    "تخشک": {
        "root": "farsi"
    },
    "تذرو": {
        "root": "farsi"
    },
    "ترانه": {
        "root": "farsi"
    },
    "ترسا": {
        "root": "farsi"
    },
    "ترکان": {
        "root": "farsi"
    },
    "ترگل": {
        "root": "farsi"
    },
    "ترلان": {
        "root": "farsi"
    },
    "ترمه": {
        "root": "farsi"
    },
    "ترنگ": {
        "root": "farsi"
    },
    "ترنیان": {
        "root": "farsi"
    },
    "تروند": {
        "root": "farsi"
    },
    "تریتی": {
        "root": "farsi"
    },
    "تسنیم": {
        "root": "farsi"
    },
    "تشتر": {
        "root": "farsi"
    },
    "تکبانو": {
        "root": "farsi"
    },
    "تکاو": {
        "root": "farsi"
    },
    "تکتم": {
        "root": "farsi"
    },
    "تلکا": {
        "root": "farsi"
    },
    "تلما": {
        "root": "farsi"
    },
    "تلناز": {
        "root": "farsi"
    },
    "تمنا": {
        "root": "farsi"
    },
    "تمیس": {
        "root": "farsi"
    },
    "تناز": {
        "root": "farsi"
    },
    "تنبور": {
        "root": "farsi"
    },
    "تندیس": {
        "root": "farsi"
    },
    "تنی": {
        "root": "farsi"
    },
    "تنینار": {
        "root": "farsi"
    },
    "توتیا": {
        "root": "farsi"
    },
    "توراکینا": {
        "root": "farsi"
    },
    "توران": {
        "root": "farsi"
    },
    "تورانبانو": {
        "root": "farsi"
    },
    "توراندخت": {
        "root": "farsi"
    },
    "توری": {
        "root": "farsi"
    },
    "توسا": {
        "root": "farsi"
    },
    "توشنامئیتی": {
        "root": "farsi"
    },
    "توفان": {
        "root": "farsi"
    },
    "توکا": {
        "root": "farsi"
    },
    "تهمینه": {
        "root": "farsi"
    },
    "تیتی": {
        "root": "farsi"
    },
    "تیتیسا": {
        "root": "farsi"
    },
    "تیتیگل": {
        "root": "farsi"
    },
    "تیتینار": {
        "root": "farsi"
    },
    "تیارا": {
        "root": "farsi"
    },
    "تیبا": {
        "root": "farsi"
    },
    "تیدآ": {
        "root": "farsi"
    },
    "تیراژه": {
        "root": "farsi"
    },
    "تیزهوش": {
        "root": "farsi"
    },
    "تیسا": {
        "root": "farsi"
    },
    "تیساگل": {
        "root": "farsi"
    },
    "تیساناز": {
        "root": "farsi"
    },
    "تینا": {
        "root": "farsi"
    },
    "تیناب": {
        "root": "farsi"
    },
    "تینوش": {
        "root": "farsi"
    },
    "تیهو": {
        "root": "farsi"
    },
    "ثریا": {
        "root": "farsi"
    },
    "ثمره": {
        "root": "farsi"
    },
    "ثمینا": {
        "root": "farsi"
    },
    "ثمینه": {
        "root": "farsi"
    },
    "ثنا": {
        "root": "farsi"
    },
    "جاسمین": {
        "root": "farsi"
    },
    "جام": {
        "root": "farsi"
    },
    "جانآرام": {
        "root": "farsi"
    },
    "جاننواز": {
        "root": "farsi"
    },
    "جانا": {
        "root": "farsi"
    },
    "جانام": {
        "root": "farsi"
    },
    "جانانه": {
        "root": "farsi"
    },
    "جانبانو": {
        "root": "farsi"
    },
    "جاندخت": {
        "root": "farsi"
    },
    "جانمهر": {
        "root": "farsi"
    },
    "جریره": {
        "root": "farsi"
    },
    "جلوه": {
        "root": "farsi"
    },
    "جمدخت": {
        "root": "farsi"
    },
    "جمیله": {
        "root": "farsi"
    },
    "جنان": {
        "root": "farsi"
    },
    "جنت": {
        "root": "farsi"
    },
    "جوانه": {
        "root": "farsi"
    },
    "جواهر": {
        "root": "farsi"
    },
    "جوهر": {
        "root": "farsi"
    },
    "جهانافروز": {
        "root": "farsi"
    },
    "جهانآذر": {
        "root": "farsi"
    },
    "جهانآسا": {
        "root": "farsi"
    },
    "جهانآوا": {
        "root": "farsi"
    },
    "جهانبانو": {
        "root": "farsi"
    },
    "جهانخاتون": {
        "root": "farsi"
    },
    "جهانماه": {
        "root": "farsi"
    },
    "جهانتاب": {
        "root": "farsi"
    },
    "جهاندخت": {
        "root": "farsi"
    },
    "جهانرخ": {
        "root": "farsi"
    },
    "جیحون": {
        "root": "farsi"
    },
    "جیران": {
        "root": "farsi"
    },
    "جیلا": {
        "root": "farsi"
    },
    "چمان": {
        "root": "farsi"
    },
    "چالی": {
        "root": "farsi"
    },
    "چام": {
        "root": "farsi"
    },
    "چامه": {
        "root": "farsi"
    },
    "چرمه": {
        "root": "farsi"
    },
    "چشمه": {
        "root": "farsi"
    },
    "چکاو": {
        "root": "farsi"
    },
    "چکاوک": {
        "root": "farsi"
    },
    "چکاوه": {
        "root": "farsi"
    },
    "چلچله": {
        "root": "farsi"
    },
    "چمانه": {
        "root": "farsi"
    },
    "چمن": {
        "root": "farsi"
    },
    "چمنافروز": {
        "root": "farsi"
    },
    "چمنآرا": {
        "root": "farsi"
    },
    "چمنچهر": {
        "root": "farsi"
    },
    "چوک": {
        "root": "farsi"
    },
    "چهراب": {
        "root": "farsi"
    },
    "چهرافروز": {
        "root": "farsi"
    },
    "چهرآرا": {
        "root": "farsi"
    },
    "چهرزاد": {
        "root": "farsi"
    },
    "چهرفروز": {
        "root": "farsi"
    },
    "چهرک": {
        "root": "farsi"
    },
    "چهرمینو": {
        "root": "farsi"
    },
    "چهره": {
        "root": "farsi"
    },
    "چهرهگل": {
        "root": "farsi"
    },
    "چهلچراغ": {
        "root": "farsi"
    },
    "چیترا": {
        "root": "farsi"
    },
    "چیچک": {
        "root": "farsi"
    },
    "چیستا": {
        "root": "farsi"
    },
    "چیستی": {
        "root": "farsi"
    },
    "چیکا": {
        "root": "farsi"
    },
    "چیلانه": {
        "root": "farsi"
    },
    "حارثه": {
        "root": "farsi"
    },
    "حامده": {
        "root": "farsi"
    },
    "حانیه": {
        "root": "farsi"
    },
    "حبیبه": {
        "root": "farsi"
    },
    "حدیث": {
        "root": "farsi"
    },
    "حدیثه": {
        "root": "farsi"
    },
    "حدیقه": {
        "root": "farsi"
    },
    "حرمت": {
        "root": "farsi"
    },
    "حره": {
        "root": "farsi"
    },
    "حریر": {
        "root": "farsi"
    },
    "حسانه": {
        "root": "farsi"
    },
    "حسنا": {
        "root": "farsi"
    },
    "حسنی": {
        "root": "farsi"
    },
    "حسیبا": {
        "root": "farsi"
    },
    "حسینیه": {
        "root": "farsi"
    },
    "حفصه": {
        "root": "farsi"
    },
    "حکیمه": {
        "root": "farsi"
    },
    "حلما": {
        "root": "farsi"
    },
    "حلیا": {
        "root": "farsi"
    },
    "حلیمه": {
        "root": "farsi"
    },
    "حلیه": {
        "root": "farsi"
    },
    "حماسه": {
        "root": "farsi"
    },
    "حمرا": {
        "root": "farsi"
    },
    "حمراه": {
        "root": "farsi"
    },
    "حمیده": {
        "root": "farsi"
    },
    "حمیرا": {
        "root": "farsi"
    },
    "حنا": {
        "root": "farsi"
    },
    "حنانه": {
        "root": "farsi"
    },
    "حنیفه": {
        "root": "farsi"
    },
    "حوا": {
        "root": "farsi"
    },
    "حور": {
        "root": "farsi"
    },
    "حورا": {
        "root": "farsi"
    },
    "حورآسا": {
        "root": "farsi"
    },
    "حورآفرین": {
        "root": "farsi"
    },
    "حورجهان": {
        "root": "farsi"
    },
    "حوردیس": {
        "root": "farsi"
    },
    "حوررخ": {
        "root": "farsi"
    },
    "حورزاد": {
        "root": "farsi"
    },
    "حوروش": {
        "root": "farsi"
    },
    "حوری": {
        "root": "farsi"
    },
    "حوریبانو": {
        "root": "farsi"
    },
    "حوریدخت": {
        "root": "farsi"
    },
    "حوریرخ": {
        "root": "farsi"
    },
    "حوریزاد": {
        "root": "farsi"
    },
    "حوریلقا": {
        "root": "farsi"
    },
    "حوریا": {
        "root": "farsi"
    },
    "حوریه": {
        "root": "farsi"
    },
    "حیات": {
        "root": "farsi"
    },
    "حیفا": {
        "root": "farsi"
    },
    "خوروش": {
        "root": "farsi"
    },
    "خاتون": {
        "root": "farsi"
    },
    "خاتونک": {
        "root": "farsi"
    },
    "خارا": {
        "root": "farsi"
    },
    "خارک": {
        "root": "farsi"
    },
    "خاره": {
        "root": "farsi"
    },
    "خاشعه": {
        "root": "farsi"
    },
    "خاطرافروز": {
        "root": "farsi"
    },
    "خاطرآسا": {
        "root": "farsi"
    },
    "خاطرنواز": {
        "root": "farsi"
    },
    "خاطره": {
        "root": "farsi"
    },
    "خالده": {
        "root": "farsi"
    },
    "خالواش": {
        "root": "farsi"
    },
    "خانم": {
        "root": "farsi"
    },
    "خانمگل": {
        "root": "farsi"
    },
    "خانوم": {
        "root": "farsi"
    },
    "خاور": {
        "root": "farsi"
    },
    "ختا": {
        "root": "farsi"
    },
    "ختمی": {
        "root": "farsi"
    },
    "ختن": {
        "root": "farsi"
    },
    "خجسته": {
        "root": "farsi"
    },
    "خجستهلقا": {
        "root": "farsi"
    },
    "خجیر": {
        "root": "farsi"
    },
    "خدانظر": {
        "root": "farsi"
    },
    "خدیجه": {
        "root": "farsi"
    },
    "خرام": {
        "root": "farsi"
    },
    "خرامان": {
        "root": "farsi"
    },
    "خرشا": {
        "root": "farsi"
    },
    "خرمبانو": {
        "root": "farsi"
    },
    "خرمبهار": {
        "root": "farsi"
    },
    "خرمچهر": {
        "root": "farsi"
    },
    "خرمگل": {
        "root": "farsi"
    },
    "خرمدخت": {
        "root": "farsi"
    },
    "خرمدل": {
        "root": "farsi"
    },
    "خرمن": {
        "root": "farsi"
    },
    "خرمناز": {
        "root": "farsi"
    },
    "خرمه": {
        "root": "farsi"
    },
    "خزان": {
        "root": "farsi"
    },
    "خزر": {
        "root": "farsi"
    },
    "خضرا": {
        "root": "farsi"
    },
    "خندانچهر": {
        "root": "farsi"
    },
    "خندانگل": {
        "root": "farsi"
    },
    "خوبچهر": {
        "root": "farsi"
    },
    "خوبرخ": {
        "root": "farsi"
    },
    "خوبروی": {
        "root": "farsi"
    },
    "خوبیار": {
        "root": "farsi"
    },
    "خوتکا": {
        "root": "farsi"
    },
    "خوردخت": {
        "root": "farsi"
    },
    "خوردیس": {
        "root": "farsi"
    },
    "خورشاد": {
        "root": "farsi"
    },
    "خورشید": {
        "root": "farsi"
    },
    "خورشیدچهر": {
        "root": "farsi"
    },
    "خورشیدبانو": {
        "root": "farsi"
    },
    "خورشیددخت": {
        "root": "farsi"
    },
    "خورشیدرخ": {
        "root": "farsi"
    },
    "خورشیدفر": {
        "root": "farsi"
    },
    "خورشیدمهر": {
        "root": "farsi"
    },
    "خوشلقا": {
        "root": "farsi"
    },
    "خوشاب": {
        "root": "farsi"
    },
    "خوشبوی": {
        "root": "farsi"
    },
    "خوشچهر": {
        "root": "farsi"
    },
    "خوشخو": {
        "root": "farsi"
    },
    "خوشدل": {
        "root": "farsi"
    },
    "خوشروی": {
        "root": "farsi"
    },
    "خوشگو": {
        "root": "farsi"
    },
    "خوشنوا": {
        "root": "farsi"
    },
    "خوشه": {
        "root": "farsi"
    },
    "خوشین": {
        "root": "farsi"
    },
    "خیرالنسا": {
        "root": "farsi"
    },
    "خیزران": {
        "root": "farsi"
    },
    "دستنبو": {
        "root": "farsi"
    },
    "دخمل": {
        "root": "farsi"
    },
    "درافشان": {
        "root": "farsi"
    },
    "دردانه": {
        "root": "farsi"
    },
    "درنا": {
        "root": "farsi"
    },
    "دغدو": {
        "root": "farsi"
    },
    "درمنه": {
        "root": "farsi"
    },
    "دادآفرید": {
        "root": "farsi"
    },
    "دادآفرین": {
        "root": "farsi"
    },
    "دادلی": {
        "root": "farsi"
    },
    "دارینا": {
        "root": "farsi"
    },
    "دارینه": {
        "root": "farsi"
    },
    "دالیا": {
        "root": "farsi"
    },
    "داماسپیا": {
        "root": "farsi"
    },
    "دامینه": {
        "root": "farsi"
    },
    "دانژه": {
        "root": "farsi"
    },
    "دانیا": {
        "root": "farsi"
    },
    "دایانا": {
        "root": "farsi"
    },
    "دختمهر": {
        "root": "farsi"
    },
    "درا": {
        "root": "farsi"
    },
    "دراج": {
        "root": "farsi"
    },
    "دربانو": {
        "root": "farsi"
    },
    "دربها": {
        "root": "farsi"
    },
    "درةالتاج": {
        "root": "farsi"
    },
    "درتا": {
        "root": "farsi"
    },
    "درخشا": {
        "root": "farsi"
    },
    "درخشان": {
        "root": "farsi"
    },
    "درسا": {
        "root": "farsi"
    },
    "درستی": {
        "root": "farsi"
    },
    "درفام": {
        "root": "farsi"
    },
    "درفشان": {
        "root": "farsi"
    },
    "درگل": {
        "root": "farsi"
    },
    "درمان": {
        "root": "farsi"
    },
    "درناز": {
        "root": "farsi"
    },
    "دروار": {
        "root": "farsi"
    },
    "دره": {
        "root": "farsi"
    },
    "دری": {
        "root": "farsi"
    },
    "دریا": {
        "root": "farsi"
    },
    "دریادخت": {
        "root": "farsi"
    },
    "دریاناز": {
        "root": "farsi"
    },
    "دریتا": {
        "root": "farsi"
    },
    "درین": {
        "root": "farsi"
    },
    "دلافروز": {
        "root": "farsi"
    },
    "دلانگیز": {
        "root": "farsi"
    },
    "دلآرا": {
        "root": "farsi"
    },
    "دلآرام": {
        "root": "farsi"
    },
    "دلآسا": {
        "root": "farsi"
    },
    "دلآشوب": {
        "root": "farsi"
    },
    "دلآویز": {
        "root": "farsi"
    },
    "دلبهار": {
        "root": "farsi"
    },
    "دلارا": {
        "root": "farsi"
    },
    "دلارام": {
        "root": "farsi"
    },
    "دلاویز": {
        "root": "farsi"
    },
    "دلبان": {
        "root": "farsi"
    },
    "دلبر": {
        "root": "farsi"
    },
    "دلپذیر": {
        "root": "farsi"
    },
    "دلپرور": {
        "root": "farsi"
    },
    "دلپسند": {
        "root": "farsi"
    },
    "دلجو": {
        "root": "farsi"
    },
    "دلخوش": {
        "root": "farsi"
    },
    "دلدار": {
        "root": "farsi"
    },
    "دلربای": {
        "root": "farsi"
    },
    "دلستان": {
        "root": "farsi"
    },
    "دلفروز": {
        "root": "farsi"
    },
    "دلکش": {
        "root": "farsi"
    },
    "دلگرم": {
        "root": "farsi"
    },
    "دلگشا": {
        "root": "farsi"
    },
    "دلگون": {
        "root": "farsi"
    },
    "دلناز": {
        "root": "farsi"
    },
    "دلنواز": {
        "root": "farsi"
    },
    "دلنوش": {
        "root": "farsi"
    },
    "دلنیا": {
        "root": "farsi"
    },
    "دلوار": {
        "root": "farsi"
    },
    "دلووان": {
        "root": "farsi"
    },
    "دلیار": {
        "root": "farsi"
    },
    "دلیله": {
        "root": "farsi"
    },
    "دلینا": {
        "root": "farsi"
    },
    "دمساز": {
        "root": "farsi"
    },
    "دمن": {
        "root": "farsi"
    },
    "دنا": {
        "root": "farsi"
    },
    "دنبره": {
        "root": "farsi"
    },
    "دنیا": {
        "root": "farsi"
    },
    "دنیز": {
        "root": "farsi"
    },
    "دورسین": {
        "root": "farsi"
    },
    "دهما": {
        "root": "farsi"
    },
    "دیان": {
        "root": "farsi"
    },
    "دیانا": {
        "root": "farsi"
    },
    "دیبا": {
        "root": "farsi"
    },
    "دیبارخ": {
        "root": "farsi"
    },
    "دیدار": {
        "root": "farsi"
    },
    "دیلان": {
        "root": "farsi"
    },
    "دینا": {
        "root": "farsi"
    },
    "دینارگیس": {
        "root": "farsi"
    },
    "دیناز": {
        "root": "farsi"
    },
    "دینه": {
        "root": "farsi"
    },
    "ذکیه": {
        "root": "farsi"
    },
    "رسابانو": {
        "root": "farsi"
    },
    "رسادخت": {
        "root": "farsi"
    },
    "ردگون": {
        "root": "farsi"
    },
    "رکسانا": {
        "root": "farsi"
    },
    "رابعه": {
        "root": "farsi"
    },
    "رابو": {
        "root": "farsi"
    },
    "رابیا": {
        "root": "farsi"
    },
    "راتا": {
        "root": "farsi"
    },
    "راحل": {
        "root": "farsi"
    },
    "راحله": {
        "root": "farsi"
    },
    "راحیل": {
        "root": "farsi"
    },
    "رادا": {
        "root": "farsi"
    },
    "راددخت": {
        "root": "farsi"
    },
    "راز": {
        "root": "farsi"
    },
    "رازان": {
        "root": "farsi"
    },
    "رازقی": {
        "root": "farsi"
    },
    "رازک": {
        "root": "farsi"
    },
    "رازمهر": {
        "root": "farsi"
    },
    "رازیانه": {
        "root": "farsi"
    },
    "راشل": {
        "root": "farsi"
    },
    "راضیه": {
        "root": "farsi"
    },
    "رافع": {
        "root": "farsi"
    },
    "رافعه": {
        "root": "farsi"
    },
    "رافونه": {
        "root": "farsi"
    },
    "رامافزا": {
        "root": "farsi"
    },
    "رامافزون": {
        "root": "farsi"
    },
    "رامبانو": {
        "root": "farsi"
    },
    "رامدخت": {
        "root": "farsi"
    },
    "رامسینا": {
        "root": "farsi"
    },
    "رامش": {
        "root": "farsi"
    },
    "رامشین": {
        "root": "farsi"
    },
    "رامک": {
        "root": "farsi"
    },
    "رامونا": {
        "root": "farsi"
    },
    "رامیلا": {
        "root": "farsi"
    },
    "رامینا": {
        "root": "farsi"
    },
    "رامینه": {
        "root": "farsi"
    },
    "رانیا": {
        "root": "farsi"
    },
    "راوش": {
        "root": "farsi"
    },
    "راوک": {
        "root": "farsi"
    },
    "راویز": {
        "root": "farsi"
    },
    "راویس": {
        "root": "farsi"
    },
    "راهین": {
        "root": "farsi"
    },
    "رایحه": {
        "root": "farsi"
    },
    "رایومند": {
        "root": "farsi"
    },
    "رائیک": {
        "root": "farsi"
    },
    "رائیکا": {
        "root": "farsi"
    },
    "رأفت": {
        "root": "farsi"
    },
    "رباب": {
        "root": "farsi"
    },
    "ربابه": {
        "root": "farsi"
    },
    "ربیعه": {
        "root": "farsi"
    },
    "رتاج": {
        "root": "farsi"
    },
    "رحمه": {
        "root": "farsi"
    },
    "رحیمه": {
        "root": "farsi"
    },
    "رخافروز": {
        "root": "farsi"
    },
    "رخامین": {
        "root": "farsi"
    },
    "رخسار": {
        "root": "farsi"
    },
    "رخساره": {
        "root": "farsi"
    },
    "رخسانا": {
        "root": "farsi"
    },
    "رخشا": {
        "root": "farsi"
    },
    "رخشاد": {
        "root": "farsi"
    },
    "رخشانه": {
        "root": "farsi"
    },
    "رخشنده": {
        "root": "farsi"
    },
    "رخشید": {
        "root": "farsi"
    },
    "رخشیده": {
        "root": "farsi"
    },
    "رخک": {
        "root": "farsi"
    },
    "رخنا": {
        "root": "farsi"
    },
    "رخنار": {
        "root": "farsi"
    },
    "ردا": {
        "root": "farsi"
    },
    "ردیمه": {
        "root": "farsi"
    },
    "رز": {
        "root": "farsi"
    },
    "رزا": {
        "root": "farsi"
    },
    "رزالین": {
        "root": "farsi"
    },
    "رزان": {
        "root": "farsi"
    },
    "رزمین": {
        "root": "farsi"
    },
    "رزیتا": {
        "root": "farsi"
    },
    "رزیندخت": {
        "root": "farsi"
    },
    "رزینا": {
        "root": "farsi"
    },
    "رژان": {
        "root": "farsi"
    },
    "رسپینا": {
        "root": "farsi"
    },
    "رستا": {
        "root": "farsi"
    },
    "رستاک": {
        "root": "farsi"
    },
    "رضوان": {
        "root": "farsi"
    },
    "رضوانه": {
        "root": "farsi"
    },
    "رضیه": {
        "root": "farsi"
    },
    "رعنا": {
        "root": "farsi"
    },
    "رفیعه": {
        "root": "farsi"
    },
    "رقیه": {
        "root": "farsi"
    },
    "رکسانه": {
        "root": "farsi"
    },
    "رمان": {
        "root": "farsi"
    },
    "رمانه": {
        "root": "farsi"
    },
    "رمیصا": {
        "root": "farsi"
    },
    "روان": {
        "root": "farsi"
    },
    "روبینا": {
        "root": "farsi"
    },
    "روجا": {
        "root": "farsi"
    },
    "روحانگیز": {
        "root": "farsi"
    },
    "روحبخش": {
        "root": "farsi"
    },
    "رودابه": {
        "root": "farsi"
    },
    "روزافزون": {
        "root": "farsi"
    },
    "روزانا": {
        "root": "farsi"
    },
    "روزیتا": {
        "root": "farsi"
    },
    "روژ": {
        "root": "farsi"
    },
    "روژا": {
        "root": "farsi"
    },
    "روژان": {
        "root": "farsi"
    },
    "روژانو": {
        "root": "farsi"
    },
    "روژدا": {
        "root": "farsi"
    },
    "روژیا": {
        "root": "farsi"
    },
    "روژیار": {
        "root": "farsi"
    },
    "روژین": {
        "root": "farsi"
    },
    "روژینا": {
        "root": "farsi"
    },
    "روژییار": {
        "root": "farsi"
    },
    "روسانا": {
        "root": "farsi"
    },
    "روشا": {
        "root": "farsi"
    },
    "روشان": {
        "root": "farsi"
    },
    "روشن": {
        "root": "farsi"
    },
    "روشنچهر": {
        "root": "farsi"
    },
    "روشنرخ": {
        "root": "farsi"
    },
    "روشنمهر": {
        "root": "farsi"
    },
    "روشنا": {
        "root": "farsi"
    },
    "روشنک": {
        "root": "farsi"
    },
    "رومیسا": {
        "root": "farsi"
    },
    "رومینا": {
        "root": "farsi"
    },
    "روناک": {
        "root": "farsi"
    },
    "رونیا": {
        "root": "farsi"
    },
    "رونیکا": {
        "root": "farsi"
    },
    "رویا": {
        "root": "farsi"
    },
    "رها": {
        "root": "farsi"
    },
    "رؤیا": {
        "root": "farsi"
    },
    "ریتا": {
        "root": "farsi"
    },
    "ریجینا": {
        "root": "farsi"
    },
    "ریحان": {
        "root": "farsi"
    },
    "ریحانه": {
        "root": "farsi"
    },
    "ریرا": {
        "root": "farsi"
    },
    "ریکا": {
        "root": "farsi"
    },
    "ریما": {
        "root": "farsi"
    },
    "ریواس": {
        "root": "farsi"
    },
    "زمرد": {
        "root": "farsi"
    },
    "زادمهر": {
        "root": "farsi"
    },
    "زاکیه": {
        "root": "farsi"
    },
    "زامیر": {
        "root": "farsi"
    },
    "زاهده": {
        "root": "farsi"
    },
    "زبیده": {
        "root": "farsi"
    },
    "زرافشان": {
        "root": "farsi"
    },
    "زراندام": {
        "root": "farsi"
    },
    "زربانو": {
        "root": "farsi"
    },
    "زربین": {
        "root": "farsi"
    },
    "زرپری": {
        "root": "farsi"
    },
    "زرتا": {
        "root": "farsi"
    },
    "زرتاج": {
        "root": "farsi"
    },
    "زرخاتون": {
        "root": "farsi"
    },
    "زردخت": {
        "root": "farsi"
    },
    "زردیس": {
        "root": "farsi"
    },
    "زرستان": {
        "root": "farsi"
    },
    "زرشام": {
        "root": "farsi"
    },
    "زرکا": {
        "root": "farsi"
    },
    "زرگل": {
        "root": "farsi"
    },
    "زرگیس": {
        "root": "farsi"
    },
    "زرگیسو": {
        "root": "farsi"
    },
    "زرمان": {
        "root": "farsi"
    },
    "زرناز": {
        "root": "farsi"
    },
    "زرنگار": {
        "root": "farsi"
    },
    "زرنگیس": {
        "root": "farsi"
    },
    "زرنوش": {
        "root": "farsi"
    },
    "زرواندخت": {
        "root": "farsi"
    },
    "زری": {
        "root": "farsi"
    },
    "زرین": {
        "root": "farsi"
    },
    "زرینبانو": {
        "root": "farsi"
    },
    "زرینچهر": {
        "root": "farsi"
    },
    "زریندخت": {
        "root": "farsi"
    },
    "زرینگل": {
        "root": "farsi"
    },
    "زرینگیس": {
        "root": "farsi"
    },
    "زرینمهر": {
        "root": "farsi"
    },
    "زریننرگسه": {
        "root": "farsi"
    },
    "زریننگار": {
        "root": "farsi"
    },
    "زرینهمای": {
        "root": "farsi"
    },
    "زرینهور": {
        "root": "farsi"
    },
    "زرینه": {
        "root": "farsi"
    },
    "زعفران": {
        "root": "farsi"
    },
    "زکیه": {
        "root": "farsi"
    },
    "زگما": {
        "root": "farsi"
    },
    "زلال": {
        "root": "farsi"
    },
    "زمانه": {
        "root": "farsi"
    },
    "زمزم": {
        "root": "farsi"
    },
    "زمزمه": {
        "root": "farsi"
    },
    "زنبق": {
        "root": "farsi"
    },
    "زوفا": {
        "root": "farsi"
    },
    "زویا": {
        "root": "farsi"
    },
    "زهرا": {
        "root": "farsi"
    },
    "زهراناز": {
        "root": "farsi"
    },
    "زهره": {
        "root": "farsi"
    },
    "زهیرا": {
        "root": "farsi"
    },
    "زیبالنسا": {
        "root": "farsi"
    },
    "زیبا": {
        "root": "farsi"
    },
    "زیبادخت": {
        "root": "farsi"
    },
    "زیباچهر": {
        "root": "farsi"
    },
    "زیبارخ": {
        "root": "farsi"
    },
    "زیباروی": {
        "root": "farsi"
    },
    "زیبان": {
        "root": "farsi"
    },
    "زیبنده": {
        "root": "farsi"
    },
    "زیتون": {
        "root": "farsi"
    },
    "زیتونخاتون": {
        "root": "farsi"
    },
    "زیتونه": {
        "root": "farsi"
    },
    "زیرجد": {
        "root": "farsi"
    },
    "زینا": {
        "root": "farsi"
    },
    "زینب": {
        "root": "farsi"
    },
    "زینت": {
        "root": "farsi"
    },
    "زیوا": {
        "root": "farsi"
    },
    "زیور": {
        "root": "farsi"
    },
    "زیورتاج": {
        "root": "farsi"
    },
    "زیوین": {
        "root": "farsi"
    },
    "زییده": {
        "root": "farsi"
    },
    "ژاسمن": {
        "root": "farsi"
    },
    "ژاسمین": {
        "root": "farsi"
    },
    "ژاکلین": {
        "root": "farsi"
    },
    "ژالانه": {
        "root": "farsi"
    },
    "ژاله": {
        "root": "farsi"
    },
    "ژالین": {
        "root": "farsi"
    },
    "ژامک": {
        "root": "farsi"
    },
    "ژانت": {
        "root": "farsi"
    },
    "ژانیا": {
        "root": "farsi"
    },
    "ژانیتا": {
        "root": "farsi"
    },
    "ژانین": {
        "root": "farsi"
    },
    "ژانینا": {
        "root": "farsi"
    },
    "ژاوا": {
        "root": "farsi"
    },
    "ژاوه": {
        "root": "farsi"
    },
    "ژاییژ": {
        "root": "farsi"
    },
    "ژربرا": {
        "root": "farsi"
    },
    "ژرفا": {
        "root": "farsi"
    },
    "ژرفی": {
        "root": "farsi"
    },
    "ژرفین": {
        "root": "farsi"
    },
    "ژرویرا": {
        "root": "farsi"
    },
    "ژنیا": {
        "root": "farsi"
    },
    "ژنیک": {
        "root": "farsi"
    },
    "ژوان": {
        "root": "farsi"
    },
    "ژون": {
        "root": "farsi"
    },
    "ژیانچهر": {
        "root": "farsi"
    },
    "ژیاندخت": {
        "root": "farsi"
    },
    "ژیژیس": {
        "root": "farsi"
    },
    "ژیکان": {
        "root": "farsi"
    },
    "ژیلا": {
        "root": "farsi"
    },
    "ژینا": {
        "root": "farsi"
    },
    "ژینو": {
        "root": "farsi"
    },
    "ژینوس": {
        "root": "farsi"
    },
    "ژیوار": {
        "root": "farsi"
    },
    "ستوش": {
        "root": "farsi"
    },
    "سرور": {
        "root": "farsi"
    },
    "سابرینا": {
        "root": "farsi"
    },
    "سابود": {
        "root": "farsi"
    },
    "ساتراپ": {
        "root": "farsi"
    },
    "ساتی": {
        "root": "farsi"
    },
    "ساتیا": {
        "root": "farsi"
    },
    "ساتین": {
        "root": "farsi"
    },
    "ساجده": {
        "root": "farsi"
    },
    "ساحر": {
        "root": "farsi"
    },
    "ساحره": {
        "root": "farsi"
    },
    "ساحل": {
        "root": "farsi"
    },
    "سارا": {
        "root": "farsi"
    },
    "سارال": {
        "root": "farsi"
    },
    "سارالماز": {
        "root": "farsi"
    },
    "سارای": {
        "root": "farsi"
    },
    "سارگل": {
        "root": "farsi"
    },
    "سارنیا": {
        "root": "farsi"
    },
    "ساره": {
        "root": "farsi"
    },
    "ساریان": {
        "root": "farsi"
    },
    "ساریسا": {
        "root": "farsi"
    },
    "سارینا": {
        "root": "farsi"
    },
    "سارینه": {
        "root": "farsi"
    },
    "سازک": {
        "root": "farsi"
    },
    "سازین": {
        "root": "farsi"
    },
    "ساطعه": {
        "root": "farsi"
    },
    "ساعده": {
        "root": "farsi"
    },
    "ساغر": {
        "root": "farsi"
    },
    "ساقی": {
        "root": "farsi"
    },
    "سالسا": {
        "root": "farsi"
    },
    "سالمه": {
        "root": "farsi"
    },
    "سالومه": {
        "root": "farsi"
    },
    "سالی": {
        "root": "farsi"
    },
    "سامره": {
        "root": "farsi"
    },
    "سامه": {
        "root": "farsi"
    },
    "سامیرا": {
        "root": "farsi"
    },
    "سامینا": {
        "root": "farsi"
    },
    "سامینه": {
        "root": "farsi"
    },
    "سامیه": {
        "root": "farsi"
    },
    "سانآی": {
        "root": "farsi"
    },
    "ساناز": {
        "root": "farsi"
    },
    "سانای": {
        "root": "farsi"
    },
    "سانلی": {
        "root": "farsi"
    },
    "سانوا": {
        "root": "farsi"
    },
    "سانیا": {
        "root": "farsi"
    },
    "ساورینا": {
        "root": "farsi"
    },
    "ساوند": {
        "root": "farsi"
    },
    "ساویز": {
        "root": "farsi"
    },
    "ساویس": {
        "root": "farsi"
    },
    "ساوین": {
        "root": "farsi"
    },
    "ساهره": {
        "root": "farsi"
    },
    "سایا": {
        "root": "farsi"
    },
    "سایان": {
        "root": "farsi"
    },
    "سایره": {
        "root": "farsi"
    },
    "سایمان": {
        "root": "farsi"
    },
    "ساینا": {
        "root": "farsi"
    },
    "ساینه": {
        "root": "farsi"
    },
    "سایه": {
        "root": "farsi"
    },
    "سبا": {
        "root": "farsi"
    },
    "سبارو": {
        "root": "farsi"
    },
    "سبزارنگ": {
        "root": "farsi"
    },
    "سبزبهار": {
        "root": "farsi"
    },
    "سبزپری": {
        "root": "farsi"
    },
    "سبزک": {
        "root": "farsi"
    },
    "سبزه": {
        "root": "farsi"
    },
    "سبزهبهار": {
        "root": "farsi"
    },
    "سبزهقبا": {
        "root": "farsi"
    },
    "سبزینه": {
        "root": "farsi"
    },
    "سپاکو": {
        "root": "farsi"
    },
    "سپتا": {
        "root": "farsi"
    },
    "سپیتا": {
        "root": "farsi"
    },
    "سپیته": {
        "root": "farsi"
    },
    "سپیده": {
        "root": "farsi"
    },
    "سپیدهگل": {
        "root": "farsi"
    },
    "سپینود": {
        "root": "farsi"
    },
    "ستاتیرا": {
        "root": "farsi"
    },
    "ستاره": {
        "root": "farsi"
    },
    "ستاک": {
        "root": "farsi"
    },
    "ستایش": {
        "root": "farsi"
    },
    "ستوده": {
        "root": "farsi"
    },
    "ستی": {
        "root": "farsi"
    },
    "ستیا": {
        "root": "farsi"
    },
    "سحر": {
        "root": "farsi"
    },
    "سحرناز": {
        "root": "farsi"
    },
    "سحرنوش": {
        "root": "farsi"
    },
    "سدا": {
        "root": "farsi"
    },
    "سداب": {
        "root": "farsi"
    },
    "سدن": {
        "root": "farsi"
    },
    "سدنا": {
        "root": "farsi"
    },
    "سرایه": {
        "root": "farsi"
    },
    "سرآویز": {
        "root": "farsi"
    },
    "سرخوسفید": {
        "root": "farsi"
    },
    "سرگل": {
        "root": "farsi"
    },
    "سرمه": {
        "root": "farsi"
    },
    "سرنا": {
        "root": "farsi"
    },
    "سرو": {
        "root": "farsi"
    },
    "سروآزاد": {
        "root": "farsi"
    },
    "سروبن": {
        "root": "farsi"
    },
    "سروتن": {
        "root": "farsi"
    },
    "سروجهان": {
        "root": "farsi"
    },
    "سروشا": {
        "root": "farsi"
    },
    "سروگل": {
        "root": "farsi"
    },
    "سروناز": {
        "root": "farsi"
    },
    "سروین": {
        "root": "farsi"
    },
    "سریرا": {
        "root": "farsi"
    },
    "سعیده": {
        "root": "farsi"
    },
    "سکینه": {
        "root": "farsi"
    },
    "سلاله": {
        "root": "farsi"
    },
    "سلدا": {
        "root": "farsi"
    },
    "سلطنت": {
        "root": "farsi"
    },
    "سلما": {
        "root": "farsi"
    },
    "سلمه": {
        "root": "farsi"
    },
    "سلمی": {
        "root": "farsi"
    },
    "سلنا": {
        "root": "farsi"
    },
    "سلوی": {
        "root": "farsi"
    },
    "سلیمه": {
        "root": "farsi"
    },
    "سلینا": {
        "root": "farsi"
    },
    "سما": {
        "root": "farsi"
    },
    "سمانه": {
        "root": "farsi"
    },
    "سمر": {
        "root": "farsi"
    },
    "سمن": {
        "root": "farsi"
    },
    "سمناندام": {
        "root": "farsi"
    },
    "سمنبر": {
        "root": "farsi"
    },
    "سمنپیکر": {
        "root": "farsi"
    },
    "سمنچهر": {
        "root": "farsi"
    },
    "سمنچهره": {
        "root": "farsi"
    },
    "سمندیس": {
        "root": "farsi"
    },
    "سمنرخ": {
        "root": "farsi"
    },
    "سمنرو": {
        "root": "farsi"
    },
    "سمنسیما": {
        "root": "farsi"
    },
    "سمنگل": {
        "root": "farsi"
    },
    "سمنناز": {
        "root": "farsi"
    },
    "سمنزار": {
        "root": "farsi"
    },
    "سمنوی": {
        "root": "farsi"
    },
    "سمیرا": {
        "root": "farsi"
    },
    "سمیرامیس": {
        "root": "farsi"
    },
    "سمین": {
        "root": "farsi"
    },
    "سمینه": {
        "root": "farsi"
    },
    "سمیه": {
        "root": "farsi"
    },
    "سنا": {
        "root": "farsi"
    },
    "سنبل": {
        "root": "farsi"
    },
    "سندس": {
        "root": "farsi"
    },
    "سندوس": {
        "root": "farsi"
    },
    "سنیا": {
        "root": "farsi"
    },
    "سوتیام": {
        "root": "farsi"
    },
    "سودا": {
        "root": "farsi"
    },
    "سودابه": {
        "root": "farsi"
    },
    "سوده": {
        "root": "farsi"
    },
    "سوره": {
        "root": "farsi"
    },
    "سوری": {
        "root": "farsi"
    },
    "سوریا": {
        "root": "farsi"
    },
    "سوزان": {
        "root": "farsi"
    },
    "سوژا": {
        "root": "farsi"
    },
    "سوسا": {
        "root": "farsi"
    },
    "سوسن": {
        "root": "farsi"
    },
    "سوسنک": {
        "root": "farsi"
    },
    "سوفی": {
        "root": "farsi"
    },
    "سوفیا": {
        "root": "farsi"
    },
    "سوگل": {
        "root": "farsi"
    },
    "سوگلی": {
        "root": "farsi"
    },
    "سوگند": {
        "root": "farsi"
    },
    "سولاف": {
        "root": "farsi"
    },
    "سولماز": {
        "root": "farsi"
    },
    "سولینا": {
        "root": "farsi"
    },
    "سومیا": {
        "root": "farsi"
    },
    "سومیتا": {
        "root": "farsi"
    },
    "سومینا": {
        "root": "farsi"
    },
    "سونا": {
        "root": "farsi"
    },
    "سونای": {
        "root": "farsi"
    },
    "سونیا": {
        "root": "farsi"
    },
    "سویل": {
        "root": "farsi"
    },
    "سویلآی": {
        "root": "farsi"
    },
    "سوین": {
        "root": "farsi"
    },
    "سوینچ": {
        "root": "farsi"
    },
    "سهی": {
        "root": "farsi"
    },
    "سهیزاد": {
        "root": "farsi"
    },
    "سهیلا": {
        "root": "farsi"
    },
    "سیبل": {
        "root": "farsi"
    },
    "سیسام": {
        "root": "farsi"
    },
    "سیسی": {
        "root": "farsi"
    },
    "سیسیکام": {
        "root": "farsi"
    },
    "سیگل": {
        "root": "farsi"
    },
    "سیبگل": {
        "root": "farsi"
    },
    "سیتا": {
        "root": "farsi"
    },
    "سیران": {
        "root": "farsi"
    },
    "سیرانوش": {
        "root": "farsi"
    },
    "سیرنگ": {
        "root": "farsi"
    },
    "سیفور": {
        "root": "farsi"
    },
    "سیلوانا": {
        "root": "farsi"
    },
    "سیمتن": {
        "root": "farsi"
    },
    "سیما": {
        "root": "farsi"
    },
    "سیمبر": {
        "root": "farsi"
    },
    "سیمرخ": {
        "root": "farsi"
    },
    "سیمروی": {
        "root": "farsi"
    },
    "سیمگون": {
        "root": "farsi"
    },
    "سیمیا": {
        "root": "farsi"
    },
    "سیمین": {
        "root": "farsi"
    },
    "سیمینتن": {
        "root": "farsi"
    },
    "سیمینچهر": {
        "root": "farsi"
    },
    "سیمیندخت": {
        "root": "farsi"
    },
    "سیمینرخ": {
        "root": "farsi"
    },
    "سیمینه": {
        "root": "farsi"
    },
    "سیندخت": {
        "root": "farsi"
    },
    "سینره": {
        "root": "farsi"
    },
    "شاپرک": {
        "root": "farsi"
    },
    "شاپری": {
        "root": "farsi"
    },
    "شاخشمشاد": {
        "root": "farsi"
    },
    "شاخنبات": {
        "root": "farsi"
    },
    "شاخسار": {
        "root": "farsi"
    },
    "شاداب": {
        "root": "farsi"
    },
    "شادان": {
        "root": "farsi"
    },
    "شادانبانو": {
        "root": "farsi"
    },
    "شادانه": {
        "root": "farsi"
    },
    "شادآفرید": {
        "root": "farsi"
    },
    "شادبانو": {
        "root": "farsi"
    },
    "شادبهر": {
        "root": "farsi"
    },
    "شادپری": {
        "root": "farsi"
    },
    "شادخاتون": {
        "root": "farsi"
    },
    "شاددخت": {
        "root": "farsi"
    },
    "شاددل": {
        "root": "farsi"
    },
    "شادرخ": {
        "root": "farsi"
    },
    "شادرو": {
        "root": "farsi"
    },
    "شادروز": {
        "root": "farsi"
    },
    "شادروی": {
        "root": "farsi"
    },
    "شادفر": {
        "root": "farsi"
    },
    "شادک": {
        "root": "farsi"
    },
    "شادکام": {
        "root": "farsi"
    },
    "شادکامه": {
        "root": "farsi"
    },
    "شادگل": {
        "root": "farsi"
    },
    "شادگون": {
        "root": "farsi"
    },
    "شادلین": {
        "root": "farsi"
    },
    "شادمان": {
        "root": "farsi"
    },
    "شادمانه": {
        "root": "farsi"
    },
    "شادناز": {
        "root": "farsi"
    },
    "شادنوش": {
        "root": "farsi"
    },
    "شادور": {
        "root": "farsi"
    },
    "شادی": {
        "root": "farsi"
    },
    "شادیافزا": {
        "root": "farsi"
    },
    "شادیآور": {
        "root": "farsi"
    },
    "شادیا": {
        "root": "farsi"
    },
    "شادیان": {
        "root": "farsi"
    },
    "شادیانه": {
        "root": "farsi"
    },
    "شاران": {
        "root": "farsi"
    },
    "شارک": {
        "root": "farsi"
    },
    "شارمین": {
        "root": "farsi"
    },
    "شارمینا": {
        "root": "farsi"
    },
    "شاریس": {
        "root": "farsi"
    },
    "شارین": {
        "root": "farsi"
    },
    "شارینا": {
        "root": "farsi"
    },
    "شاسپرم": {
        "root": "farsi"
    },
    "شالیزار": {
        "root": "farsi"
    },
    "شامان": {
        "root": "farsi"
    },
    "شامیرام": {
        "root": "farsi"
    },
    "شانا": {
        "root": "farsi"
    },
    "شانو": {
        "root": "farsi"
    },
    "شاهاسپرم": {
        "root": "farsi"
    },
    "شاهآذر": {
        "root": "farsi"
    },
    "شاهآفرید": {
        "root": "farsi"
    },
    "شاهبانگ": {
        "root": "farsi"
    },
    "شاهپرک": {
        "root": "farsi"
    },
    "شاهپرند": {
        "root": "farsi"
    },
    "شاهپری": {
        "root": "farsi"
    },
    "شاهپسند": {
        "root": "farsi"
    },
    "شاهپونه": {
        "root": "farsi"
    },
    "شاهجهان": {
        "root": "farsi"
    },
    "شاهخاتون": {
        "root": "farsi"
    },
    "شاهصنم": {
        "root": "farsi"
    },
    "شاهفرید": {
        "root": "farsi"
    },
    "شاهناز": {
        "root": "farsi"
    },
    "شاهبانو": {
        "root": "farsi"
    },
    "شاهجان": {
        "root": "farsi"
    },
    "شاهدانه": {
        "root": "farsi"
    },
    "شاهدخت": {
        "root": "farsi"
    },
    "شاهرو": {
        "root": "farsi"
    },
    "شاهفرند": {
        "root": "farsi"
    },
    "شاهگل": {
        "root": "farsi"
    },
    "شاهیده": {
        "root": "farsi"
    },
    "شایا": {
        "root": "farsi"
    },
    "شایاندخت": {
        "root": "farsi"
    },
    "شایسته": {
        "root": "farsi"
    },
    "شایلی": {
        "root": "farsi"
    },
    "شاین": {
        "root": "farsi"
    },
    "شبافروز": {
        "root": "farsi"
    },
    "شبآرا": {
        "root": "farsi"
    },
    "شببو": {
        "root": "farsi"
    },
    "شبپره": {
        "root": "farsi"
    },
    "شبدخت": {
        "root": "farsi"
    },
    "شبناز": {
        "root": "farsi"
    },
    "شباهنگ": {
        "root": "farsi"
    },
    "شبدیس": {
        "root": "farsi"
    },
    "شبگون": {
        "root": "farsi"
    },
    "شبنم": {
        "root": "farsi"
    },
    "شراره": {
        "root": "farsi"
    },
    "شرافت": {
        "root": "farsi"
    },
    "شرمیلا": {
        "root": "farsi"
    },
    "شرمین": {
        "root": "farsi"
    },
    "شرمیندخت": {
        "root": "farsi"
    },
    "شرمینه": {
        "root": "farsi"
    },
    "شروانه": {
        "root": "farsi"
    },
    "شری": {
        "root": "farsi"
    },
    "شرین": {
        "root": "farsi"
    },
    "شعری": {
        "root": "farsi"
    },
    "شعله": {
        "root": "farsi"
    },
    "شفق": {
        "root": "farsi"
    },
    "شفیعه": {
        "root": "farsi"
    },
    "شفیقه": {
        "root": "farsi"
    },
    "شقاقل": {
        "root": "farsi"
    },
    "شقایق": {
        "root": "farsi"
    },
    "شکال": {
        "root": "farsi"
    },
    "شکر": {
        "root": "farsi"
    },
    "شکربانو": {
        "root": "farsi"
    },
    "شکردخت": {
        "root": "farsi"
    },
    "شکرناز": {
        "root": "farsi"
    },
    "شکرین": {
        "root": "farsi"
    },
    "شکفته": {
        "root": "farsi"
    },
    "شکوفا": {
        "root": "farsi"
    },
    "شکوفه": {
        "root": "farsi"
    },
    "شکوه": {
        "root": "farsi"
    },
    "شکوهدخت": {
        "root": "farsi"
    },
    "شکوهناز": {
        "root": "farsi"
    },
    "شکوهنده": {
        "root": "farsi"
    },
    "شکوهه": {
        "root": "farsi"
    },
    "شکیبا": {
        "root": "farsi"
    },
    "شکیبه": {
        "root": "farsi"
    },
    "شکیلا": {
        "root": "farsi"
    },
    "شگون": {
        "root": "farsi"
    },
    "شلاله": {
        "root": "farsi"
    },
    "شلیر": {
        "root": "farsi"
    },
    "شمایل": {
        "root": "farsi"
    },
    "شمسالملوک": {
        "root": "farsi"
    },
    "شمسایران": {
        "root": "farsi"
    },
    "شمسا": {
        "root": "farsi"
    },
    "شمسی": {
        "root": "farsi"
    },
    "شمشاد": {
        "root": "farsi"
    },
    "شمه": {
        "root": "farsi"
    },
    "شمیرا": {
        "root": "farsi"
    },
    "شمیس": {
        "root": "farsi"
    },
    "شمیسا": {
        "root": "farsi"
    },
    "شمیسه": {
        "root": "farsi"
    },
    "شمیلا": {
        "root": "farsi"
    },
    "شمیم": {
        "root": "farsi"
    },
    "شمیمه": {
        "root": "farsi"
    },
    "شناز": {
        "root": "farsi"
    },
    "شناسا": {
        "root": "farsi"
    },
    "شنایا": {
        "root": "farsi"
    },
    "شنبلید": {
        "root": "farsi"
    },
    "شوانه": {
        "root": "farsi"
    },
    "شوخشنگ": {
        "root": "farsi"
    },
    "شود": {
        "root": "farsi"
    },
    "شورانگیز": {
        "root": "farsi"
    },
    "شورآفرین": {
        "root": "farsi"
    },
    "شوشا": {
        "root": "farsi"
    },
    "شوقانگیز": {
        "root": "farsi"
    },
    "شوکا": {
        "root": "farsi"
    },
    "شوکت": {
        "root": "farsi"
    },
    "شهبانو": {
        "root": "farsi"
    },
    "شهپر": {
        "root": "farsi"
    },
    "شهدخت": {
        "root": "farsi"
    },
    "شهددخت": {
        "root": "farsi"
    },
    "شهدیس": {
        "root": "farsi"
    },
    "شهراز": {
        "root": "farsi"
    },
    "شهرآرا": {
        "root": "farsi"
    },
    "شهربانو": {
        "root": "farsi"
    },
    "شهردخت": {
        "root": "farsi"
    },
    "شهرزاد": {
        "root": "farsi"
    },
    "شهرگل": {
        "root": "farsi"
    },
    "شهرناز": {
        "root": "farsi"
    },
    "شهرنواز": {
        "root": "farsi"
    },
    "شهرویه": {
        "root": "farsi"
    },
    "شهره": {
        "root": "farsi"
    },
    "شهزاد": {
        "root": "farsi"
    },
    "شهزاده": {
        "root": "farsi"
    },
    "شهگل": {
        "root": "farsi"
    },
    "شهلا": {
        "root": "farsi"
    },
    "شهناز": {
        "root": "farsi"
    },
    "شهنواز": {
        "root": "farsi"
    },
    "شهیره": {
        "root": "farsi"
    },
    "شهین": {
        "root": "farsi"
    },
    "شهینبانو": {
        "root": "farsi"
    },
    "شیبا": {
        "root": "farsi"
    },
    "شیدا": {
        "root": "farsi"
    },
    "شیدبانو": {
        "root": "farsi"
    },
    "شیدخت": {
        "root": "farsi"
    },
    "شیددخت": {
        "root": "farsi"
    },
    "شیدر": {
        "root": "farsi"
    },
    "شیدرخ": {
        "root": "farsi"
    },
    "شیده": {
        "root": "farsi"
    },
    "شیرات": {
        "root": "farsi"
    },
    "شیرزن": {
        "root": "farsi"
    },
    "شیرگل": {
        "root": "farsi"
    },
    "شیرین": {
        "root": "farsi"
    },
    "شیرینبانو": {
        "root": "farsi"
    },
    "شیرینجهان": {
        "root": "farsi"
    },
    "شیریندخت": {
        "root": "farsi"
    },
    "شیرینگل": {
        "root": "farsi"
    },
    "شیفته": {
        "root": "farsi"
    },
    "شیلا": {
        "root": "farsi"
    },
    "شیلان": {
        "root": "farsi"
    },
    "شیلر": {
        "root": "farsi"
    },
    "شیما": {
        "root": "farsi"
    },
    "شینا": {
        "root": "farsi"
    },
    "شیناب": {
        "root": "farsi"
    },
    "شیناز": {
        "root": "farsi"
    },
    "شیوا": {
        "root": "farsi"
    },
    "صاباحگل": {
        "root": "farsi"
    },
    "صابره": {
        "root": "farsi"
    },
    "صابرین": {
        "root": "farsi"
    },
    "صادقه": {
        "root": "farsi"
    },
    "صالحه": {
        "root": "farsi"
    },
    "صبا": {
        "root": "farsi"
    },
    "صباحت": {
        "root": "farsi"
    },
    "صبحآسا": {
        "root": "farsi"
    },
    "صبحجبین": {
        "root": "farsi"
    },
    "صبحچهر": {
        "root": "farsi"
    },
    "صبحچهره": {
        "root": "farsi"
    },
    "صبرا": {
        "root": "farsi"
    },
    "صبرناز": {
        "root": "farsi"
    },
    "صبرینه": {
        "root": "farsi"
    },
    "صبریه": {
        "root": "farsi"
    },
    "صحرا": {
        "root": "farsi"
    },
    "صحو": {
        "root": "farsi"
    },
    "صدا": {
        "root": "farsi"
    },
    "صدپر": {
        "root": "farsi"
    },
    "صدف": {
        "root": "farsi"
    },
    "صدیقه": {
        "root": "farsi"
    },
    "صغری": {
        "root": "farsi"
    },
    "صفاناز": {
        "root": "farsi"
    },
    "صفورا": {
        "root": "farsi"
    },
    "صفیه": {
        "root": "farsi"
    },
    "صنم": {
        "root": "farsi"
    },
    "صنمدخت": {
        "root": "farsi"
    },
    "صنمرو": {
        "root": "farsi"
    },
    "صنمگل": {
        "root": "farsi"
    },
    "صنمناز": {
        "root": "farsi"
    },
    "صنوبر": {
        "root": "farsi"
    },
    "صوفیا": {
        "root": "farsi"
    },
    "صونا": {
        "root": "farsi"
    },
    "صهبا": {
        "root": "farsi"
    },
    "ضحی": {
        "root": "farsi"
    },
    "ضرغامه": {
        "root": "farsi"
    },
    "طاوس": {
        "root": "farsi"
    },
    "طاووس": {
        "root": "farsi"
    },
    "طاهره": {
        "root": "farsi"
    },
    "طراوت": {
        "root": "farsi"
    },
    "طربانگیز": {
        "root": "farsi"
    },
    "طربآرا": {
        "root": "farsi"
    },
    "طرفه": {
        "root": "farsi"
    },
    "طرلان": {
        "root": "farsi"
    },
    "طره": {
        "root": "farsi"
    },
    "طرهخاتون": {
        "root": "farsi"
    },
    "طغاترکان": {
        "root": "farsi"
    },
    "طلا": {
        "root": "farsi"
    },
    "طلاسان": {
        "root": "farsi"
    },
    "طلاگون": {
        "root": "farsi"
    },
    "طلاناز": {
        "root": "farsi"
    },
    "طلایه": {
        "root": "farsi"
    },
    "طلعت": {
        "root": "farsi"
    },
    "طلوع": {
        "root": "farsi"
    },
    "طلیعه": {
        "root": "farsi"
    },
    "طناز": {
        "root": "farsi"
    },
    "طنان": {
        "root": "farsi"
    },
    "طنین": {
        "root": "farsi"
    },
    "طوبی": {
        "root": "farsi"
    },
    "طوطی": {
        "root": "farsi"
    },
    "طوطیا": {
        "root": "farsi"
    },
    "طهورا": {
        "root": "farsi"
    },
    "طیبه": {
        "root": "farsi"
    },
    "طیلا": {
        "root": "farsi"
    },
    "ظریفه": {
        "root": "farsi"
    },
    "ظفردخت": {
        "root": "farsi"
    },
    "ظهیره": {
        "root": "farsi"
    },
    "عابده": {
        "root": "farsi"
    },
    "عاتکه": {
        "root": "farsi"
    },
    "عادله": {
        "root": "farsi"
    },
    "عادیات": {
        "root": "farsi"
    },
    "عارفه": {
        "root": "farsi"
    },
    "عاصفه": {
        "root": "farsi"
    },
    "عاطفه": {
        "root": "farsi"
    },
    "عاقله": {
        "root": "farsi"
    },
    "عالم": {
        "root": "farsi"
    },
    "عالمتاج": {
        "root": "farsi"
    },
    "عالمه": {
        "root": "farsi"
    },
    "عالیه": {
        "root": "farsi"
    },
    "عامره": {
        "root": "farsi"
    },
    "عایشه": {
        "root": "farsi"
    },
    "عجبنوش": {
        "root": "farsi"
    },
    "عذرا": {
        "root": "farsi"
    },
    "عرشیان": {
        "root": "farsi"
    },
    "عرفانه": {
        "root": "farsi"
    },
    "عزالنسا": {
        "root": "farsi"
    },
    "عزتالزمان": {
        "root": "farsi"
    },
    "عزتالسادات": {
        "root": "farsi"
    },
    "عزتالملوک": {
        "root": "farsi"
    },
    "عزتبانو": {
        "root": "farsi"
    },
    "عزتزمان": {
        "root": "farsi"
    },
    "عزتملک": {
        "root": "farsi"
    },
    "عزتنسا": {
        "root": "farsi"
    },
    "عزیر": {
        "root": "farsi"
    },
    "عزیزه": {
        "root": "farsi"
    },
    "عسل": {
        "root": "farsi"
    },
    "عسلناز": {
        "root": "farsi"
    },
    "عشرت": {
        "root": "farsi"
    },
    "عشرتالملوک": {
        "root": "farsi"
    },
    "عصمت": {
        "root": "farsi"
    },
    "عصمتالملوک": {
        "root": "farsi"
    },
    "عطرسای": {
        "root": "farsi"
    },
    "عطرین": {
        "root": "farsi"
    },
    "عطیةالله": {
        "root": "farsi"
    },
    "عطیه": {
        "root": "farsi"
    },
    "عظیمه": {
        "root": "farsi"
    },
    "عفاف": {
        "root": "farsi"
    },
    "عفت": {
        "root": "farsi"
    },
    "عفیفه": {
        "root": "farsi"
    },
    "عقیق": {
        "root": "farsi"
    },
    "عقیله": {
        "root": "farsi"
    },
    "علویه": {
        "root": "farsi"
    },
    "علیا": {
        "root": "farsi"
    },
    "عنبر": {
        "root": "farsi"
    },
    "عنبربو": {
        "root": "farsi"
    },
    "عنقا": {
        "root": "farsi"
    },
    "عهدیه": {
        "root": "farsi"
    },
    "غانیه": {
        "root": "farsi"
    },
    "غدیره": {
        "root": "farsi"
    },
    "غزال": {
        "root": "farsi"
    },
    "غزاله": {
        "root": "farsi"
    },
    "غزل": {
        "root": "farsi"
    },
    "غزلناز": {
        "root": "farsi"
    },
    "غمزه": {
        "root": "farsi"
    },
    "غنج": {
        "root": "farsi"
    },
    "غنچه": {
        "root": "farsi"
    },
    "غوغا": {
        "root": "farsi"
    },
    "فاتن": {
        "root": "farsi"
    },
    "فاتیما": {
        "root": "farsi"
    },
    "فاخته": {
        "root": "farsi"
    },
    "فارا": {
        "root": "farsi"
    },
    "فارهه": {
        "root": "farsi"
    },
    "فاسیروس": {
        "root": "farsi"
    },
    "فاطمه": {
        "root": "farsi"
    },
    "فاطمهزهرا": {
        "root": "farsi"
    },
    "فاطیما": {
        "root": "farsi"
    },
    "فامگل": {
        "root": "farsi"
    },
    "فانیذ": {
        "root": "farsi"
    },
    "فایحه": {
        "root": "farsi"
    },
    "فایدیم": {
        "root": "farsi"
    },
    "فایضه": {
        "root": "farsi"
    },
    "فایقه": {
        "root": "farsi"
    },
    "فائحه": {
        "root": "farsi"
    },
    "فائزه": {
        "root": "farsi"
    },
    "فائضه": {
        "root": "farsi"
    },
    "فائقه": {
        "root": "farsi"
    },
    "فتانه": {
        "root": "farsi"
    },
    "فتنه": {
        "root": "farsi"
    },
    "فخرالزمان": {
        "root": "farsi"
    },
    "فخرالسادات": {
        "root": "farsi"
    },
    "فخرالملوک": {
        "root": "farsi"
    },
    "فخرایران": {
        "root": "farsi"
    },
    "فخرآفاق": {
        "root": "farsi"
    },
    "فخرجهان": {
        "root": "farsi"
    },
    "فخرگل": {
        "root": "farsi"
    },
    "فخری": {
        "root": "farsi"
    },
    "فخیمه": {
        "root": "farsi"
    },
    "فراتاگون": {
        "root": "farsi"
    },
    "فراچهر": {
        "root": "farsi"
    },
    "فرارنگ": {
        "root": "farsi"
    },
    "فرازنده": {
        "root": "farsi"
    },
    "فرانک": {
        "root": "farsi"
    },
    "فرانه": {
        "root": "farsi"
    },
    "فراهت": {
        "root": "farsi"
    },
    "فرآذر": {
        "root": "farsi"
    },
    "فربو": {
        "root": "farsi"
    },
    "فرپرک": {
        "root": "farsi"
    },
    "فرتوک": {
        "root": "farsi"
    },
    "فرجهان": {
        "root": "farsi"
    },
    "فرح": {
        "root": "farsi"
    },
    "فرحانگیز": {
        "root": "farsi"
    },
    "فرحبانو": {
        "root": "farsi"
    },
    "فرحبخش": {
        "root": "farsi"
    },
    "فرحدخت": {
        "root": "farsi"
    },
    "فرحنوش": {
        "root": "farsi"
    },
    "فرحانه": {
        "root": "farsi"
    },
    "فرحتاج": {
        "root": "farsi"
    },
    "فرحناز": {
        "root": "farsi"
    },
    "فرخبانو": {
        "root": "farsi"
    },
    "فرخبخش": {
        "root": "farsi"
    },
    "فرختاج": {
        "root": "farsi"
    },
    "فرخچهر": {
        "root": "farsi"
    },
    "فرخلقا": {
        "root": "farsi"
    },
    "فرخماه": {
        "root": "farsi"
    },
    "فرخناز": {
        "root": "farsi"
    },
    "فرخروز": {
        "root": "farsi"
    },
    "فرخنده": {
        "root": "farsi"
    },
    "فرخندهچهر": {
        "root": "farsi"
    },
    "فردخت": {
        "root": "farsi"
    },
    "فردیس": {
        "root": "farsi"
    },
    "فرزاندخت": {
        "root": "farsi"
    },
    "فرزانه": {
        "root": "farsi"
    },
    "فرستو": {
        "root": "farsi"
    },
    "فرسیما": {
        "root": "farsi"
    },
    "فرشته": {
        "root": "farsi"
    },
    "فرشیده": {
        "root": "farsi"
    },
    "فرغانه": {
        "root": "farsi"
    },
    "فرگل": {
        "root": "farsi"
    },
    "فرگون": {
        "root": "farsi"
    },
    "فرمهر": {
        "root": "farsi"
    },
    "فرمیسک": {
        "root": "farsi"
    },
    "فرناز": {
        "root": "farsi"
    },
    "فرنگار": {
        "root": "farsi"
    },
    "فرنگیز": {
        "root": "farsi"
    },
    "فرنگیس": {
        "root": "farsi"
    },
    "فرنو": {
        "root": "farsi"
    },
    "فرنواز": {
        "root": "farsi"
    },
    "فرنوش": {
        "root": "farsi"
    },
    "فرنوشا": {
        "root": "farsi"
    },
    "فرنی": {
        "root": "farsi"
    },
    "فرنیا": {
        "root": "farsi"
    },
    "فرنیان": {
        "root": "farsi"
    },
    "فروردین": {
        "root": "farsi"
    },
    "فروز": {
        "root": "farsi"
    },
    "فروزا": {
        "root": "farsi"
    },
    "فروزاتون": {
        "root": "farsi"
    },
    "فروزان": {
        "root": "farsi"
    },
    "فروزجهان": {
        "root": "farsi"
    },
    "فروزش": {
        "root": "farsi"
    },
    "فروزنده": {
        "root": "farsi"
    },
    "فروزینه": {
        "root": "farsi"
    },
    "فروشنک": {
        "root": "farsi"
    },
    "فروغ": {
        "root": "farsi"
    },
    "فروغبانو": {
        "root": "farsi"
    },
    "فروغدخت": {
        "root": "farsi"
    },
    "فروهنده": {
        "root": "farsi"
    },
    "فرهوش": {
        "root": "farsi"
    },
    "فرهت": {
        "root": "farsi"
    },
    "فرهناز": {
        "root": "farsi"
    },
    "فرهور": {
        "root": "farsi"
    },
    "فریار": {
        "root": "farsi"
    },
    "فریال": {
        "root": "farsi"
    },
    "فریانه": {
        "root": "farsi"
    },
    "فریبا": {
        "root": "farsi"
    },
    "فریدخت": {
        "root": "farsi"
    },
    "فریده": {
        "root": "farsi"
    },
    "فریر": {
        "root": "farsi"
    },
    "فریرخ": {
        "root": "farsi"
    },
    "فریرو": {
        "root": "farsi"
    },
    "فریسا": {
        "root": "farsi"
    },
    "فریشا": {
        "root": "farsi"
    },
    "فریضه": {
        "root": "farsi"
    },
    "فریما": {
        "root": "farsi"
    },
    "فریمانه": {
        "root": "farsi"
    },
    "فریماه": {
        "root": "farsi"
    },
    "فرین": {
        "root": "farsi"
    },
    "فریندخت": {
        "root": "farsi"
    },
    "فرینا": {
        "root": "farsi"
    },
    "فریناز": {
        "root": "farsi"
    },
    "فریوش": {
        "root": "farsi"
    },
    "فصیحه": {
        "root": "farsi"
    },
    "فضه": {
        "root": "farsi"
    },
    "فضیلت": {
        "root": "farsi"
    },
    "فغان": {
        "root": "farsi"
    },
    "فغستان": {
        "root": "farsi"
    },
    "فلامک": {
        "root": "farsi"
    },
    "فلکتاج": {
        "root": "farsi"
    },
    "فلکوش": {
        "root": "farsi"
    },
    "فلکناز": {
        "root": "farsi"
    },
    "فلور": {
        "root": "farsi"
    },
    "فلورا": {
        "root": "farsi"
    },
    "فلوریا": {
        "root": "farsi"
    },
    "فوزیه": {
        "root": "farsi"
    },
    "فوژان": {
        "root": "farsi"
    },
    "فهیمه": {
        "root": "farsi"
    },
    "فیروزخاتون": {
        "root": "farsi"
    },
    "فیروزه": {
        "root": "farsi"
    },
    "قاصدک": {
        "root": "farsi"
    },
    "قاهره": {
        "root": "farsi"
    },
    "قدسی": {
        "root": "farsi"
    },
    "قدسیه": {
        "root": "farsi"
    },
    "قدیسه": {
        "root": "farsi"
    },
    "قرةالعین": {
        "root": "farsi"
    },
    "قرنفل": {
        "root": "farsi"
    },
    "قشنگ": {
        "root": "farsi"
    },
    "قشنگگل": {
        "root": "farsi"
    },
    "قصیده": {
        "root": "farsi"
    },
    "قطره": {
        "root": "farsi"
    },
    "قمر": {
        "root": "farsi"
    },
    "قمرالزمان": {
        "root": "farsi"
    },
    "قمرالملوک": {
        "root": "farsi"
    },
    "قمرتاج": {
        "root": "farsi"
    },
    "قمرسیما": {
        "root": "farsi"
    },
    "قمرناز": {
        "root": "farsi"
    },
    "قمری": {
        "root": "farsi"
    },
    "قیدافه": {
        "root": "farsi"
    },
    "قیزبس": {
        "root": "farsi"
    },
    "کنیا": {
        "root": "farsi"
    },
    "کاترین": {
        "root": "farsi"
    },
    "کاترینا": {
        "root": "farsi"
    },
    "کاتیا": {
        "root": "farsi"
    },
    "کارمن": {
        "root": "farsi"
    },
    "کارولین": {
        "root": "farsi"
    },
    "کاس": {
        "root": "farsi"
    },
    "کاساندان": {
        "root": "farsi"
    },
    "کاشین": {
        "root": "farsi"
    },
    "کامدل": {
        "root": "farsi"
    },
    "کامله": {
        "root": "farsi"
    },
    "کاملیا": {
        "root": "farsi"
    },
    "کاملین": {
        "root": "farsi"
    },
    "کامه": {
        "root": "farsi"
    },
    "کامیشا": {
        "root": "farsi"
    },
    "کامیلا": {
        "root": "farsi"
    },
    "کاناز": {
        "root": "farsi"
    },
    "کانی": {
        "root": "farsi"
    },
    "کاویش": {
        "root": "farsi"
    },
    "کبرا": {
        "root": "farsi"
    },
    "کبری": {
        "root": "farsi"
    },
    "کبریا": {
        "root": "farsi"
    },
    "کبیتا": {
        "root": "farsi"
    },
    "کتایون": {
        "root": "farsi"
    },
    "کرا": {
        "root": "farsi"
    },
    "کرانه": {
        "root": "farsi"
    },
    "کرشمه": {
        "root": "farsi"
    },
    "کریمه": {
        "root": "farsi"
    },
    "کژال": {
        "root": "farsi"
    },
    "کشم": {
        "root": "farsi"
    },
    "کشور": {
        "root": "farsi"
    },
    "کشوربانو": {
        "root": "farsi"
    },
    "کلارا": {
        "root": "farsi"
    },
    "کلاله": {
        "root": "farsi"
    },
    "کلثوم": {
        "root": "farsi"
    },
    "کمانه": {
        "root": "farsi"
    },
    "کمند": {
        "root": "farsi"
    },
    "کوثر": {
        "root": "farsi"
    },
    "کوچیار": {
        "root": "farsi"
    },
    "کوشانه": {
        "root": "farsi"
    },
    "کوشک": {
        "root": "farsi"
    },
    "کوکب": {
        "root": "farsi"
    },
    "کوکبه": {
        "root": "farsi"
    },
    "کوهینه": {
        "root": "farsi"
    },
    "کهربا": {
        "root": "farsi"
    },
    "کهسار": {
        "root": "farsi"
    },
    "کیآفرید": {
        "root": "farsi"
    },
    "کیآفرین": {
        "root": "farsi"
    },
    "کیبانو": {
        "root": "farsi"
    },
    "کیدخت": {
        "root": "farsi"
    },
    "کیادخت": {
        "root": "farsi"
    },
    "کیارا": {
        "root": "farsi"
    },
    "کیانبانو": {
        "root": "farsi"
    },
    "کیانا": {
        "root": "farsi"
    },
    "کیاندخت": {
        "root": "farsi"
    },
    "کیانه": {
        "root": "farsi"
    },
    "کیجا": {
        "root": "farsi"
    },
    "کیجانا": {
        "root": "farsi"
    },
    "کیسر": {
        "root": "farsi"
    },
    "کیمیا": {
        "root": "farsi"
    },
    "کیناز": {
        "root": "farsi"
    },
    "کیوانبانو": {
        "root": "farsi"
    },
    "کیواندخت": {
        "root": "farsi"
    },
    "کیوانچهر": {
        "root": "farsi"
    },
    "کیوانرخ": {
        "root": "farsi"
    },
    "کیوانزاد": {
        "root": "farsi"
    },
    "کیهاندخت": {
        "root": "farsi"
    },
    "کیهانه": {
        "root": "farsi"
    },
    "گاتا": {
        "root": "farsi"
    },
    "گرامیدخت": {
        "root": "farsi"
    },
    "گرانمهر": {
        "root": "farsi"
    },
    "گردآفرید": {
        "root": "farsi"
    },
    "گردآفرین": {
        "root": "farsi"
    },
    "گردیا": {
        "root": "farsi"
    },
    "گردیه": {
        "root": "farsi"
    },
    "گزل": {
        "root": "farsi"
    },
    "گشتا": {
        "root": "farsi"
    },
    "گل": {
        "root": "farsi"
    },
    "گلافروز": {
        "root": "farsi"
    },
    "گلافسر": {
        "root": "farsi"
    },
    "گلافشان": {
        "root": "farsi"
    },
    "گلاندام": {
        "root": "farsi"
    },
    "گلآذین": {
        "root": "farsi"
    },
    "گلآرا": {
        "root": "farsi"
    },
    "گلآسا": {
        "root": "farsi"
    },
    "گلآفرید": {
        "root": "farsi"
    },
    "گلآگین": {
        "root": "farsi"
    },
    "گلآور": {
        "root": "farsi"
    },
    "گلآویز": {
        "root": "farsi"
    },
    "گلآیین": {
        "root": "farsi"
    },
    "گلپر": {
        "root": "farsi"
    },
    "گلپرست": {
        "root": "farsi"
    },
    "گلپری": {
        "root": "farsi"
    },
    "گلپناه": {
        "root": "farsi"
    },
    "گلپیکر": {
        "root": "farsi"
    },
    "گلتاج": {
        "root": "farsi"
    },
    "گلتن": {
        "root": "farsi"
    },
    "گلجهان": {
        "root": "farsi"
    },
    "گلخند": {
        "root": "farsi"
    },
    "گلدانه": {
        "root": "farsi"
    },
    "گلدخت": {
        "root": "farsi"
    },
    "گلدوست": {
        "root": "farsi"
    },
    "گلربا": {
        "root": "farsi"
    },
    "گلسیما": {
        "root": "farsi"
    },
    "گلشاد": {
        "root": "farsi"
    },
    "گلگونه": {
        "root": "farsi"
    },
    "گلنسا": {
        "root": "farsi"
    },
    "گلوش": {
        "root": "farsi"
    },
    "گلاب": {
        "root": "farsi"
    },
    "گلابتون": {
        "root": "farsi"
    },
    "گلاره": {
        "root": "farsi"
    },
    "گلاسا": {
        "root": "farsi"
    },
    "گلال": {
        "root": "farsi"
    },
    "گلاله": {
        "root": "farsi"
    },
    "گلاویژ": {
        "root": "farsi"
    },
    "گلایل": {
        "root": "farsi"
    },
    "گلایول": {
        "root": "farsi"
    },
    "گلایون": {
        "root": "farsi"
    },
    "گلباران": {
        "root": "farsi"
    },
    "گلباش": {
        "root": "farsi"
    },
    "گلبان": {
        "root": "farsi"
    },
    "گلبانو": {
        "root": "farsi"
    },
    "گلبر": {
        "root": "farsi"
    },
    "گلبرگ": {
        "root": "farsi"
    },
    "گلبن": {
        "root": "farsi"
    },
    "گلبوته": {
        "root": "farsi"
    },
    "گلبهار": {
        "root": "farsi"
    },
    "گلبیز": {
        "root": "farsi"
    },
    "گلپاد": {
        "root": "farsi"
    },
    "گلپونه": {
        "root": "farsi"
    },
    "گلچهر": {
        "root": "farsi"
    },
    "گلچهره": {
        "root": "farsi"
    },
    "گلچین": {
        "root": "farsi"
    },
    "گلدسته": {
        "root": "farsi"
    },
    "گلدیس": {
        "root": "farsi"
    },
    "گلرخ": {
        "root": "farsi"
    },
    "گلرخسار": {
        "root": "farsi"
    },
    "گلرنگ": {
        "root": "farsi"
    },
    "گلرو": {
        "root": "farsi"
    },
    "گلروی": {
        "root": "farsi"
    },
    "گلریز": {
        "root": "farsi"
    },
    "گلزاد": {
        "root": "farsi"
    },
    "گلزار": {
        "root": "farsi"
    },
    "گلسا": {
        "root": "farsi"
    },
    "گلسان": {
        "root": "farsi"
    },
    "گلستان": {
        "root": "farsi"
    },
    "گلستانه": {
        "root": "farsi"
    },
    "گلسر": {
        "root": "farsi"
    },
    "گلسو": {
        "root": "farsi"
    },
    "گلشا": {
        "root": "farsi"
    },
    "گلشن": {
        "root": "farsi"
    },
    "گلشهر": {
        "root": "farsi"
    },
    "گلشید": {
        "root": "farsi"
    },
    "گلعذار": {
        "root": "farsi"
    },
    "گلفام": {
        "root": "farsi"
    },
    "گلفشان": {
        "root": "farsi"
    },
    "گلگون": {
        "root": "farsi"
    },
    "گلنار": {
        "root": "farsi"
    },
    "گلناز": {
        "root": "farsi"
    },
    "گلنام": {
        "root": "farsi"
    },
    "گلندام": {
        "root": "farsi"
    },
    "گلنواز": {
        "root": "farsi"
    },
    "گلنوش": {
        "root": "farsi"
    },
    "گلوریا": {
        "root": "farsi"
    },
    "گلی": {
        "root": "farsi"
    },
    "گلیناز": {
        "root": "farsi"
    },
    "گلیا": {
        "root": "farsi"
    },
    "گلیار": {
        "root": "farsi"
    },
    "گلین": {
        "root": "farsi"
    },
    "گندم": {
        "root": "farsi"
    },
    "گندمک": {
        "root": "farsi"
    },
    "گوطلا": {
        "root": "farsi"
    },
    "گولی": {
        "root": "farsi"
    },
    "گوهر": {
        "root": "farsi"
    },
    "گوهرافروز": {
        "root": "farsi"
    },
    "گوهرآرا": {
        "root": "farsi"
    },
    "گوهربانو": {
        "root": "farsi"
    },
    "گوهرتاب": {
        "root": "farsi"
    },
    "گوهرتاج": {
        "root": "farsi"
    },
    "گوهرتاش": {
        "root": "farsi"
    },
    "گوهرچهر": {
        "root": "farsi"
    },
    "گوهردخت": {
        "root": "farsi"
    },
    "گوهرزاد": {
        "root": "farsi"
    },
    "گوهرسان": {
        "root": "farsi"
    },
    "گوهرشاد": {
        "root": "farsi"
    },
    "گوهرشید": {
        "root": "farsi"
    },
    "گوهرفشان": {
        "root": "farsi"
    },
    "گوهرملک": {
        "root": "farsi"
    },
    "گوهرناز": {
        "root": "farsi"
    },
    "گوهرنگار": {
        "root": "farsi"
    },
    "گوهره": {
        "root": "farsi"
    },
    "گوهرین": {
        "root": "farsi"
    },
    "گهر": {
        "root": "farsi"
    },
    "گهربانو": {
        "root": "farsi"
    },
    "گهرچهر": {
        "root": "farsi"
    },
    "گهردخت": {
        "root": "farsi"
    },
    "گهرناز": {
        "root": "farsi"
    },
    "گهرنگار": {
        "root": "farsi"
    },
    "گیتا": {
        "root": "farsi"
    },
    "گیتی": {
        "root": "farsi"
    },
    "گیتیناز": {
        "root": "farsi"
    },
    "گیسو": {
        "root": "farsi"
    },
    "گیسیا": {
        "root": "farsi"
    },
    "گیلار": {
        "root": "farsi"
    },
    "گیلاکو": {
        "root": "farsi"
    },
    "گیلانا": {
        "root": "farsi"
    },
    "گیلدا": {
        "root": "farsi"
    },
    "گیلنار": {
        "root": "farsi"
    },
    "گیلوا": {
        "root": "farsi"
    },
    "گیهان": {
        "root": "farsi"
    },
    "لچک": {
        "root": "farsi"
    },
    "لاچین": {
        "root": "farsi"
    },
    "لادبن": {
        "root": "farsi"
    },
    "لادن": {
        "root": "farsi"
    },
    "لاریسا": {
        "root": "farsi"
    },
    "لاله": {
        "root": "farsi"
    },
    "لالهچهر": {
        "root": "farsi"
    },
    "لالهدخت": {
        "root": "farsi"
    },
    "لالهرخ": {
        "root": "farsi"
    },
    "لالهرخسار": {
        "root": "farsi"
    },
    "لالهرو": {
        "root": "farsi"
    },
    "لالهزار": {
        "root": "farsi"
    },
    "لالهگون": {
        "root": "farsi"
    },
    "لالهوش": {
        "root": "farsi"
    },
    "لامیا": {
        "root": "farsi"
    },
    "لاون": {
        "root": "farsi"
    },
    "لایه": {
        "root": "farsi"
    },
    "لبخند": {
        "root": "farsi"
    },
    "لبخنده": {
        "root": "farsi"
    },
    "لبینا": {
        "root": "farsi"
    },
    "لتکا": {
        "root": "farsi"
    },
    "لطیفه": {
        "root": "farsi"
    },
    "لعبت": {
        "root": "farsi"
    },
    "لعل": {
        "root": "farsi"
    },
    "لعیا": {
        "root": "farsi"
    },
    "لمیا": {
        "root": "farsi"
    },
    "لمیس": {
        "root": "farsi"
    },
    "لنیا": {
        "root": "farsi"
    },
    "لورا": {
        "root": "farsi"
    },
    "لؤلؤ": {
        "root": "farsi"
    },
    "لیا": {
        "root": "farsi"
    },
    "لیالی": {
        "root": "farsi"
    },
    "لیان": {
        "root": "farsi"
    },
    "لیبه": {
        "root": "farsi"
    },
    "لیدا": {
        "root": "farsi"
    },
    "لیزا": {
        "root": "farsi"
    },
    "لیسا": {
        "root": "farsi"
    },
    "لیلا": {
        "root": "farsi"
    },
    "لیلی": {
        "root": "farsi"
    },
    "لیلیا": {
        "root": "farsi"
    },
    "لیلیان": {
        "root": "farsi"
    },
    "لیمو": {
        "root": "farsi"
    },
    "لینا": {
        "root": "farsi"
    },
    "لیندا": {
        "root": "farsi"
    },
    "لیو": {
        "root": "farsi"
    },
    "لئا": {
        "root": "farsi"
    },
    "مشیانه": {
        "root": "farsi"
    },
    "ماتیسا": {
        "root": "farsi"
    },
    "ماتینا": {
        "root": "farsi"
    },
    "ماجان": {
        "root": "farsi"
    },
    "ماجده": {
        "root": "farsi"
    },
    "مادیا": {
        "root": "farsi"
    },
    "مارال": {
        "root": "farsi"
    },
    "مارتا": {
        "root": "farsi"
    },
    "مارگاریتا": {
        "root": "farsi"
    },
    "مارگریت": {
        "root": "farsi"
    },
    "مارلین": {
        "root": "farsi"
    },
    "ماری": {
        "root": "farsi"
    },
    "ماریا": {
        "root": "farsi"
    },
    "ماریان": {
        "root": "farsi"
    },
    "مارینا": {
        "root": "farsi"
    },
    "ماریه": {
        "root": "farsi"
    },
    "ماسا": {
        "root": "farsi"
    },
    "ماشگانا": {
        "root": "farsi"
    },
    "ماگنولیا": {
        "root": "farsi"
    },
    "مالکه": {
        "root": "farsi"
    },
    "مامک": {
        "root": "farsi"
    },
    "مامو": {
        "root": "farsi"
    },
    "مامیثا": {
        "root": "farsi"
    },
    "مانا": {
        "root": "farsi"
    },
    "مانتره": {
        "root": "farsi"
    },
    "مانترا": {
        "root": "farsi"
    },
    "ماندان": {
        "root": "farsi"
    },
    "ماندانا": {
        "root": "farsi"
    },
    "ماندوی": {
        "root": "farsi"
    },
    "مانک": {
        "root": "farsi"
    },
    "مانگ": {
        "root": "farsi"
    },
    "مانند": {
        "root": "farsi"
    },
    "مانوشا": {
        "root": "farsi"
    },
    "مانوشاک": {
        "root": "farsi"
    },
    "مانه": {
        "root": "farsi"
    },
    "مانیا": {
        "root": "farsi"
    },
    "مانیان": {
        "root": "farsi"
    },
    "مانیوک": {
        "root": "farsi"
    },
    "ماورد": {
        "root": "farsi"
    },
    "ماهآفرید": {
        "root": "farsi"
    },
    "ماهآفرین": {
        "root": "farsi"
    },
    "ماهبانو": {
        "root": "farsi"
    },
    "ماهبه": {
        "root": "farsi"
    },
    "ماهبیبی": {
        "root": "farsi"
    },
    "ماهپرن": {
        "root": "farsi"
    },
    "ماهپری": {
        "root": "farsi"
    },
    "ماهپیکر": {
        "root": "farsi"
    },
    "ماهتابان": {
        "root": "farsi"
    },
    "ماهجبین": {
        "root": "farsi"
    },
    "ماهجهان": {
        "root": "farsi"
    },
    "ماهچهره": {
        "root": "farsi"
    },
    "ماهخاتون": {
        "root": "farsi"
    },
    "ماهخانم": {
        "root": "farsi"
    },
    "ماهخدای": {
        "root": "farsi"
    },
    "ماهرخسار": {
        "root": "farsi"
    },
    "ماهروی": {
        "root": "farsi"
    },
    "ماهزیور": {
        "root": "farsi"
    },
    "ماهسیما": {
        "root": "farsi"
    },
    "ماهشاد": {
        "root": "farsi"
    },
    "ماهشید": {
        "root": "farsi"
    },
    "ماهصنم": {
        "root": "farsi"
    },
    "ماهطلعت": {
        "root": "farsi"
    },
    "ماهلقا": {
        "root": "farsi"
    },
    "ماهمنظر": {
        "root": "farsi"
    },
    "ماهمنیر": {
        "root": "farsi"
    },
    "ماهنسا": {
        "root": "farsi"
    },
    "ماهانه": {
        "root": "farsi"
    },
    "ماهایا": {
        "root": "farsi"
    },
    "ماهبد": {
        "root": "farsi"
    },
    "ماهپاره": {
        "root": "farsi"
    },
    "ماهتا": {
        "root": "farsi"
    },
    "ماهتاب": {
        "root": "farsi"
    },
    "ماهتاج": {
        "root": "farsi"
    },
    "ماهتیسا": {
        "root": "farsi"
    },
    "ماهچهر": {
        "root": "farsi"
    },
    "ماهدخت": {
        "root": "farsi"
    },
    "ماهدیس": {
        "root": "farsi"
    },
    "ماهرخ": {
        "root": "farsi"
    },
    "ماهرو": {
        "root": "farsi"
    },
    "ماهزاد": {
        "root": "farsi"
    },
    "ماهک": {
        "root": "farsi"
    },
    "ماهکان": {
        "root": "farsi"
    },
    "ماهگل": {
        "root": "farsi"
    },
    "ماهناز": {
        "root": "farsi"
    },
    "ماهناک": {
        "root": "farsi"
    },
    "ماهنوش": {
        "root": "farsi"
    },
    "ماهنی": {
        "root": "farsi"
    },
    "ماهور": {
        "root": "farsi"
    },
    "ماهوش": {
        "root": "farsi"
    },
    "ماهویه": {
        "root": "farsi"
    },
    "ماهی": {
        "root": "farsi"
    },
    "ماهین": {
        "root": "farsi"
    },
    "مایا": {
        "root": "farsi"
    },
    "مائده": {
        "root": "farsi"
    },
    "مبارکه": {
        "root": "farsi"
    },
    "مبینا": {
        "root": "farsi"
    },
    "متینه": {
        "root": "farsi"
    },
    "مجذوب": {
        "root": "farsi"
    },
    "محبت": {
        "root": "farsi"
    },
    "محبوب": {
        "root": "farsi"
    },
    "محبوبه": {
        "root": "farsi"
    },
    "محترم": {
        "root": "farsi"
    },
    "محدثه": {
        "root": "farsi"
    },
    "محسنه": {
        "root": "farsi"
    },
    "محنا": {
        "root": "farsi"
    },
    "محیا": {
        "root": "farsi"
    },
    "محیصا": {
        "root": "farsi"
    },
    "مخمل": {
        "root": "farsi"
    },
    "مدیا": {
        "root": "farsi"
    },
    "مدیسه": {
        "root": "farsi"
    },
    "مدینه": {
        "root": "farsi"
    },
    "مرجان": {
        "root": "farsi"
    },
    "مرجانه": {
        "root": "farsi"
    },
    "مرجون": {
        "root": "farsi"
    },
    "مرحان": {
        "root": "farsi"
    },
    "مرحمت": {
        "root": "farsi"
    },
    "مردآوند": {
        "root": "farsi"
    },
    "مرسده": {
        "root": "farsi"
    },
    "مرسیا": {
        "root": "farsi"
    },
    "مرصع": {
        "root": "farsi"
    },
    "مرضیه": {
        "root": "farsi"
    },
    "مرمر": {
        "root": "farsi"
    },
    "مرمرین": {
        "root": "farsi"
    },
    "مروا": {
        "root": "farsi"
    },
    "مروارید": {
        "root": "farsi"
    },
    "مروانه": {
        "root": "farsi"
    },
    "مریس": {
        "root": "farsi"
    },
    "مریم": {
        "root": "farsi"
    },
    "مژان": {
        "root": "farsi"
    },
    "مژده": {
        "root": "farsi"
    },
    "مژگان": {
        "root": "farsi"
    },
    "مستانه": {
        "root": "farsi"
    },
    "مستوره": {
        "root": "farsi"
    },
    "مسرور": {
        "root": "farsi"
    },
    "مسلمه": {
        "root": "farsi"
    },
    "مسیحا": {
        "root": "farsi"
    },
    "مشک": {
        "root": "farsi"
    },
    "مشکات": {
        "root": "farsi"
    },
    "مشکاه": {
        "root": "farsi"
    },
    "مشکدانه": {
        "root": "farsi"
    },
    "مشکناز": {
        "root": "farsi"
    },
    "مشکنک": {
        "root": "farsi"
    },
    "مشکین": {
        "root": "farsi"
    },
    "مشیما": {
        "root": "farsi"
    },
    "مطهره": {
        "root": "farsi"
    },
    "معصوم": {
        "root": "farsi"
    },
    "معصومه": {
        "root": "farsi"
    },
    "معظمه": {
        "root": "farsi"
    },
    "مقبله": {
        "root": "farsi"
    },
    "مقدسه": {
        "root": "farsi"
    },
    "مقصوده": {
        "root": "farsi"
    },
    "مکرمه": {
        "root": "farsi"
    },
    "مکینا": {
        "root": "farsi"
    },
    "مکیناس": {
        "root": "farsi"
    },
    "مکیه": {
        "root": "farsi"
    },
    "ملاحت": {
        "root": "farsi"
    },
    "ملک": {
        "root": "farsi"
    },
    "ملکبانو": {
        "root": "farsi"
    },
    "ملکتاج": {
        "root": "farsi"
    },
    "ملکناز": {
        "root": "farsi"
    },
    "ملکه": {
        "root": "farsi"
    },
    "ملورین": {
        "root": "farsi"
    },
    "ملوس": {
        "root": "farsi"
    },
    "ملوک": {
        "root": "farsi"
    },
    "ملیحه": {
        "root": "farsi"
    },
    "ملیسا": {
        "root": "farsi"
    },
    "ملیکا": {
        "root": "farsi"
    },
    "ملیکه": {
        "root": "farsi"
    },
    "ملیله": {
        "root": "farsi"
    },
    "ملینا": {
        "root": "farsi"
    },
    "منا": {
        "root": "farsi"
    },
    "منال": {
        "root": "farsi"
    },
    "منجوق": {
        "root": "farsi"
    },
    "منصوره": {
        "root": "farsi"
    },
    "منظر": {
        "root": "farsi"
    },
    "منوره": {
        "root": "farsi"
    },
    "منیر": {
        "root": "farsi"
    },
    "منیره": {
        "root": "farsi"
    },
    "منیژه": {
        "root": "farsi"
    },
    "مورد": {
        "root": "farsi"
    },
    "موژان": {
        "root": "farsi"
    },
    "موکا": {
        "root": "farsi"
    },
    "مولود": {
        "root": "farsi"
    },
    "مونا": {
        "root": "farsi"
    },
    "مونجوق": {
        "root": "farsi"
    },
    "مونس": {
        "root": "farsi"
    },
    "مونیکا": {
        "root": "farsi"
    },
    "مهپاره": {
        "root": "farsi"
    },
    "مهپیکر": {
        "root": "farsi"
    },
    "مهجبین": {
        "root": "farsi"
    },
    "مهسیما": {
        "root": "farsi"
    },
    "مهفروز": {
        "root": "farsi"
    },
    "مهفروغ": {
        "root": "farsi"
    },
    "مهگل": {
        "root": "farsi"
    },
    "مهلقا": {
        "root": "farsi"
    },
    "مهیاس": {
        "root": "farsi"
    },
    "مها": {
        "root": "farsi"
    },
    "مهبا": {
        "root": "farsi"
    },
    "مهبان": {
        "root": "farsi"
    },
    "مهتا": {
        "root": "farsi"
    },
    "مهتاب": {
        "root": "farsi"
    },
    "مهتاج": {
        "root": "farsi"
    },
    "مهترا": {
        "root": "farsi"
    },
    "مهدا": {
        "root": "farsi"
    },
    "مهدخت": {
        "root": "farsi"
    },
    "مهدیا": {
        "root": "farsi"
    },
    "مهدیس": {
        "root": "farsi"
    },
    "مهدیسا": {
        "root": "farsi"
    },
    "مهدیسه": {
        "root": "farsi"
    },
    "مهدیه": {
        "root": "farsi"
    },
    "مهر": {
        "root": "farsi"
    },
    "مهرآریا": {
        "root": "farsi"
    },
    "مهرآئین": {
        "root": "farsi"
    },
    "مهررخسار": {
        "root": "farsi"
    },
    "مهرا": {
        "root": "farsi"
    },
    "مهراسا": {
        "root": "farsi"
    },
    "مهرافروز": {
        "root": "farsi"
    },
    "مهرافزا": {
        "root": "farsi"
    },
    "مهرافزون": {
        "root": "farsi"
    },
    "مهرافشان": {
        "root": "farsi"
    },
    "مهرانا": {
        "root": "farsi"
    },
    "مهراندیش": {
        "root": "farsi"
    },
    "مهرانگیز": {
        "root": "farsi"
    },
    "مهرانه": {
        "root": "farsi"
    },
    "مهراوه": {
        "root": "farsi"
    },
    "مهرآذر": {
        "root": "farsi"
    },
    "مهرآذین": {
        "root": "farsi"
    },
    "مهرآسا": {
        "root": "farsi"
    },
    "مهرآفرید": {
        "root": "farsi"
    },
    "مهرآگین": {
        "root": "farsi"
    },
    "مهرآمیز": {
        "root": "farsi"
    },
    "مهرآور": {
        "root": "farsi"
    },
    "مهربان": {
        "root": "farsi"
    },
    "مهربانو": {
        "root": "farsi"
    },
    "مهرتا": {
        "root": "farsi"
    },
    "مهرتاب": {
        "root": "farsi"
    },
    "مهرچهر": {
        "root": "farsi"
    },
    "مهرچین": {
        "root": "farsi"
    },
    "مهرخ": {
        "root": "farsi"
    },
    "مهردخت": {
        "root": "farsi"
    },
    "مهردیس": {
        "root": "farsi"
    },
    "مهرسا": {
        "root": "farsi"
    },
    "مهرشید": {
        "root": "farsi"
    },
    "مهرکیش": {
        "root": "farsi"
    },
    "مهرگل": {
        "root": "farsi"
    },
    "مهرمنیر": {
        "root": "farsi"
    },
    "مهرناز": {
        "root": "farsi"
    },
    "مهرنسا": {
        "root": "farsi"
    },
    "مهرنگار": {
        "root": "farsi"
    },
    "مهرنواز": {
        "root": "farsi"
    },
    "مهرنوش": {
        "root": "farsi"
    },
    "مهرو": {
        "root": "farsi"
    },
    "مهروز": {
        "root": "farsi"
    },
    "مهروش": {
        "root": "farsi"
    },
    "مهروی": {
        "root": "farsi"
    },
    "مهری": {
        "root": "farsi"
    },
    "مهریز": {
        "root": "farsi"
    },
    "مهریماه": {
        "root": "farsi"
    },
    "مهسا": {
        "root": "farsi"
    },
    "مهسان": {
        "root": "farsi"
    },
    "مهسانه": {
        "root": "farsi"
    },
    "مهستا": {
        "root": "farsi"
    },
    "مهستی": {
        "root": "farsi"
    },
    "مهشاد": {
        "root": "farsi"
    },
    "مهشید": {
        "root": "farsi"
    },
    "مهفام": {
        "root": "farsi"
    },
    "مهکامه": {
        "root": "farsi"
    },
    "مهکیا": {
        "root": "farsi"
    },
    "مهلا": {
        "root": "farsi"
    },
    "مهنا": {
        "root": "farsi"
    },
    "مهناز": {
        "root": "farsi"
    },
    "مهنور": {
        "root": "farsi"
    },
    "مهنوش": {
        "root": "farsi"
    },
    "مهنیا": {
        "root": "farsi"
    },
    "مهوش": {
        "root": "farsi"
    },
    "مهیا": {
        "root": "farsi"
    },
    "مهیاره": {
        "root": "farsi"
    },
    "مهیتا": {
        "root": "farsi"
    },
    "مهیره": {
        "root": "farsi"
    },
    "مهیمنه": {
        "root": "farsi"
    },
    "مهین": {
        "root": "farsi"
    },
    "مهیندخت": {
        "root": "farsi"
    },
    "میترا": {
        "root": "farsi"
    },
    "میچکا": {
        "root": "farsi"
    },
    "میخک": {
        "root": "farsi"
    },
    "میرانه": {
        "root": "farsi"
    },
    "میرتو": {
        "root": "farsi"
    },
    "میریام": {
        "root": "farsi"
    },
    "میسا": {
        "root": "farsi"
    },
    "میسان": {
        "root": "farsi"
    },
    "میشانه": {
        "root": "farsi"
    },
    "میشکا": {
        "root": "farsi"
    },
    "میشی": {
        "root": "farsi"
    },
    "میگل": {
        "root": "farsi"
    },
    "میلا": {
        "root": "farsi"
    },
    "میلانا": {
        "root": "farsi"
    },
    "میمنت": {
        "root": "farsi"
    },
    "مینا": {
        "root": "farsi"
    },
    "میناز": {
        "root": "farsi"
    },
    "مینو": {
        "root": "farsi"
    },
    "مینوچهر": {
        "root": "farsi"
    },
    "مینورام": {
        "root": "farsi"
    },
    "مینورخ": {
        "root": "farsi"
    },
    "مینوزاد": {
        "root": "farsi"
    },
    "مینوسرشت": {
        "root": "farsi"
    },
    "مینوش": {
        "root": "farsi"
    },
    "مینووش": {
        "root": "farsi"
    },
    "میهن": {
        "root": "farsi"
    },
    "میهنبانو": {
        "root": "farsi"
    },
    "میهنتاج": {
        "root": "farsi"
    },
    "میهندخت": {
        "root": "farsi"
    },
    "ناتاشا": {
        "root": "farsi"
    },
    "نادره": {
        "root": "farsi"
    },
    "نادرهگفتار": {
        "root": "farsi"
    },
    "نادی": {
        "root": "farsi"
    },
    "نادیا": {
        "root": "farsi"
    },
    "نادیه": {
        "root": "farsi"
    },
    "ناراین": {
        "root": "farsi"
    },
    "ناربن": {
        "root": "farsi"
    },
    "ناردانا": {
        "root": "farsi"
    },
    "ناردانه": {
        "root": "farsi"
    },
    "ناردخت": {
        "root": "farsi"
    },
    "ناردیس": {
        "root": "farsi"
    },
    "نارسیس": {
        "root": "farsi"
    },
    "نارگل": {
        "root": "farsi"
    },
    "نارگون": {
        "root": "farsi"
    },
    "نارملا": {
        "root": "farsi"
    },
    "نارمیلا": {
        "root": "farsi"
    },
    "نارنج": {
        "root": "farsi"
    },
    "نارو": {
        "root": "farsi"
    },
    "ناریا": {
        "root": "farsi"
    },
    "ناریکا": {
        "root": "farsi"
    },
    "نارین": {
        "root": "farsi"
    },
    "نارینا": {
        "root": "farsi"
    },
    "نارینه": {
        "root": "farsi"
    },
    "ناریه": {
        "root": "farsi"
    },
    "ناز": {
        "root": "farsi"
    },
    "نازان": {
        "root": "farsi"
    },
    "نازانتا": {
        "root": "farsi"
    },
    "نازآفرید": {
        "root": "farsi"
    },
    "نازآفرین": {
        "root": "farsi"
    },
    "نازبانو": {
        "root": "farsi"
    },
    "نازبو": {
        "root": "farsi"
    },
    "نازپرور": {
        "root": "farsi"
    },
    "نازپری": {
        "root": "farsi"
    },
    "نازجهان": {
        "root": "farsi"
    },
    "نازخاتون": {
        "root": "farsi"
    },
    "نازدانه": {
        "root": "farsi"
    },
    "نازدخت": {
        "root": "farsi"
    },
    "نازدلبر": {
        "root": "farsi"
    },
    "نازرخ": {
        "root": "farsi"
    },
    "نازک": {
        "root": "farsi"
    },
    "نازگل": {
        "root": "farsi"
    },
    "نازگوهر": {
        "root": "farsi"
    },
    "نازگیتی": {
        "root": "farsi"
    },
    "نازلی": {
        "root": "farsi"
    },
    "نازمهر": {
        "root": "farsi"
    },
    "نازنوش": {
        "root": "farsi"
    },
    "نازنین": {
        "root": "farsi"
    },
    "نازنینچهر": {
        "root": "farsi"
    },
    "نازنینزهرا": {
        "root": "farsi"
    },
    "نازی": {
        "root": "farsi"
    },
    "نازیاب": {
        "root": "farsi"
    },
    "نازیار": {
        "root": "farsi"
    },
    "نازیتا": {
        "root": "farsi"
    },
    "نازیک": {
        "root": "farsi"
    },
    "نازیلا": {
        "root": "farsi"
    },
    "نازینه": {
        "root": "farsi"
    },
    "ناژین": {
        "root": "farsi"
    },
    "نافه": {
        "root": "farsi"
    },
    "ناکتا": {
        "root": "farsi"
    },
    "نانا": {
        "root": "farsi"
    },
    "نانسی": {
        "root": "farsi"
    },
    "نانیسا": {
        "root": "farsi"
    },
    "ناوه": {
        "root": "farsi"
    },
    "ناهید": {
        "root": "farsi"
    },
    "نایریکا": {
        "root": "farsi"
    },
    "نائله": {
        "root": "farsi"
    },
    "نائیریکا": {
        "root": "farsi"
    },
    "نبات": {
        "root": "farsi"
    },
    "نجلا": {
        "root": "farsi"
    },
    "نجم": {
        "root": "farsi"
    },
    "نجمه": {
        "root": "farsi"
    },
    "نجوا": {
        "root": "farsi"
    },
    "نجیبه": {
        "root": "farsi"
    },
    "نخستین": {
        "root": "farsi"
    },
    "ندا": {
        "root": "farsi"
    },
    "ندیمه": {
        "root": "farsi"
    },
    "نرجس": {
        "root": "farsi"
    },
    "نرجسخاتون": {
        "root": "farsi"
    },
    "نرسا": {
        "root": "farsi"
    },
    "نرگس": {
        "root": "farsi"
    },
    "نرمین": {
        "root": "farsi"
    },
    "نسا": {
        "root": "farsi"
    },
    "نساک": {
        "root": "farsi"
    },
    "نستر": {
        "root": "farsi"
    },
    "نسترن": {
        "root": "farsi"
    },
    "نسرین": {
        "root": "farsi"
    },
    "نسرینمهر": {
        "root": "farsi"
    },
    "نسریننوش": {
        "root": "farsi"
    },
    "نسیبه": {
        "root": "farsi"
    },
    "نسیم": {
        "root": "farsi"
    },
    "نشمیل": {
        "root": "farsi"
    },
    "نصیبه": {
        "root": "farsi"
    },
    "نظاره": {
        "root": "farsi"
    },
    "نعنا": {
        "root": "farsi"
    },
    "نعناع": {
        "root": "farsi"
    },
    "نغمه": {
        "root": "farsi"
    },
    "نفیسا": {
        "root": "farsi"
    },
    "نفیسه": {
        "root": "farsi"
    },
    "نقره": {
        "root": "farsi"
    },
    "نکوزاد": {
        "root": "farsi"
    },
    "نکویار": {
        "root": "farsi"
    },
    "نکهت": {
        "root": "farsi"
    },
    "نگار": {
        "root": "farsi"
    },
    "نگارا": {
        "root": "farsi"
    },
    "نگاربسته": {
        "root": "farsi"
    },
    "نگارشید": {
        "root": "farsi"
    },
    "نگاره": {
        "root": "farsi"
    },
    "نگارین": {
        "root": "farsi"
    },
    "نگاه": {
        "root": "farsi"
    },
    "نگین": {
        "root": "farsi"
    },
    "نگینا": {
        "root": "farsi"
    },
    "نگینه": {
        "root": "farsi"
    },
    "نواآفرین": {
        "root": "farsi"
    },
    "نوازش": {
        "root": "farsi"
    },
    "نوال": {
        "root": "farsi"
    },
    "نوباوه": {
        "root": "farsi"
    },
    "نوبر": {
        "root": "farsi"
    },
    "نور": {
        "root": "farsi"
    },
    "نورا": {
        "root": "farsi"
    },
    "نورافشان": {
        "root": "farsi"
    },
    "نوران": {
        "root": "farsi"
    },
    "نورآفرین": {
        "root": "farsi"
    },
    "نورسته": {
        "root": "farsi"
    },
    "نورین": {
        "root": "farsi"
    },
    "نوریه": {
        "root": "farsi"
    },
    "نوژان": {
        "root": "farsi"
    },
    "نوشآفرید": {
        "root": "farsi"
    },
    "نوشآگین": {
        "root": "farsi"
    },
    "نوشلب": {
        "root": "farsi"
    },
    "نوشا": {
        "root": "farsi"
    },
    "نوشابه": {
        "root": "farsi"
    },
    "نوشاد": {
        "root": "farsi"
    },
    "نوشان": {
        "root": "farsi"
    },
    "نوشناز": {
        "root": "farsi"
    },
    "نوشه": {
        "root": "farsi"
    },
    "نوشید": {
        "root": "farsi"
    },
    "نوشین": {
        "root": "farsi"
    },
    "نوشینلب": {
        "root": "farsi"
    },
    "نوشینه": {
        "root": "farsi"
    },
    "نوگل": {
        "root": "farsi"
    },
    "نونا": {
        "root": "farsi"
    },
    "نونهال": {
        "root": "farsi"
    },
    "نهال": {
        "root": "farsi"
    },
    "نهضت": {
        "root": "farsi"
    },
    "نیاز": {
        "root": "farsi"
    },
    "نیالا": {
        "root": "farsi"
    },
    "نیان": {
        "root": "farsi"
    },
    "نیایش": {
        "root": "farsi"
    },
    "نیتا": {
        "root": "farsi"
    },
    "نیر": {
        "root": "farsi"
    },
    "نیروانا": {
        "root": "farsi"
    },
    "نیره": {
        "root": "farsi"
    },
    "نیسا": {
        "root": "farsi"
    },
    "نیشا": {
        "root": "farsi"
    },
    "نیکاختر": {
        "root": "farsi"
    },
    "نیکآفرید": {
        "root": "farsi"
    },
    "نیکآفرین": {
        "root": "farsi"
    },
    "نیکتاج": {
        "root": "farsi"
    },
    "نیکتاش": {
        "root": "farsi"
    },
    "نیکرخسار": {
        "root": "farsi"
    },
    "نیکمهر": {
        "root": "farsi"
    },
    "نیکتا": {
        "root": "farsi"
    },
    "نیکچهر": {
        "root": "farsi"
    },
    "نیکچهره": {
        "root": "farsi"
    },
    "نیکدخت": {
        "root": "farsi"
    },
    "نیکرخ": {
        "root": "farsi"
    },
    "نیکروی": {
        "root": "farsi"
    },
    "نیکناز": {
        "root": "farsi"
    },
    "نیکولقا": {
        "root": "farsi"
    },
    "نیلا": {
        "root": "farsi"
    },
    "نیلاب": {
        "root": "farsi"
    },
    "نیلرام": {
        "root": "farsi"
    },
    "نیلگون": {
        "root": "farsi"
    },
    "نیلوفر": {
        "root": "farsi"
    },
    "نیلیا": {
        "root": "farsi"
    },
    "نیمتاج": {
        "root": "farsi"
    },
    "نینا": {
        "root": "farsi"
    },
    "نیواندخت": {
        "root": "farsi"
    },
    "نیوشه": {
        "root": "farsi"
    },
    "نیووند": {
        "root": "farsi"
    },
    "ورد": {
        "root": "farsi"
    },
    "واپسین": {
        "root": "farsi"
    },
    "واج": {
        "root": "farsi"
    },
    "وادی": {
        "root": "farsi"
    },
    "وارتوش": {
        "root": "farsi"
    },
    "واژه": {
        "root": "farsi"
    },
    "واله": {
        "root": "farsi"
    },
    "والیه": {
        "root": "farsi"
    },
    "وانوش": {
        "root": "farsi"
    },
    "وانوشه": {
        "root": "farsi"
    },
    "وانیار": {
        "root": "farsi"
    },
    "وجیهه": {
        "root": "farsi"
    },
    "وچان": {
        "root": "farsi"
    },
    "وحدانه": {
        "root": "farsi"
    },
    "وحیده": {
        "root": "farsi"
    },
    "ودا": {
        "root": "farsi"
    },
    "ورتا": {
        "root": "farsi"
    },
    "ورتاج": {
        "root": "farsi"
    },
    "ورجا": {
        "root": "farsi"
    },
    "وردآور": {
        "root": "farsi"
    },
    "وردی": {
        "root": "farsi"
    },
    "ورشان": {
        "root": "farsi"
    },
    "ورقا": {
        "root": "farsi"
    },
    "وریشه": {
        "root": "farsi"
    },
    "وسمه": {
        "root": "farsi"
    },
    "وسیم": {
        "root": "farsi"
    },
    "وسیمه": {
        "root": "farsi"
    },
    "وش": {
        "root": "farsi"
    },
    "وشان": {
        "root": "farsi"
    },
    "وشن": {
        "root": "farsi"
    },
    "ولان": {
        "root": "farsi"
    },
    "ولگا": {
        "root": "farsi"
    },
    "وناز": {
        "root": "farsi"
    },
    "ونوس": {
        "root": "farsi"
    },
    "ونوش": {
        "root": "farsi"
    },
    "ونوشه": {
        "root": "farsi"
    },
    "وهآفرید": {
        "root": "farsi"
    },
    "وهآفرین": {
        "root": "farsi"
    },
    "وهنوش": {
        "root": "farsi"
    },
    "وهار": {
        "root": "farsi"
    },
    "وهان": {
        "root": "farsi"
    },
    "وهرو": {
        "root": "farsi"
    },
    "وهشتیه": {
        "root": "farsi"
    },
    "وهوگون": {
        "root": "farsi"
    },
    "ویان": {
        "root": "farsi"
    },
    "ویانا": {
        "root": "farsi"
    },
    "ویدا": {
        "root": "farsi"
    },
    "ویرو": {
        "root": "farsi"
    },
    "ویستا": {
        "root": "farsi"
    },
    "ویشکا": {
        "root": "farsi"
    },
    "وینا": {
        "root": "farsi"
    },
    "ویوات": {
        "root": "farsi"
    },
    "ویوگ": {
        "root": "farsi"
    },
    "ویولا": {
        "root": "farsi"
    },
    "ویونا": {
        "root": "farsi"
    },
    "هووی": {
        "root": "farsi"
    },
    "هاجر": {
        "root": "farsi"
    },
    "هارا": {
        "root": "farsi"
    },
    "هاله": {
        "root": "farsi"
    },
    "هانه": {
        "root": "farsi"
    },
    "هانیا": {
        "root": "farsi"
    },
    "هانیه": {
        "root": "farsi"
    },
    "هایده": {
        "root": "farsi"
    },
    "هدا": {
        "root": "farsi"
    },
    "هدسه": {
        "root": "farsi"
    },
    "هدی": {
        "root": "farsi"
    },
    "هدیه": {
        "root": "farsi"
    },
    "هرانوش": {
        "root": "farsi"
    },
    "هرمیس": {
        "root": "farsi"
    },
    "هرمینا": {
        "root": "farsi"
    },
    "هستنوه": {
        "root": "farsi"
    },
    "هستی": {
        "root": "farsi"
    },
    "هفدن": {
        "root": "farsi"
    },
    "هفیان": {
        "root": "farsi"
    },
    "هگبه": {
        "root": "farsi"
    },
    "هلاله": {
        "root": "farsi"
    },
    "هلپرین": {
        "root": "farsi"
    },
    "هلما": {
        "root": "farsi"
    },
    "هلن": {
        "root": "farsi"
    },
    "هلنا": {
        "root": "farsi"
    },
    "هلنسا": {
        "root": "farsi"
    },
    "هلیا": {
        "root": "farsi"
    },
    "هلیله": {
        "root": "farsi"
    },
    "هلینا": {
        "root": "farsi"
    },
    "هلیون": {
        "root": "farsi"
    },
    "هما": {
        "root": "farsi"
    },
    "هماچهر": {
        "root": "farsi"
    },
    "همافر": {
        "root": "farsi"
    },
    "همایونبخت": {
        "root": "farsi"
    },
    "همایونچهر": {
        "root": "farsi"
    },
    "همدم": {
        "root": "farsi"
    },
    "همراز": {
        "root": "farsi"
    },
    "همساز": {
        "root": "farsi"
    },
    "همگام": {
        "root": "farsi"
    },
    "هموند": {
        "root": "farsi"
    },
    "همیشهبهار": {
        "root": "farsi"
    },
    "همیلا": {
        "root": "farsi"
    },
    "هنار": {
        "root": "farsi"
    },
    "هناو": {
        "root": "farsi"
    },
    "هنگامه": {
        "root": "farsi"
    },
    "هنیا": {
        "root": "farsi"
    },
    "هوآفرید": {
        "root": "farsi"
    },
    "هوبخت": {
        "root": "farsi"
    },
    "هوپاد": {
        "root": "farsi"
    },
    "هوتس": {
        "root": "farsi"
    },
    "هوتسا": {
        "root": "farsi"
    },
    "هوتوس": {
        "root": "farsi"
    },
    "هودسا": {
        "root": "farsi"
    },
    "هوده": {
        "root": "farsi"
    },
    "هورآفرین": {
        "root": "farsi"
    },
    "هوربانو": {
        "root": "farsi"
    },
    "هورتاش": {
        "root": "farsi"
    },
    "هورتن": {
        "root": "farsi"
    },
    "هورچهر": {
        "root": "farsi"
    },
    "هورخش": {
        "root": "farsi"
    },
    "هورداد": {
        "root": "farsi"
    },
    "هوردخت": {
        "root": "farsi"
    },
    "هوردیس": {
        "root": "farsi"
    },
    "هوررخ": {
        "root": "farsi"
    },
    "هورزاد": {
        "root": "farsi"
    },
    "هورسان": {
        "root": "farsi"
    },
    "هورشاد": {
        "root": "farsi"
    },
    "هورشید": {
        "root": "farsi"
    },
    "هورفر": {
        "root": "farsi"
    },
    "هورمهر": {
        "root": "farsi"
    },
    "هورناز": {
        "root": "farsi"
    },
    "هوروش": {
        "root": "farsi"
    },
    "هوری": {
        "root": "farsi"
    },
    "هوزاد": {
        "root": "farsi"
    },
    "هوژین": {
        "root": "farsi"
    },
    "هوشبام": {
        "root": "farsi"
    },
    "هوگون": {
        "root": "farsi"
    },
    "هوما": {
        "root": "farsi"
    },
    "هومهر": {
        "root": "farsi"
    },
    "هونیا": {
        "root": "farsi"
    },
    "هوورشت": {
        "root": "farsi"
    },
    "هویار": {
        "root": "farsi"
    },
    "هیدیکا": {
        "root": "farsi"
    },
    "هیران": {
        "root": "farsi"
    },
    "هیزان": {
        "root": "farsi"
    },
    "هیژان": {
        "root": "farsi"
    },
    "هیلا": {
        "root": "farsi"
    },
    "هیلان": {
        "root": "farsi"
    },
    "هیلدا": {
        "root": "farsi"
    },
    "هیما": {
        "root": "farsi"
    },
    "هیمو": {
        "root": "farsi"
    },
    "هینا": {
        "root": "farsi"
    },
    "هینان": {
        "root": "farsi"
    },
    "هیوان": {
        "root": "farsi"
    },
    "یادمهر": {
        "root": "farsi"
    },
    "یارات": {
        "root": "farsi"
    },
    "یارگل": {
        "root": "farsi"
    },
    "یارناز": {
        "root": "farsi"
    },
    "یارنوش": {
        "root": "farsi"
    },
    "یاری": {
        "root": "farsi"
    },
    "یارین": {
        "root": "farsi"
    },
    "یاس": {
        "root": "farsi"
    },
    "یاسرخ": {
        "root": "farsi"
    },
    "یاسگل": {
        "root": "farsi"
    },
    "یاسما": {
        "root": "farsi"
    },
    "یاسمن": {
        "root": "farsi"
    },
    "یاسمین": {
        "root": "farsi"
    },
    "یاسمینا": {
        "root": "farsi"
    },
    "یاسینا": {
        "root": "farsi"
    },
    "یاشیل": {
        "root": "farsi"
    },
    "یافا": {
        "root": "farsi"
    },
    "یامور": {
        "root": "farsi"
    },
    "یامین": {
        "root": "farsi"
    },
    "یرحا": {
        "root": "farsi"
    },
    "یسرا": {
        "root": "farsi"
    },
    "یسری": {
        "root": "farsi"
    },
    "یسنا": {
        "root": "farsi"
    },
    "یسنی": {
        "root": "farsi"
    },
    "یغما": {
        "root": "farsi"
    },
    "یغماناز": {
        "root": "farsi"
    },
    "یکمال": {
        "root": "farsi"
    },
    "یکیتی": {
        "root": "farsi"
    },
    "یگانه": {
        "root": "farsi"
    },
    "یلدا": {
        "root": "farsi"
    },
    "یلدوز": {
        "root": "farsi"
    },
    "یمنا": {
        "root": "farsi"
    },
    "یوتاب": {
        "root": "farsi"
    },
    "یوکابد": {
        "root": "farsi"
    },
    "یولدوز": {
        "root": "farsi"
    }
}

const male = {
    "ابده": {
        "root": "farsi"
    },
    "ابیش": {
        "root": "farsi"
    },
    "اپروند": {
        "root": "farsi"
    },
    "اپرویژ": {
        "root": "farsi"
    },
    "اپیوه": {
        "root": "farsi"
    },
    "اترس": {
        "root": "farsi"
    },
    "ارتان": {
        "root": "farsi"
    },
    "ارشن": {
        "root": "farsi"
    },
    "ارشام": {
        "root": "farsi"
    },
    "ارشان": {
        "root": "farsi"
    },
    "اشوداد": {
        "root": "farsi"
    },
    "اگومان": {
        "root": "farsi"
    },
    "اوخشیا": {
        "root": "farsi"
    },
    "اورداد": {
        "root": "farsi"
    },
    "اورکام": {
        "root": "farsi"
    },
    "اهنود": {
        "root": "farsi"
    },
    "ازیرن": {
        "root": "farsi"
    },
    "اشهن": {
        "root": "farsi"
    },
    "اورنگ": {
        "root": "farsi"
    },
    "اوژن": {
        "root": "farsi"
    },
    "اباذر": {
        "root": "farsi"
    },
    "ابالفضل": {
        "root": "farsi"
    },
    "ابتهاج": {
        "root": "farsi"
    },
    "ابتهاش": {
        "root": "farsi"
    },
    "ابتین": {
        "root": "farsi"
    },
    "ابرارها": {
        "root": "farsi"
    },
    "ابراهیم": {
        "root": "farsi"
    },
    "ابوالحسن": {
        "root": "farsi"
    },
    "ابوالحسین": {
        "root": "farsi"
    },
    "ابوالعباس": {
        "root": "farsi"
    },
    "ابوالعلا": {
        "root": "farsi"
    },
    "ابوالفتح": {
        "root": "farsi"
    },
    "ابوالفرج": {
        "root": "farsi"
    },
    "ابوالفضل": {
        "root": "farsi"
    },
    "ابوالقاسم": {
        "root": "farsi"
    },
    "ابوبکر": {
        "root": "farsi"
    },
    "ابوذر": {
        "root": "farsi"
    },
    "ابوریحان": {
        "root": "farsi"
    },
    "ابوطالب": {
        "root": "farsi"
    },
    "ابوعزیز": {
        "root": "farsi"
    },
    "ابومسلم": {
        "root": "farsi"
    },
    "اپرنگ": {
        "root": "farsi"
    },
    "اپرویز": {
        "root": "farsi"
    },
    "اتبک": {
        "root": "farsi"
    },
    "اترک": {
        "root": "farsi"
    },
    "اترین": {
        "root": "farsi"
    },
    "اثیر": {
        "root": "farsi"
    },
    "اثیرالدین": {
        "root": "farsi"
    },
    "احتشام": {
        "root": "farsi"
    },
    "احد": {
        "root": "farsi"
    },
    "احسان": {
        "root": "farsi"
    },
    "احسانالله": {
        "root": "farsi"
    },
    "احمد": {
        "root": "farsi"
    },
    "احمدرضا": {
        "root": "farsi"
    },
    "احیا": {
        "root": "farsi"
    },
    "اختای": {
        "root": "farsi"
    },
    "اختیارالدین": {
        "root": "farsi"
    },
    "اخشاد": {
        "root": "farsi"
    },
    "اخشید": {
        "root": "farsi"
    },
    "ادریس": {
        "root": "farsi"
    },
    "ادنا": {
        "root": "farsi"
    },
    "ادهم": {
        "root": "farsi"
    },
    "ادیان": {
        "root": "farsi"
    },
    "ادیب": {
        "root": "farsi"
    },
    "اذرخش": {
        "root": "farsi"
    },
    "اراد": {
        "root": "farsi"
    },
    "اران": {
        "root": "farsi"
    },
    "ارباب": {
        "root": "farsi"
    },
    "ارباد": {
        "root": "farsi"
    },
    "ارباس": {
        "root": "farsi"
    },
    "اربیل": {
        "root": "farsi"
    },
    "ارتاآریا": {
        "root": "farsi"
    },
    "ارتاریا": {
        "root": "farsi"
    },
    "ارتافرین": {
        "root": "farsi"
    },
    "ارتگین": {
        "root": "farsi"
    },
    "ارتمن": {
        "root": "farsi"
    },
    "ارتنگ": {
        "root": "farsi"
    },
    "ارتیان": {
        "root": "farsi"
    },
    "ارتین": {
        "root": "farsi"
    },
    "ارج": {
        "root": "farsi"
    },
    "ارجاسب": {
        "root": "farsi"
    },
    "ارجاسپ": {
        "root": "farsi"
    },
    "ارجمند": {
        "root": "farsi"
    },
    "ارد": {
        "root": "farsi"
    },
    "اردا": {
        "root": "farsi"
    },
    "اردشام": {
        "root": "farsi"
    },
    "اردشیر": {
        "root": "farsi"
    },
    "اردلان": {
        "root": "farsi"
    },
    "اردم": {
        "root": "farsi"
    },
    "اردوان": {
        "root": "farsi"
    },
    "اردیداد": {
        "root": "farsi"
    },
    "اردیان": {
        "root": "farsi"
    },
    "اردین": {
        "root": "farsi"
    },
    "ارزین": {
        "root": "farsi"
    },
    "ارژن": {
        "root": "farsi"
    },
    "ارژنگ": {
        "root": "farsi"
    },
    "ارس": {
        "root": "farsi"
    },
    "ارسام": {
        "root": "farsi"
    },
    "ارسطو": {
        "root": "farsi"
    },
    "ارسلان": {
        "root": "farsi"
    },
    "ارسمان": {
        "root": "farsi"
    },
    "ارسن": {
        "root": "farsi"
    },
    "ارسیا": {
        "root": "farsi"
    },
    "ارسیما": {
        "root": "farsi"
    },
    "ارش": {
        "root": "farsi"
    },
    "ارشاد": {
        "root": "farsi"
    },
    "ارشاسب": {
        "root": "farsi"
    },
    "ارشاک": {
        "root": "farsi"
    },
    "ارشاویر": {
        "root": "farsi"
    },
    "ارشز": {
        "root": "farsi"
    },
    "ارشک": {
        "root": "farsi"
    },
    "ارشویر": {
        "root": "farsi"
    },
    "ارشیز": {
        "root": "farsi"
    },
    "ارغان": {
        "root": "farsi"
    },
    "ارغش": {
        "root": "farsi"
    },
    "ارفش": {
        "root": "farsi"
    },
    "ارفع": {
        "root": "farsi"
    },
    "ارکان": {
        "root": "farsi"
    },
    "ارکین": {
        "root": "farsi"
    },
    "ارماسب": {
        "root": "farsi"
    },
    "ارمان": {
        "root": "farsi"
    },
    "ارمانک": {
        "root": "farsi"
    },
    "ارمایل": {
        "root": "farsi"
    },
    "ارمیا": {
        "root": "farsi"
    },
    "ارمیس": {
        "root": "farsi"
    },
    "ارمین": {
        "root": "farsi"
    },
    "ارناک": {
        "root": "farsi"
    },
    "ارنوش": {
        "root": "farsi"
    },
    "ارواد": {
        "root": "farsi"
    },
    "اروتدنر": {
        "root": "farsi"
    },
    "اروند": {
        "root": "farsi"
    },
    "اریا": {
        "root": "farsi"
    },
    "اریاسب": {
        "root": "farsi"
    },
    "اریامن": {
        "root": "farsi"
    },
    "اریس": {
        "root": "farsi"
    },
    "ازدر": {
        "root": "farsi"
    },
    "اسامه": {
        "root": "farsi"
    },
    "اسپاد": {
        "root": "farsi"
    },
    "اسپنتمان": {
        "root": "farsi"
    },
    "اسپندیاد": {
        "root": "farsi"
    },
    "اسپندیار": {
        "root": "farsi"
    },
    "اسپهبد": {
        "root": "farsi"
    },
    "اسپیتامن": {
        "root": "farsi"
    },
    "اسپیتمن": {
        "root": "farsi"
    },
    "استاسیس": {
        "root": "farsi"
    },
    "استرا": {
        "root": "farsi"
    },
    "اسحاق": {
        "root": "farsi"
    },
    "اسحق": {
        "root": "farsi"
    },
    "اسد": {
        "root": "farsi"
    },
    "اسدالدین": {
        "root": "farsi"
    },
    "اسدالله": {
        "root": "farsi"
    },
    "اسرافیل": {
        "root": "farsi"
    },
    "اسعد": {
        "root": "farsi"
    },
    "اسفار": {
        "root": "farsi"
    },
    "اسفندیار": {
        "root": "farsi"
    },
    "اسکندر": {
        "root": "farsi"
    },
    "اسلام": {
        "root": "farsi"
    },
    "اسماعیل": {
        "root": "farsi"
    },
    "اسمعیل": {
        "root": "farsi"
    },
    "اشا": {
        "root": "farsi"
    },
    "اشاداد": {
        "root": "farsi"
    },
    "اشتاد": {
        "root": "farsi"
    },
    "اشراق": {
        "root": "farsi"
    },
    "اشرس": {
        "root": "farsi"
    },
    "اشرفالدین": {
        "root": "farsi"
    },
    "اشعیا": {
        "root": "farsi"
    },
    "اشکناز": {
        "root": "farsi"
    },
    "اشکان": {
        "root": "farsi"
    },
    "اشکبوس": {
        "root": "farsi"
    },
    "اشکش": {
        "root": "farsi"
    },
    "اشناس": {
        "root": "farsi"
    },
    "اشو": {
        "root": "farsi"
    },
    "اشوفروهر": {
        "root": "farsi"
    },
    "اشومنش": {
        "root": "farsi"
    },
    "اشیر": {
        "root": "farsi"
    },
    "اصغر": {
        "root": "farsi"
    },
    "اصلان": {
        "root": "farsi"
    },
    "اصیلالدین": {
        "root": "farsi"
    },
    "اعتبارعلی": {
        "root": "farsi"
    },
    "اعتماد": {
        "root": "farsi"
    },
    "اعلا": {
        "root": "farsi"
    },
    "اغریرث": {
        "root": "farsi"
    },
    "افتخارالدین": {
        "root": "farsi"
    },
    "افراسیاب": {
        "root": "farsi"
    },
    "افرود": {
        "root": "farsi"
    },
    "افریدون": {
        "root": "farsi"
    },
    "افشار": {
        "root": "farsi"
    },
    "افشین": {
        "root": "farsi"
    },
    "افضل": {
        "root": "farsi"
    },
    "افضلالدین": {
        "root": "farsi"
    },
    "افلاطون": {
        "root": "farsi"
    },
    "اقبال": {
        "root": "farsi"
    },
    "اقبالعلی": {
        "root": "farsi"
    },
    "اقشین": {
        "root": "farsi"
    },
    "اکبر": {
        "root": "farsi"
    },
    "اکتای": {
        "root": "farsi"
    },
    "اکدش": {
        "root": "farsi"
    },
    "اکلیا": {
        "root": "farsi"
    },
    "البتگین": {
        "root": "farsi"
    },
    "البرز": {
        "root": "farsi"
    },
    "الچین": {
        "root": "farsi"
    },
    "الدنیز": {
        "root": "farsi"
    },
    "الشن": {
        "root": "farsi"
    },
    "الکوس": {
        "root": "farsi"
    },
    "اللهیار": {
        "root": "farsi"
    },
    "الوند": {
        "root": "farsi"
    },
    "الیاد": {
        "root": "farsi"
    },
    "الیار": {
        "root": "farsi"
    },
    "الیاس": {
        "root": "farsi"
    },
    "الیان": {
        "root": "farsi"
    },
    "امامقلی": {
        "root": "farsi"
    },
    "امان": {
        "root": "farsi"
    },
    "امانالله": {
        "root": "farsi"
    },
    "امرسان": {
        "root": "farsi"
    },
    "امید": {
        "root": "farsi"
    },
    "امیدوار": {
        "root": "farsi"
    },
    "امیر": {
        "root": "farsi"
    },
    "امیرارسلان": {
        "root": "farsi"
    },
    "امیرپارسا": {
        "root": "farsi"
    },
    "امیرحافظ": {
        "root": "farsi"
    },
    "امیرحسین": {
        "root": "farsi"
    },
    "امیررضا": {
        "root": "farsi"
    },
    "امیرطاها": {
        "root": "farsi"
    },
    "امیرعباس": {
        "root": "farsi"
    },
    "امیرعلی": {
        "root": "farsi"
    },
    "امیرکسری": {
        "root": "farsi"
    },
    "امیرمحمد": {
        "root": "farsi"
    },
    "امیرمهدی": {
        "root": "farsi"
    },
    "امیرنظام": {
        "root": "farsi"
    },
    "امین": {
        "root": "farsi"
    },
    "امینالدین": {
        "root": "farsi"
    },
    "امینالله": {
        "root": "farsi"
    },
    "اندریمان": {
        "root": "farsi"
    },
    "اندمان": {
        "root": "farsi"
    },
    "اندی": {
        "root": "farsi"
    },
    "اندیان": {
        "root": "farsi"
    },
    "انوش": {
        "root": "farsi"
    },
    "انوشزاد": {
        "root": "farsi"
    },
    "انوشتکین": {
        "root": "farsi"
    },
    "انوشروان": {
        "root": "farsi"
    },
    "انوشیروان": {
        "root": "farsi"
    },
    "اوات": {
        "root": "farsi"
    },
    "اوتانا": {
        "root": "farsi"
    },
    "اوحد": {
        "root": "farsi"
    },
    "اوحدالدین": {
        "root": "farsi"
    },
    "اورمزد": {
        "root": "farsi"
    },
    "اورمزدیار": {
        "root": "farsi"
    },
    "اورند": {
        "root": "farsi"
    },
    "اوریا": {
        "root": "farsi"
    },
    "اوریاد": {
        "root": "farsi"
    },
    "اوس": {
        "root": "farsi"
    },
    "اوستا": {
        "root": "farsi"
    },
    "اوستانه": {
        "root": "farsi"
    },
    "اوشه": {
        "root": "farsi"
    },
    "اوشهنگ": {
        "root": "farsi"
    },
    "اوشیدر": {
        "root": "farsi"
    },
    "اوکتای": {
        "root": "farsi"
    },
    "اولاد": {
        "root": "farsi"
    },
    "اویس": {
        "root": "farsi"
    },
    "اهرن": {
        "root": "farsi"
    },
    "اهورا": {
        "root": "farsi"
    },
    "اهورامزدا": {
        "root": "farsi"
    },
    "اهوراداد": {
        "root": "farsi"
    },
    "اهورامزد": {
        "root": "farsi"
    },
    "ایاز": {
        "root": "farsi"
    },
    "ایبک": {
        "root": "farsi"
    },
    "ایتکین": {
        "root": "farsi"
    },
    "ایثار": {
        "root": "farsi"
    },
    "ایدون": {
        "root": "farsi"
    },
    "ایرانپناه": {
        "root": "farsi"
    },
    "ایرانپور": {
        "root": "farsi"
    },
    "ایرانشاه": {
        "root": "farsi"
    },
    "ایرج": {
        "root": "farsi"
    },
    "ایریک": {
        "root": "farsi"
    },
    "ایزد": {
        "root": "farsi"
    },
    "ایزدپناه": {
        "root": "farsi"
    },
    "ایزدبد": {
        "root": "farsi"
    },
    "ایزدداد": {
        "root": "farsi"
    },
    "ایزدگشسپ": {
        "root": "farsi"
    },
    "ایزدیار": {
        "root": "farsi"
    },
    "ایسدواستر": {
        "root": "farsi"
    },
    "ایشا": {
        "root": "farsi"
    },
    "ایلا": {
        "root": "farsi"
    },
    "ایلدرم": {
        "root": "farsi"
    },
    "ایلدیریم": {
        "root": "farsi"
    },
    "ایلکین": {
        "root": "farsi"
    },
    "ایلگار": {
        "root": "farsi"
    },
    "ایلماز": {
        "root": "farsi"
    },
    "ایلیا": {
        "root": "farsi"
    },
    "ایلیار": {
        "root": "farsi"
    },
    "ایلیاس": {
        "root": "farsi"
    },
    "ایمان": {
        "root": "farsi"
    },
    "ایوب": {
        "root": "farsi"
    },
    "ائلمان": {
        "root": "farsi"
    },
    "ائیریا": {
        "root": "farsi"
    },
    "آباد": {
        "root": "farsi"
    },
    "آبادان": {
        "root": "farsi"
    },
    "آبادیس": {
        "root": "farsi"
    },
    "آباریس": {
        "root": "farsi"
    },
    "آباقا": {
        "root": "farsi"
    },
    "آباگران": {
        "root": "farsi"
    },
    "آبان": {
        "root": "farsi"
    },
    "آبانزاد": {
        "root": "farsi"
    },
    "آبانیاد": {
        "root": "farsi"
    },
    "آبتین": {
        "root": "farsi"
    },
    "آبد": {
        "root": "farsi"
    },
    "آبدست": {
        "root": "farsi"
    },
    "آبدوس": {
        "root": "farsi"
    },
    "آبدین": {
        "root": "farsi"
    },
    "آبرام": {
        "root": "farsi"
    },
    "آبراهام": {
        "root": "farsi"
    },
    "آبرلی": {
        "root": "farsi"
    },
    "آبرو": {
        "root": "farsi"
    },
    "آبستا": {
        "root": "farsi"
    },
    "آبش": {
        "root": "farsi"
    },
    "آبکار": {
        "root": "farsi"
    },
    "آبلاتکا": {
        "root": "farsi"
    },
    "آبو": {
        "root": "farsi"
    },
    "آبی": {
        "root": "farsi"
    },
    "آبیار": {
        "root": "farsi"
    },
    "آپادا": {
        "root": "farsi"
    },
    "آپاداش": {
        "root": "farsi"
    },
    "آپاسای": {
        "root": "farsi"
    },
    "آپنیتا": {
        "root": "farsi"
    },
    "آتا": {
        "root": "farsi"
    },
    "آتاباللی": {
        "root": "farsi"
    },
    "آتابای": {
        "root": "farsi"
    },
    "آتابیک": {
        "root": "farsi"
    },
    "آتابیگ": {
        "root": "farsi"
    },
    "آتاقلیچ": {
        "root": "farsi"
    },
    "آتاگلدی": {
        "root": "farsi"
    },
    "آتامکین": {
        "root": "farsi"
    },
    "آتان": {
        "root": "farsi"
    },
    "آتجان": {
        "root": "farsi"
    },
    "آترابان": {
        "root": "farsi"
    },
    "آتربان": {
        "root": "farsi"
    },
    "آتردین": {
        "root": "farsi"
    },
    "آتروان": {
        "root": "farsi"
    },
    "آتروپات": {
        "root": "farsi"
    },
    "آترون": {
        "root": "farsi"
    },
    "آترینه": {
        "root": "farsi"
    },
    "آتسز": {
        "root": "farsi"
    },
    "آتشبرزین": {
        "root": "farsi"
    },
    "آتشپا": {
        "root": "farsi"
    },
    "آتشبان": {
        "root": "farsi"
    },
    "آتشزاد": {
        "root": "farsi"
    },
    "آتشکار": {
        "root": "farsi"
    },
    "آتمش": {
        "root": "farsi"
    },
    "آتورپات": {
        "root": "farsi"
    },
    "آتیال": {
        "root": "farsi"
    },
    "آتیتی": {
        "root": "farsi"
    },
    "آتیجی": {
        "root": "farsi"
    },
    "آتیلا": {
        "root": "farsi"
    },
    "آتین": {
        "root": "farsi"
    },
    "آثویه": {
        "root": "farsi"
    },
    "آجیر": {
        "root": "farsi"
    },
    "آچیم": {
        "root": "farsi"
    },
    "آخش": {
        "root": "farsi"
    },
    "آخشیج": {
        "root": "farsi"
    },
    "آدر": {
        "root": "farsi"
    },
    "آدرباد": {
        "root": "farsi"
    },
    "آداد": {
        "root": "farsi"
    },
    "آدارایل": {
        "root": "farsi"
    },
    "آداش": {
        "root": "farsi"
    },
    "آدان": {
        "root": "farsi"
    },
    "آدبهاوا": {
        "root": "farsi"
    },
    "آدخ": {
        "root": "farsi"
    },
    "آدریان": {
        "root": "farsi"
    },
    "آدریانوس": {
        "root": "farsi"
    },
    "آدرین": {
        "root": "farsi"
    },
    "آدلی": {
        "root": "farsi"
    },
    "آدم": {
        "root": "farsi"
    },
    "آدورا": {
        "root": "farsi"
    },
    "آدهاوا": {
        "root": "farsi"
    },
    "آدی": {
        "root": "farsi"
    },
    "آدیش": {
        "root": "farsi"
    },
    "آدیگوزل": {
        "root": "farsi"
    },
    "آدین": {
        "root": "farsi"
    },
    "آدینگ": {
        "root": "farsi"
    },
    "آذربرزین": {
        "root": "farsi"
    },
    "آذران": {
        "root": "farsi"
    },
    "آذراوغلی": {
        "root": "farsi"
    },
    "آذرآیین": {
        "root": "farsi"
    },
    "آذربد": {
        "root": "farsi"
    },
    "آذربابا": {
        "root": "farsi"
    },
    "آذرباد": {
        "root": "farsi"
    },
    "آذربان": {
        "root": "farsi"
    },
    "آذربود": {
        "root": "farsi"
    },
    "آذربه": {
        "root": "farsi"
    },
    "آذربهرام": {
        "root": "farsi"
    },
    "آذرپژوه": {
        "root": "farsi"
    },
    "آذرپاد": {
        "root": "farsi"
    },
    "آذرپناه": {
        "root": "farsi"
    },
    "آذرپی": {
        "root": "farsi"
    },
    "آذرتاش": {
        "root": "farsi"
    },
    "آذرتوس": {
        "root": "farsi"
    },
    "آذرجوش": {
        "root": "farsi"
    },
    "آذرداد": {
        "root": "farsi"
    },
    "آذرشب": {
        "root": "farsi"
    },
    "آذرشسب": {
        "root": "farsi"
    },
    "آذرشن": {
        "root": "farsi"
    },
    "آذرطوس": {
        "root": "farsi"
    },
    "آذرفر": {
        "root": "farsi"
    },
    "آذرفرنبغ": {
        "root": "farsi"
    },
    "آذرکار": {
        "root": "farsi"
    },
    "آذرکیش": {
        "root": "farsi"
    },
    "آذرکیوان": {
        "root": "farsi"
    },
    "آذرگشسب": {
        "root": "farsi"
    },
    "آذرگشسپ": {
        "root": "farsi"
    },
    "آذرماهان": {
        "root": "farsi"
    },
    "آذرمهربرزین": {
        "root": "farsi"
    },
    "آذرنرسی": {
        "root": "farsi"
    },
    "آذرنگ": {
        "root": "farsi"
    },
    "آذروان": {
        "root": "farsi"
    },
    "آذینفر": {
        "root": "farsi"
    },
    "آراج": {
        "root": "farsi"
    },
    "آراد": {
        "root": "farsi"
    },
    "آرارات": {
        "root": "farsi"
    },
    "آراز": {
        "root": "farsi"
    },
    "آرازش": {
        "root": "farsi"
    },
    "آراس": {
        "root": "farsi"
    },
    "آران": {
        "root": "farsi"
    },
    "آرپان": {
        "root": "farsi"
    },
    "آرتاباز": {
        "root": "farsi"
    },
    "آرتابان": {
        "root": "farsi"
    },
    "آرتاپارت": {
        "root": "farsi"
    },
    "آرتان": {
        "root": "farsi"
    },
    "آرتمن": {
        "root": "farsi"
    },
    "آرتوان": {
        "root": "farsi"
    },
    "آرتیمان": {
        "root": "farsi"
    },
    "آرتین": {
        "root": "farsi"
    },
    "آرخا": {
        "root": "farsi"
    },
    "آردا": {
        "root": "farsi"
    },
    "آردین": {
        "root": "farsi"
    },
    "آرسام": {
        "root": "farsi"
    },
    "آرسان": {
        "root": "farsi"
    },
    "آرسن": {
        "root": "farsi"
    },
    "آرسین": {
        "root": "farsi"
    },
    "آرش": {
        "root": "farsi"
    },
    "آرشا": {
        "root": "farsi"
    },
    "آرشاک": {
        "root": "farsi"
    },
    "آرشام": {
        "root": "farsi"
    },
    "آرشامه": {
        "root": "farsi"
    },
    "آرشان": {
        "root": "farsi"
    },
    "آرشاویر": {
        "root": "farsi"
    },
    "آرکا": {
        "root": "farsi"
    },
    "آرمان": {
        "root": "farsi"
    },
    "آرمناک": {
        "root": "farsi"
    },
    "آرمیا": {
        "root": "farsi"
    },
    "آرمین": {
        "root": "farsi"
    },
    "آرمینی": {
        "root": "farsi"
    },
    "آرنا": {
        "root": "farsi"
    },
    "آروکو": {
        "root": "farsi"
    },
    "آرویج": {
        "root": "farsi"
    },
    "آروین": {
        "root": "farsi"
    },
    "آری": {
        "root": "farsi"
    },
    "آریا": {
        "root": "farsi"
    },
    "آریاباد": {
        "root": "farsi"
    },
    "آریابان": {
        "root": "farsi"
    },
    "آریابد": {
        "root": "farsi"
    },
    "آریابرز": {
        "root": "farsi"
    },
    "آریاراد": {
        "root": "farsi"
    },
    "آریارامنه": {
        "root": "farsi"
    },
    "آریارمن": {
        "root": "farsi"
    },
    "آریاز": {
        "root": "farsi"
    },
    "آریاسب": {
        "root": "farsi"
    },
    "آریافر": {
        "root": "farsi"
    },
    "آریاک": {
        "root": "farsi"
    },
    "آریاگیو": {
        "root": "farsi"
    },
    "آریامن": {
        "root": "farsi"
    },
    "آریامنش": {
        "root": "farsi"
    },
    "آریامهر": {
        "root": "farsi"
    },
    "آریتما": {
        "root": "farsi"
    },
    "آریز": {
        "root": "farsi"
    },
    "آریس": {
        "root": "farsi"
    },
    "آریسته": {
        "root": "farsi"
    },
    "آرین": {
        "root": "farsi"
    },
    "آریو": {
        "root": "farsi"
    },
    "آریوبرزن": {
        "root": "farsi"
    },
    "آریوبرزین": {
        "root": "farsi"
    },
    "آریوداد": {
        "root": "farsi"
    },
    "آریوراد": {
        "root": "farsi"
    },
    "آریه": {
        "root": "farsi"
    },
    "آزا": {
        "root": "farsi"
    },
    "آزاد": {
        "root": "farsi"
    },
    "آزادمنش": {
        "root": "farsi"
    },
    "آزادبه": {
        "root": "farsi"
    },
    "آزادسرو": {
        "root": "farsi"
    },
    "آزادفروز": {
        "root": "farsi"
    },
    "آزادمهر": {
        "root": "farsi"
    },
    "آزر": {
        "root": "farsi"
    },
    "آزران": {
        "root": "farsi"
    },
    "آزرمگان": {
        "root": "farsi"
    },
    "آژمان": {
        "root": "farsi"
    },
    "آژنگ": {
        "root": "farsi"
    },
    "آسام": {
        "root": "farsi"
    },
    "آسایش": {
        "root": "farsi"
    },
    "آسپاداس": {
        "root": "farsi"
    },
    "آسپیان": {
        "root": "farsi"
    },
    "آستیاژ": {
        "root": "farsi"
    },
    "آستیاک": {
        "root": "farsi"
    },
    "آسدین": {
        "root": "farsi"
    },
    "آسیدات": {
        "root": "farsi"
    },
    "آسیداد": {
        "root": "farsi"
    },
    "آشر": {
        "root": "farsi"
    },
    "آشور": {
        "root": "farsi"
    },
    "آشینا": {
        "root": "farsi"
    },
    "آصف": {
        "root": "farsi"
    },
    "آفریدون": {
        "root": "farsi"
    },
    "آقاجان": {
        "root": "farsi"
    },
    "آقاگل": {
        "root": "farsi"
    },
    "آقامیر": {
        "root": "farsi"
    },
    "آکام": {
        "root": "farsi"
    },
    "آکو": {
        "root": "farsi"
    },
    "آگا": {
        "root": "farsi"
    },
    "آلب": {
        "root": "farsi"
    },
    "آلبارسلان": {
        "root": "farsi"
    },
    "آلبتکین": {
        "root": "farsi"
    },
    "آلپارسلان": {
        "root": "farsi"
    },
    "آلپتکین": {
        "root": "farsi"
    },
    "آلتونتاش": {
        "root": "farsi"
    },
    "آلیا": {
        "root": "farsi"
    },
    "آمانج": {
        "root": "farsi"
    },
    "آماندا": {
        "root": "farsi"
    },
    "آمنید": {
        "root": "farsi"
    },
    "آموی": {
        "root": "farsi"
    },
    "آمین": {
        "root": "farsi"
    },
    "آناگ": {
        "root": "farsi"
    },
    "آنتیگون": {
        "root": "farsi"
    },
    "آنوشه": {
        "root": "farsi"
    },
    "آنیل": {
        "root": "farsi"
    },
    "آوگان": {
        "root": "farsi"
    },
    "آوه": {
        "root": "farsi"
    },
    "آویر": {
        "root": "farsi"
    },
    "آهیر": {
        "root": "farsi"
    },
    "آهیل": {
        "root": "farsi"
    },
    "آهین": {
        "root": "farsi"
    },
    "آیبک": {
        "root": "farsi"
    },
    "آیت": {
        "root": "farsi"
    },
    "آیتالله": {
        "root": "farsi"
    },
    "آیتاش": {
        "root": "farsi"
    },
    "آیتغمش": {
        "root": "farsi"
    },
    "آیتکین": {
        "root": "farsi"
    },
    "آیتونا": {
        "root": "farsi"
    },
    "آیخان": {
        "root": "farsi"
    },
    "آیدین": {
        "root": "farsi"
    },
    "آیریک": {
        "root": "farsi"
    },
    "آیقان": {
        "root": "farsi"
    },
    "آیکان": {
        "root": "farsi"
    },
    "آیهان": {
        "root": "farsi"
    },
    "آیینگشسب": {
        "root": "farsi"
    },
    "آئیل": {
        "root": "farsi"
    },
    "بخشا": {
        "root": "farsi"
    },
    "بدخشان": {
        "root": "farsi"
    },
    "برسم": {
        "root": "farsi"
    },
    "برشنوم": {
        "root": "farsi"
    },
    "برازمان": {
        "root": "farsi"
    },
    "بردیا": {
        "root": "farsi"
    },
    "برسام": {
        "root": "farsi"
    },
    "برمک": {
        "root": "farsi"
    },
    "بگاداد": {
        "root": "farsi"
    },
    "بگاش": {
        "root": "farsi"
    },
    "بهاوند": {
        "root": "farsi"
    },
    "بهرامشاه": {
        "root": "farsi"
    },
    "برزو": {
        "root": "farsi"
    },
    "برزویه": {
        "root": "farsi"
    },
    "بزرگمهر": {
        "root": "farsi"
    },
    "بندار": {
        "root": "farsi"
    },
    "بنشاد": {
        "root": "farsi"
    },
    "بهراد": {
        "root": "farsi"
    },
    "بهروز": {
        "root": "farsi"
    },
    "بهمرد": {
        "root": "farsi"
    },
    "بابا": {
        "root": "farsi"
    },
    "بابر": {
        "root": "farsi"
    },
    "بابک": {
        "root": "farsi"
    },
    "بابوی": {
        "root": "farsi"
    },
    "بابیک": {
        "root": "farsi"
    },
    "باپوک": {
        "root": "farsi"
    },
    "باپیر": {
        "root": "farsi"
    },
    "باتیس": {
        "root": "farsi"
    },
    "بادان": {
        "root": "farsi"
    },
    "بادرام": {
        "root": "farsi"
    },
    "بادلیس": {
        "root": "farsi"
    },
    "بادینان": {
        "root": "farsi"
    },
    "باذان": {
        "root": "farsi"
    },
    "باراد": {
        "root": "farsi"
    },
    "باربد": {
        "root": "farsi"
    },
    "بارسین": {
        "root": "farsi"
    },
    "بارشین": {
        "root": "farsi"
    },
    "بارمان": {
        "root": "farsi"
    },
    "باریسان": {
        "root": "farsi"
    },
    "باریکان": {
        "root": "farsi"
    },
    "بازبان": {
        "root": "farsi"
    },
    "بازیار": {
        "root": "farsi"
    },
    "بازیان": {
        "root": "farsi"
    },
    "باژار": {
        "root": "farsi"
    },
    "باژه": {
        "root": "farsi"
    },
    "باسام": {
        "root": "farsi"
    },
    "باستان": {
        "root": "farsi"
    },
    "باسکان": {
        "root": "farsi"
    },
    "باشار": {
        "root": "farsi"
    },
    "باشو": {
        "root": "farsi"
    },
    "باشوان": {
        "root": "farsi"
    },
    "باشور": {
        "root": "farsi"
    },
    "باشوک": {
        "root": "farsi"
    },
    "باغبان": {
        "root": "farsi"
    },
    "باقر": {
        "root": "farsi"
    },
    "باکور": {
        "root": "farsi"
    },
    "باگه": {
        "root": "farsi"
    },
    "بالا": {
        "root": "farsi"
    },
    "بالاچ": {
        "root": "farsi"
    },
    "بالبان": {
        "root": "farsi"
    },
    "بالک": {
        "root": "farsi"
    },
    "بالوی": {
        "root": "farsi"
    },
    "بالویز": {
        "root": "farsi"
    },
    "بامداد": {
        "root": "farsi"
    },
    "بامشاد": {
        "root": "farsi"
    },
    "بامگاه": {
        "root": "farsi"
    },
    "بانگ": {
        "root": "farsi"
    },
    "بانی": {
        "root": "farsi"
    },
    "بانیپال": {
        "root": "farsi"
    },
    "باوا": {
        "root": "farsi"
    },
    "باهرام": {
        "root": "farsi"
    },
    "باهک": {
        "root": "farsi"
    },
    "باهنر": {
        "root": "farsi"
    },
    "باهوز": {
        "root": "farsi"
    },
    "باهیف": {
        "root": "farsi"
    },
    "بایا": {
        "root": "farsi"
    },
    "بایتگین": {
        "root": "farsi"
    },
    "بایرام": {
        "root": "farsi"
    },
    "بایزید": {
        "root": "farsi"
    },
    "بایف": {
        "root": "farsi"
    },
    "بایگان": {
        "root": "farsi"
    },
    "ببک": {
        "root": "farsi"
    },
    "بتام": {
        "root": "farsi"
    },
    "بتاو": {
        "root": "farsi"
    },
    "بثریک": {
        "root": "farsi"
    },
    "بجرگ": {
        "root": "farsi"
    },
    "بحیرا": {
        "root": "farsi"
    },
    "بختآفرین": {
        "root": "farsi"
    },
    "بختیار": {
        "root": "farsi"
    },
    "بختیاری": {
        "root": "farsi"
    },
    "بخشعلی": {
        "root": "farsi"
    },
    "بخشان": {
        "root": "farsi"
    },
    "بخشینر": {
        "root": "farsi"
    },
    "بدرالدین": {
        "root": "farsi"
    },
    "بدره": {
        "root": "farsi"
    },
    "بدیعالزمان": {
        "root": "farsi"
    },
    "برات": {
        "root": "farsi"
    },
    "براخاس": {
        "root": "farsi"
    },
    "براخاص": {
        "root": "farsi"
    },
    "برادر": {
        "root": "farsi"
    },
    "برادوست": {
        "root": "farsi"
    },
    "برام": {
        "root": "farsi"
    },
    "برانوش": {
        "root": "farsi"
    },
    "براو": {
        "root": "farsi"
    },
    "براهام": {
        "root": "farsi"
    },
    "براهیم": {
        "root": "farsi"
    },
    "برآلین": {
        "root": "farsi"
    },
    "برپرس": {
        "root": "farsi"
    },
    "برتاو": {
        "root": "farsi"
    },
    "برتن": {
        "root": "farsi"
    },
    "برته": {
        "root": "farsi"
    },
    "برجاسپ": {
        "root": "farsi"
    },
    "برچاو": {
        "root": "farsi"
    },
    "برداش": {
        "root": "farsi"
    },
    "بردان": {
        "root": "farsi"
    },
    "بردل": {
        "root": "farsi"
    },
    "بردیس": {
        "root": "farsi"
    },
    "برز": {
        "root": "farsi"
    },
    "برزام": {
        "root": "farsi"
    },
    "برزان": {
        "root": "farsi"
    },
    "برزاو": {
        "root": "farsi"
    },
    "برزآذر": {
        "root": "farsi"
    },
    "برزآفرین": {
        "root": "farsi"
    },
    "برزفر": {
        "root": "farsi"
    },
    "برزفری": {
        "root": "farsi"
    },
    "برزما": {
        "root": "farsi"
    },
    "برزمند": {
        "root": "farsi"
    },
    "برزمهر": {
        "root": "farsi"
    },
    "برزن": {
        "root": "farsi"
    },
    "برزهم": {
        "root": "farsi"
    },
    "برزینداد": {
        "root": "farsi"
    },
    "برزینمهر": {
        "root": "farsi"
    },
    "برسیان": {
        "root": "farsi"
    },
    "برشان": {
        "root": "farsi"
    },
    "برکاو": {
        "root": "farsi"
    },
    "برکو": {
        "root": "farsi"
    },
    "برگش": {
        "root": "farsi"
    },
    "برمال": {
        "root": "farsi"
    },
    "برمایون": {
        "root": "farsi"
    },
    "برنوش": {
        "root": "farsi"
    },
    "بروا": {
        "root": "farsi"
    },
    "بروار": {
        "root": "farsi"
    },
    "بروان": {
        "root": "farsi"
    },
    "بروز": {
        "root": "farsi"
    },
    "بروسکان": {
        "root": "farsi"
    },
    "بروسکه": {
        "root": "farsi"
    },
    "برومند": {
        "root": "farsi"
    },
    "برهان": {
        "root": "farsi"
    },
    "برهانالدین": {
        "root": "farsi"
    },
    "برهم": {
        "root": "farsi"
    },
    "برهمن": {
        "root": "farsi"
    },
    "برهمند": {
        "root": "farsi"
    },
    "بریان": {
        "root": "farsi"
    },
    "بریز": {
        "root": "farsi"
    },
    "بریسکه": {
        "root": "farsi"
    },
    "بریکار": {
        "root": "farsi"
    },
    "برین": {
        "root": "farsi"
    },
    "بریندار": {
        "root": "farsi"
    },
    "بزرجمهر": {
        "root": "farsi"
    },
    "بزرگ": {
        "root": "farsi"
    },
    "بزرگامید": {
        "root": "farsi"
    },
    "بزوتنوه": {
        "root": "farsi"
    },
    "بزوین": {
        "root": "farsi"
    },
    "بژار": {
        "root": "farsi"
    },
    "بسام": {
        "root": "farsi"
    },
    "بستک": {
        "root": "farsi"
    },
    "بستور": {
        "root": "farsi"
    },
    "بستیر": {
        "root": "farsi"
    },
    "بسود": {
        "root": "farsi"
    },
    "بسوز": {
        "root": "farsi"
    },
    "بسیم": {
        "root": "farsi"
    },
    "بسیه": {
        "root": "farsi"
    },
    "بشتاسب": {
        "root": "farsi"
    },
    "بشیر": {
        "root": "farsi"
    },
    "بصیر": {
        "root": "farsi"
    },
    "بغرا": {
        "root": "farsi"
    },
    "بکتاش": {
        "root": "farsi"
    },
    "بکیاش": {
        "root": "farsi"
    },
    "بلاش": {
        "root": "farsi"
    },
    "بلاشان": {
        "root": "farsi"
    },
    "بلال": {
        "root": "farsi"
    },
    "بلباس": {
        "root": "farsi"
    },
    "بلویر": {
        "root": "farsi"
    },
    "بلیمت": {
        "root": "farsi"
    },
    "بمانعلی": {
        "root": "farsi"
    },
    "بنار": {
        "root": "farsi"
    },
    "بنجامین": {
        "root": "farsi"
    },
    "بندن": {
        "root": "farsi"
    },
    "بندوی": {
        "root": "farsi"
    },
    "بنیامین": {
        "root": "farsi"
    },
    "بوار": {
        "root": "farsi"
    },
    "بوبار": {
        "root": "farsi"
    },
    "بوبان": {
        "root": "farsi"
    },
    "بوپار": {
        "root": "farsi"
    },
    "بوتان": {
        "root": "farsi"
    },
    "بوجه": {
        "root": "farsi"
    },
    "بوخشا": {
        "root": "farsi"
    },
    "بودیان": {
        "root": "farsi"
    },
    "بوذر": {
        "root": "farsi"
    },
    "بوذرجمهر": {
        "root": "farsi"
    },
    "بوراب": {
        "root": "farsi"
    },
    "بورباش": {
        "root": "farsi"
    },
    "بورژک": {
        "root": "farsi"
    },
    "بورنگ": {
        "root": "farsi"
    },
    "بوزرجمهر": {
        "root": "farsi"
    },
    "بوژان": {
        "root": "farsi"
    },
    "بوستانافروز": {
        "root": "farsi"
    },
    "بوسیان": {
        "root": "farsi"
    },
    "بهآذین": {
        "root": "farsi"
    },
    "بهآئین": {
        "root": "farsi"
    },
    "بهیزداد": {
        "root": "farsi"
    },
    "بها": {
        "root": "farsi"
    },
    "بهاالدین": {
        "root": "farsi"
    },
    "بهادر": {
        "root": "farsi"
    },
    "بهامد": {
        "root": "farsi"
    },
    "بهبد": {
        "root": "farsi"
    },
    "بهبود": {
        "root": "farsi"
    },
    "بهپور": {
        "root": "farsi"
    },
    "بهتاش": {
        "root": "farsi"
    },
    "بهجت": {
        "root": "farsi"
    },
    "بهداد": {
        "root": "farsi"
    },
    "بهداور": {
        "root": "farsi"
    },
    "بهدین": {
        "root": "farsi"
    },
    "بهرام": {
        "root": "farsi"
    },
    "بهرنگ": {
        "root": "farsi"
    },
    "بهروش": {
        "root": "farsi"
    },
    "بهزاد": {
        "root": "farsi"
    },
    "بهزادان": {
        "root": "farsi"
    },
    "بهستان": {
        "root": "farsi"
    },
    "بهستون": {
        "root": "farsi"
    },
    "بهسود": {
        "root": "farsi"
    },
    "بهسودان": {
        "root": "farsi"
    },
    "بهشاد": {
        "root": "farsi"
    },
    "بهفام": {
        "root": "farsi"
    },
    "بهک": {
        "root": "farsi"
    },
    "بهلول": {
        "root": "farsi"
    },
    "بهمن": {
        "root": "farsi"
    },
    "بهمنداد": {
        "root": "farsi"
    },
    "بهمنش": {
        "root": "farsi"
    },
    "بهمنیار": {
        "root": "farsi"
    },
    "بهنام": {
        "root": "farsi"
    },
    "بهنود": {
        "root": "farsi"
    },
    "بهنیا": {
        "root": "farsi"
    },
    "بهوران": {
        "root": "farsi"
    },
    "بهیز": {
        "root": "farsi"
    },
    "بیبش": {
        "root": "farsi"
    },
    "بیارش": {
        "root": "farsi"
    },
    "بیاره": {
        "root": "farsi"
    },
    "بیباک": {
        "root": "farsi"
    },
    "بیتاوان": {
        "root": "farsi"
    },
    "بیتخش": {
        "root": "farsi"
    },
    "بیتک": {
        "root": "farsi"
    },
    "بیرام": {
        "root": "farsi"
    },
    "بیرشاد": {
        "root": "farsi"
    },
    "بیرگا": {
        "root": "farsi"
    },
    "بیرور": {
        "root": "farsi"
    },
    "بیزار": {
        "root": "farsi"
    },
    "بیژن": {
        "root": "farsi"
    },
    "بیساران": {
        "root": "farsi"
    },
    "بیستون": {
        "root": "farsi"
    },
    "بیکس": {
        "root": "farsi"
    },
    "بیلاش": {
        "root": "farsi"
    },
    "بینر": {
        "root": "farsi"
    },
    "بیورد": {
        "root": "farsi"
    },
    "بیورزاد": {
        "root": "farsi"
    },
    "پتهمانی": {
        "root": "farsi"
    },
    "پرنگ": {
        "root": "farsi"
    },
    "پریبرز": {
        "root": "farsi"
    },
    "پشنگ": {
        "root": "farsi"
    },
    "پاپریک": {
        "root": "farsi"
    },
    "پاتیرا": {
        "root": "farsi"
    },
    "پادار": {
        "root": "farsi"
    },
    "پاداشت": {
        "root": "farsi"
    },
    "پادرا": {
        "root": "farsi"
    },
    "پادشا": {
        "root": "farsi"
    },
    "پاردیک": {
        "root": "farsi"
    },
    "پارس": {
        "root": "farsi"
    },
    "پارسا": {
        "root": "farsi"
    },
    "پارسان": {
        "root": "farsi"
    },
    "پارسوا": {
        "root": "farsi"
    },
    "پارسیا": {
        "root": "farsi"
    },
    "پارسیس": {
        "root": "farsi"
    },
    "پارهوان": {
        "root": "farsi"
    },
    "پارهیار": {
        "root": "farsi"
    },
    "پاساک": {
        "root": "farsi"
    },
    "پاسدار": {
        "root": "farsi"
    },
    "پاشا": {
        "root": "farsi"
    },
    "پاکان": {
        "root": "farsi"
    },
    "پاکر": {
        "root": "farsi"
    },
    "پاکروان": {
        "root": "farsi"
    },
    "پاکزاد": {
        "root": "farsi"
    },
    "پاکمهر": {
        "root": "farsi"
    },
    "پاو": {
        "root": "farsi"
    },
    "پایا": {
        "root": "farsi"
    },
    "پایار": {
        "root": "farsi"
    },
    "پدرام": {
        "root": "farsi"
    },
    "پراهام": {
        "root": "farsi"
    },
    "پرچم": {
        "root": "farsi"
    },
    "پرداد": {
        "root": "farsi"
    },
    "پرشان": {
        "root": "farsi"
    },
    "پرشیا": {
        "root": "farsi"
    },
    "پرمایه": {
        "root": "farsi"
    },
    "پرمودیه": {
        "root": "farsi"
    },
    "پرویز": {
        "root": "farsi"
    },
    "پرهام": {
        "root": "farsi"
    },
    "پرهان": {
        "root": "farsi"
    },
    "پریام": {
        "root": "farsi"
    },
    "پژدو": {
        "root": "farsi"
    },
    "پژمان": {
        "root": "farsi"
    },
    "پژند": {
        "root": "farsi"
    },
    "پساک": {
        "root": "farsi"
    },
    "پسندیار": {
        "root": "farsi"
    },
    "پشتیسار": {
        "root": "farsi"
    },
    "پشن": {
        "root": "farsi"
    },
    "پشوتن": {
        "root": "farsi"
    },
    "پشین": {
        "root": "farsi"
    },
    "پلاش": {
        "root": "farsi"
    },
    "پلاشان": {
        "root": "farsi"
    },
    "پنجعلی": {
        "root": "farsi"
    },
    "پندار": {
        "root": "farsi"
    },
    "پوربه": {
        "root": "farsi"
    },
    "پورشسب": {
        "root": "farsi"
    },
    "پورک": {
        "root": "farsi"
    },
    "پورنگ": {
        "root": "farsi"
    },
    "پوروشسب": {
        "root": "farsi"
    },
    "پوریا": {
        "root": "farsi"
    },
    "پوریار": {
        "root": "farsi"
    },
    "پوژمان": {
        "root": "farsi"
    },
    "پولا": {
        "root": "farsi"
    },
    "پولاد": {
        "root": "farsi"
    },
    "پویا": {
        "root": "farsi"
    },
    "پویان": {
        "root": "farsi"
    },
    "پویین": {
        "root": "farsi"
    },
    "پهلبد": {
        "root": "farsi"
    },
    "پیام": {
        "root": "farsi"
    },
    "پیداگشسب": {
        "root": "farsi"
    },
    "پیران": {
        "root": "farsi"
    },
    "پیرداد": {
        "root": "farsi"
    },
    "پیروز": {
        "root": "farsi"
    },
    "پیروزان": {
        "root": "farsi"
    },
    "پیروزگر": {
        "root": "farsi"
    },
    "پیروزی": {
        "root": "farsi"
    },
    "پیشداد": {
        "root": "farsi"
    },
    "پیکان": {
        "root": "farsi"
    },
    "پیلتن": {
        "root": "farsi"
    },
    "پیلسم": {
        "root": "farsi"
    },
    "پیمان": {
        "root": "farsi"
    },
    "تسو": {
        "root": "farsi"
    },
    "تنسر": {
        "root": "farsi"
    },
    "تهمتن": {
        "root": "farsi"
    },
    "تابال": {
        "root": "farsi"
    },
    "تاجالدین": {
        "root": "farsi"
    },
    "تاجبخش": {
        "root": "farsi"
    },
    "تاجیک": {
        "root": "farsi"
    },
    "تارح": {
        "root": "farsi"
    },
    "تارخ": {
        "root": "farsi"
    },
    "تباک": {
        "root": "farsi"
    },
    "تخار": {
        "root": "farsi"
    },
    "تخشا": {
        "root": "farsi"
    },
    "تخواره": {
        "root": "farsi"
    },
    "تراب": {
        "root": "farsi"
    },
    "ترخان": {
        "root": "farsi"
    },
    "تژاو": {
        "root": "farsi"
    },
    "تقدیر": {
        "root": "farsi"
    },
    "تقی": {
        "root": "farsi"
    },
    "تکآفرین": {
        "root": "farsi"
    },
    "تکاپو": {
        "root": "farsi"
    },
    "تکاور": {
        "root": "farsi"
    },
    "تکتا": {
        "root": "farsi"
    },
    "تکش": {
        "root": "farsi"
    },
    "تکین": {
        "root": "farsi"
    },
    "تگین": {
        "root": "farsi"
    },
    "تلیمان": {
        "root": "farsi"
    },
    "توان": {
        "root": "farsi"
    },
    "توانا": {
        "root": "farsi"
    },
    "توانایی": {
        "root": "farsi"
    },
    "توحید": {
        "root": "farsi"
    },
    "تور": {
        "root": "farsi"
    },
    "تورال": {
        "root": "farsi"
    },
    "تورج": {
        "root": "farsi"
    },
    "تورک": {
        "root": "farsi"
    },
    "تورنگ": {
        "root": "farsi"
    },
    "توس": {
        "root": "farsi"
    },
    "توسن": {
        "root": "farsi"
    },
    "توفیق": {
        "root": "farsi"
    },
    "توما": {
        "root": "farsi"
    },
    "تهم": {
        "root": "farsi"
    },
    "تهماسب": {
        "root": "farsi"
    },
    "تهمورث": {
        "root": "farsi"
    },
    "تهمورس": {
        "root": "farsi"
    },
    "تهمین": {
        "root": "farsi"
    },
    "تیران": {
        "root": "farsi"
    },
    "تیرداد": {
        "root": "farsi"
    },
    "تیس": {
        "root": "farsi"
    },
    "تیگران": {
        "root": "farsi"
    },
    "تیماس": {
        "root": "farsi"
    },
    "تیمور": {
        "root": "farsi"
    },
    "تیمورتاش": {
        "root": "farsi"
    },
    "ثابت": {
        "root": "farsi"
    },
    "ثاقب": {
        "root": "farsi"
    },
    "ثامر": {
        "root": "farsi"
    },
    "ثواب": {
        "root": "farsi"
    },
    "جابان": {
        "root": "farsi"
    },
    "جابر": {
        "root": "farsi"
    },
    "جادی": {
        "root": "farsi"
    },
    "جارالله": {
        "root": "farsi"
    },
    "جاسم": {
        "root": "farsi"
    },
    "جالینوس": {
        "root": "farsi"
    },
    "جاماسب": {
        "root": "farsi"
    },
    "جاماسپ": {
        "root": "farsi"
    },
    "جامشید": {
        "root": "farsi"
    },
    "جانافروز": {
        "root": "farsi"
    },
    "جانافزا": {
        "root": "farsi"
    },
    "جانبخشان": {
        "root": "farsi"
    },
    "جانپرور": {
        "root": "farsi"
    },
    "جانمحمد": {
        "root": "farsi"
    },
    "جانان": {
        "root": "farsi"
    },
    "جانعلی": {
        "root": "farsi"
    },
    "جانلی": {
        "root": "farsi"
    },
    "جانوسیار": {
        "root": "farsi"
    },
    "جانوشیار": {
        "root": "farsi"
    },
    "جانی": {
        "root": "farsi"
    },
    "جانیار": {
        "root": "farsi"
    },
    "جاوید": {
        "root": "farsi"
    },
    "جاهد": {
        "root": "farsi"
    },
    "جبار": {
        "root": "farsi"
    },
    "جبریل": {
        "root": "farsi"
    },
    "جبرئیل": {
        "root": "farsi"
    },
    "جبلی": {
        "root": "farsi"
    },
    "جرجیس": {
        "root": "farsi"
    },
    "جریر": {
        "root": "farsi"
    },
    "جستان": {
        "root": "farsi"
    },
    "جعفر": {
        "root": "farsi"
    },
    "جلال": {
        "root": "farsi"
    },
    "جلالالدین": {
        "root": "farsi"
    },
    "جلایر": {
        "root": "farsi"
    },
    "جلیل": {
        "root": "farsi"
    },
    "جم": {
        "root": "farsi"
    },
    "جمال": {
        "root": "farsi"
    },
    "جمالالدین": {
        "root": "farsi"
    },
    "جمشاد": {
        "root": "farsi"
    },
    "جمشید": {
        "root": "farsi"
    },
    "جمهور": {
        "root": "farsi"
    },
    "جناب": {
        "root": "farsi"
    },
    "جندل": {
        "root": "farsi"
    },
    "جنید": {
        "root": "farsi"
    },
    "جواد": {
        "root": "farsi"
    },
    "جوان": {
        "root": "farsi"
    },
    "جوانشیر": {
        "root": "farsi"
    },
    "جوانمردی": {
        "root": "farsi"
    },
    "جوانوی": {
        "root": "farsi"
    },
    "جویا": {
        "root": "farsi"
    },
    "جویان": {
        "root": "farsi"
    },
    "جهان": {
        "root": "farsi"
    },
    "جهانآفرین": {
        "root": "farsi"
    },
    "جهانبخش": {
        "root": "farsi"
    },
    "جهانبین": {
        "root": "farsi"
    },
    "جهانفر": {
        "root": "farsi"
    },
    "جهانبان": {
        "root": "farsi"
    },
    "جهاندار": {
        "root": "farsi"
    },
    "جهانسوز": {
        "root": "farsi"
    },
    "جهانشاد": {
        "root": "farsi"
    },
    "جهانشاه": {
        "root": "farsi"
    },
    "جهانشید": {
        "root": "farsi"
    },
    "جهانشیر": {
        "root": "farsi"
    },
    "جهانگشای": {
        "root": "farsi"
    },
    "جهانگیر": {
        "root": "farsi"
    },
    "جهانیار": {
        "root": "farsi"
    },
    "جهن": {
        "root": "farsi"
    },
    "چابک": {
        "root": "farsi"
    },
    "چاکان": {
        "root": "farsi"
    },
    "چالش": {
        "root": "farsi"
    },
    "چالیک": {
        "root": "farsi"
    },
    "چاووش": {
        "root": "farsi"
    },
    "چاوه": {
        "root": "farsi"
    },
    "چراغ": {
        "root": "farsi"
    },
    "چراغعلی": {
        "root": "farsi"
    },
    "چکاد": {
        "root": "farsi"
    },
    "چنگش": {
        "root": "farsi"
    },
    "چنگیز": {
        "root": "farsi"
    },
    "چوبین": {
        "root": "farsi"
    },
    "چوبینه": {
        "root": "farsi"
    },
    "چوگان": {
        "root": "farsi"
    },
    "چهربرزین": {
        "root": "farsi"
    },
    "چیا": {
        "root": "farsi"
    },
    "چیاکو": {
        "root": "farsi"
    },
    "چیلان": {
        "root": "farsi"
    },
    "چینود": {
        "root": "farsi"
    },
    "حاتم": {
        "root": "farsi"
    },
    "حادید": {
        "root": "farsi"
    },
    "حارث": {
        "root": "farsi"
    },
    "حارس": {
        "root": "farsi"
    },
    "حافظ": {
        "root": "farsi"
    },
    "حافظالدین": {
        "root": "farsi"
    },
    "حام": {
        "root": "farsi"
    },
    "حامد": {
        "root": "farsi"
    },
    "حامی": {
        "root": "farsi"
    },
    "حامین": {
        "root": "farsi"
    },
    "حانان": {
        "root": "farsi"
    },
    "حانون": {
        "root": "farsi"
    },
    "حایری": {
        "root": "farsi"
    },
    "حبان": {
        "root": "farsi"
    },
    "حبیب": {
        "root": "farsi"
    },
    "حبیبالله": {
        "root": "farsi"
    },
    "حجت": {
        "root": "farsi"
    },
    "حجتالدین": {
        "root": "farsi"
    },
    "حداد": {
        "root": "farsi"
    },
    "حرمتعلی": {
        "root": "farsi"
    },
    "حزین": {
        "root": "farsi"
    },
    "حسام": {
        "root": "farsi"
    },
    "حسامالدین": {
        "root": "farsi"
    },
    "حسن": {
        "root": "farsi"
    },
    "حسنیوسف": {
        "root": "farsi"
    },
    "حسیب": {
        "root": "farsi"
    },
    "حسین": {
        "root": "farsi"
    },
    "حشمت": {
        "root": "farsi"
    },
    "حشمتالله": {
        "root": "farsi"
    },
    "حصیل": {
        "root": "farsi"
    },
    "حفیظ": {
        "root": "farsi"
    },
    "حکمت": {
        "root": "farsi"
    },
    "حکیم": {
        "root": "farsi"
    },
    "حلاج": {
        "root": "farsi"
    },
    "حلیم": {
        "root": "farsi"
    },
    "حمام": {
        "root": "farsi"
    },
    "حمدالدین": {
        "root": "farsi"
    },
    "حمدالله": {
        "root": "farsi"
    },
    "حمزه": {
        "root": "farsi"
    },
    "حمید": {
        "root": "farsi"
    },
    "حمیدالدین": {
        "root": "farsi"
    },
    "حمیدالله": {
        "root": "farsi"
    },
    "حمیدرضا": {
        "root": "farsi"
    },
    "حمیم": {
        "root": "farsi"
    },
    "حنان": {
        "root": "farsi"
    },
    "حنیف": {
        "root": "farsi"
    },
    "حنین": {
        "root": "farsi"
    },
    "حیدر": {
        "root": "farsi"
    },
    "خونیرث": {
        "root": "farsi"
    },
    "خابان": {
        "root": "farsi"
    },
    "خاروس": {
        "root": "farsi"
    },
    "خاقان": {
        "root": "farsi"
    },
    "خالد": {
        "root": "farsi"
    },
    "خالق": {
        "root": "farsi"
    },
    "خاوین": {
        "root": "farsi"
    },
    "خدابخش": {
        "root": "farsi"
    },
    "خدابنده": {
        "root": "farsi"
    },
    "خداداد": {
        "root": "farsi"
    },
    "خدادوست": {
        "root": "farsi"
    },
    "خداطلب": {
        "root": "farsi"
    },
    "خداکریم": {
        "root": "farsi"
    },
    "خدایار": {
        "root": "farsi"
    },
    "خدیو": {
        "root": "farsi"
    },
    "خراد": {
        "root": "farsi"
    },
    "خراسان": {
        "root": "farsi"
    },
    "خرداد": {
        "root": "farsi"
    },
    "خردادبرزین": {
        "root": "farsi"
    },
    "خردادبه": {
        "root": "farsi"
    },
    "خردمند": {
        "root": "farsi"
    },
    "خرزاد": {
        "root": "farsi"
    },
    "خرم": {
        "root": "farsi"
    },
    "خرمشاد": {
        "root": "farsi"
    },
    "خروش": {
        "root": "farsi"
    },
    "خسرو": {
        "root": "farsi"
    },
    "خسروپرویز": {
        "root": "farsi"
    },
    "خسروداد": {
        "root": "farsi"
    },
    "خسروزاد": {
        "root": "farsi"
    },
    "خسروشاد": {
        "root": "farsi"
    },
    "خشاش": {
        "root": "farsi"
    },
    "خشاشه": {
        "root": "farsi"
    },
    "خشایار": {
        "root": "farsi"
    },
    "خشایارشا": {
        "root": "farsi"
    },
    "خشنواز": {
        "root": "farsi"
    },
    "خشنود": {
        "root": "farsi"
    },
    "خضر": {
        "root": "farsi"
    },
    "خلیل": {
        "root": "farsi"
    },
    "خلیلالله": {
        "root": "farsi"
    },
    "خنجست": {
        "root": "farsi"
    },
    "خورسند": {
        "root": "farsi"
    },
    "خوزان": {
        "root": "farsi"
    },
    "خوشمنش": {
        "root": "farsi"
    },
    "خوشنواز": {
        "root": "farsi"
    },
    "خوشنام": {
        "root": "farsi"
    },
    "خوشنود": {
        "root": "farsi"
    },
    "خیام": {
        "root": "farsi"
    },
    "خیرالدین": {
        "root": "farsi"
    },
    "خیرالله": {
        "root": "farsi"
    },
    "خیراندیش": {
        "root": "farsi"
    },
    "خیرعلی": {
        "root": "farsi"
    },
    "دریز": {
        "root": "farsi"
    },
    "دسم": {
        "root": "farsi"
    },
    "داته": {
        "root": "farsi"
    },
    "داتام": {
        "root": "farsi"
    },
    "داتان": {
        "root": "farsi"
    },
    "داتیس": {
        "root": "farsi"
    },
    "دادار": {
        "root": "farsi"
    },
    "دادبان": {
        "root": "farsi"
    },
    "دادبرزین": {
        "root": "farsi"
    },
    "دادبه": {
        "root": "farsi"
    },
    "دادپویه": {
        "root": "farsi"
    },
    "دادجو": {
        "root": "farsi"
    },
    "دادخواه": {
        "root": "farsi"
    },
    "دادرس": {
        "root": "farsi"
    },
    "دادعلی": {
        "root": "farsi"
    },
    "دادفر": {
        "root": "farsi"
    },
    "دادفرخ": {
        "root": "farsi"
    },
    "دادفروز": {
        "root": "farsi"
    },
    "دادکار": {
        "root": "farsi"
    },
    "دادگر": {
        "root": "farsi"
    },
    "دادمهر": {
        "root": "farsi"
    },
    "دادنام": {
        "root": "farsi"
    },
    "دادور": {
        "root": "farsi"
    },
    "دادهرمز": {
        "root": "farsi"
    },
    "دادیار": {
        "root": "farsi"
    },
    "دارا": {
        "root": "farsi"
    },
    "داراب": {
        "root": "farsi"
    },
    "داران": {
        "root": "farsi"
    },
    "دارمان": {
        "root": "farsi"
    },
    "دارنوش": {
        "root": "farsi"
    },
    "داریا": {
        "root": "farsi"
    },
    "داریاو": {
        "root": "farsi"
    },
    "دارینوش": {
        "root": "farsi"
    },
    "داریو": {
        "root": "farsi"
    },
    "داریوش": {
        "root": "farsi"
    },
    "داژو": {
        "root": "farsi"
    },
    "داشاب": {
        "root": "farsi"
    },
    "داشاد": {
        "root": "farsi"
    },
    "دامور": {
        "root": "farsi"
    },
    "دامون": {
        "root": "farsi"
    },
    "دان": {
        "root": "farsi"
    },
    "دانا": {
        "root": "farsi"
    },
    "دانش": {
        "root": "farsi"
    },
    "دانشمند": {
        "root": "farsi"
    },
    "دانوش": {
        "root": "farsi"
    },
    "دانیال": {
        "root": "farsi"
    },
    "داو": {
        "root": "farsi"
    },
    "داود": {
        "root": "farsi"
    },
    "داور": {
        "root": "farsi"
    },
    "داورا": {
        "root": "farsi"
    },
    "داوود": {
        "root": "farsi"
    },
    "داوید": {
        "root": "farsi"
    },
    "دایان": {
        "root": "farsi"
    },
    "دستان": {
        "root": "farsi"
    },
    "دشمه": {
        "root": "farsi"
    },
    "دلاور": {
        "root": "farsi"
    },
    "دلیر": {
        "root": "farsi"
    },
    "دماوند": {
        "root": "farsi"
    },
    "دمور": {
        "root": "farsi"
    },
    "دوستمحمد": {
        "root": "farsi"
    },
    "دوستعلی": {
        "root": "farsi"
    },
    "دوقلو": {
        "root": "farsi"
    },
    "دومان": {
        "root": "farsi"
    },
    "دها": {
        "root": "farsi"
    },
    "دهباشی": {
        "root": "farsi"
    },
    "دهخدا": {
        "root": "farsi"
    },
    "دهناد": {
        "root": "farsi"
    },
    "دیااکو": {
        "root": "farsi"
    },
    "دیاکو": {
        "root": "farsi"
    },
    "دینمحمد": {
        "root": "farsi"
    },
    "دینشاه": {
        "root": "farsi"
    },
    "دینیار": {
        "root": "farsi"
    },
    "دیهیم": {
        "root": "farsi"
    },
    "ذبیح": {
        "root": "farsi"
    },
    "ذکا": {
        "root": "farsi"
    },
    "ذکی": {
        "root": "farsi"
    },
    "ذوالفضل": {
        "root": "farsi"
    },
    "ذوالفقار": {
        "root": "farsi"
    },
    "راتین": {
        "root": "farsi"
    },
    "راد": {
        "root": "farsi"
    },
    "رادان": {
        "root": "farsi"
    },
    "رادبرزین": {
        "root": "farsi"
    },
    "رادعلی": {
        "root": "farsi"
    },
    "رادفرخ": {
        "root": "farsi"
    },
    "رادمان": {
        "root": "farsi"
    },
    "رادمنش": {
        "root": "farsi"
    },
    "رادمهر": {
        "root": "farsi"
    },
    "رادوین": {
        "root": "farsi"
    },
    "رازاوه": {
        "root": "farsi"
    },
    "راستین": {
        "root": "farsi"
    },
    "راشا": {
        "root": "farsi"
    },
    "راشد": {
        "root": "farsi"
    },
    "راشن": {
        "root": "farsi"
    },
    "راشین": {
        "root": "farsi"
    },
    "رام": {
        "root": "farsi"
    },
    "رامبرزین": {
        "root": "farsi"
    },
    "راما": {
        "root": "farsi"
    },
    "رامان": {
        "root": "farsi"
    },
    "رامبد": {
        "root": "farsi"
    },
    "رامتین": {
        "root": "farsi"
    },
    "رامشاد": {
        "root": "farsi"
    },
    "رامی": {
        "root": "farsi"
    },
    "رامیاد": {
        "root": "farsi"
    },
    "رامیار": {
        "root": "farsi"
    },
    "رامین": {
        "root": "farsi"
    },
    "راهنما": {
        "root": "farsi"
    },
    "رایا": {
        "root": "farsi"
    },
    "رایبد": {
        "root": "farsi"
    },
    "رایمون": {
        "root": "farsi"
    },
    "رایین": {
        "root": "farsi"
    },
    "ربن": {
        "root": "farsi"
    },
    "ربیع": {
        "root": "farsi"
    },
    "رجا": {
        "root": "farsi"
    },
    "رجب": {
        "root": "farsi"
    },
    "رحمان": {
        "root": "farsi"
    },
    "رحمت": {
        "root": "farsi"
    },
    "رحمتالله": {
        "root": "farsi"
    },
    "رحیم": {
        "root": "farsi"
    },
    "رزاق": {
        "root": "farsi"
    },
    "رزقالله": {
        "root": "farsi"
    },
    "رزمان": {
        "root": "farsi"
    },
    "رزین": {
        "root": "farsi"
    },
    "رسام": {
        "root": "farsi"
    },
    "رستار": {
        "root": "farsi"
    },
    "رستان": {
        "root": "farsi"
    },
    "رستم": {
        "root": "farsi"
    },
    "رستهم": {
        "root": "farsi"
    },
    "رسول": {
        "root": "farsi"
    },
    "رشنواد": {
        "root": "farsi"
    },
    "رشید": {
        "root": "farsi"
    },
    "رشیدا": {
        "root": "farsi"
    },
    "رشیدالدین": {
        "root": "farsi"
    },
    "رضا": {
        "root": "farsi"
    },
    "رضی": {
        "root": "farsi"
    },
    "رضیالدین": {
        "root": "farsi"
    },
    "رعد": {
        "root": "farsi"
    },
    "رغمان": {
        "root": "farsi"
    },
    "رفیع": {
        "root": "farsi"
    },
    "رفیعالدین": {
        "root": "farsi"
    },
    "رکسار": {
        "root": "farsi"
    },
    "رکنالدین": {
        "root": "farsi"
    },
    "رمضان": {
        "root": "farsi"
    },
    "رمیار": {
        "root": "farsi"
    },
    "روجیار": {
        "root": "farsi"
    },
    "روحالدین": {
        "root": "farsi"
    },
    "روحالله": {
        "root": "farsi"
    },
    "روزبه": {
        "root": "farsi"
    },
    "روزبهان": {
        "root": "farsi"
    },
    "روزک": {
        "root": "farsi"
    },
    "روزمهر": {
        "root": "farsi"
    },
    "روژمان": {
        "root": "farsi"
    },
    "روشاک": {
        "root": "farsi"
    },
    "روشنایی": {
        "root": "farsi"
    },
    "روماک": {
        "root": "farsi"
    },
    "روهام": {
        "root": "farsi"
    },
    "روهان": {
        "root": "farsi"
    },
    "رهاگشته": {
        "root": "farsi"
    },
    "رهام": {
        "root": "farsi"
    },
    "رهان": {
        "root": "farsi"
    },
    "رهی": {
        "root": "farsi"
    },
    "ریاض": {
        "root": "farsi"
    },
    "ریو": {
        "root": "farsi"
    },
    "ریونیز": {
        "root": "farsi"
    },
    "رئو": {
        "root": "farsi"
    },
    "رئوف": {
        "root": "farsi"
    },
    "زریر": {
        "root": "farsi"
    },
    "زم": {
        "root": "farsi"
    },
    "زواره": {
        "root": "farsi"
    },
    "زهیر": {
        "root": "farsi"
    },
    "زاب": {
        "root": "farsi"
    },
    "زاد": {
        "root": "farsi"
    },
    "زادان": {
        "root": "farsi"
    },
    "زادانفر": {
        "root": "farsi"
    },
    "زادانفرخ": {
        "root": "farsi"
    },
    "زادبه": {
        "root": "farsi"
    },
    "زادسرو": {
        "root": "farsi"
    },
    "زادشم": {
        "root": "farsi"
    },
    "زادفرخ": {
        "root": "farsi"
    },
    "زادمن": {
        "root": "farsi"
    },
    "زاگرس": {
        "root": "farsi"
    },
    "زال": {
        "root": "farsi"
    },
    "زامیاد": {
        "root": "farsi"
    },
    "زانا": {
        "root": "farsi"
    },
    "زانیار": {
        "root": "farsi"
    },
    "زاور": {
        "root": "farsi"
    },
    "زاوش": {
        "root": "farsi"
    },
    "زاهر": {
        "root": "farsi"
    },
    "زائان": {
        "root": "farsi"
    },
    "زائر": {
        "root": "farsi"
    },
    "زراتشت": {
        "root": "farsi"
    },
    "زراسپ": {
        "root": "farsi"
    },
    "زراوه": {
        "root": "farsi"
    },
    "زرتشت": {
        "root": "farsi"
    },
    "زرحیا": {
        "root": "farsi"
    },
    "زرداده": {
        "root": "farsi"
    },
    "زرداشت": {
        "root": "farsi"
    },
    "زردشت": {
        "root": "farsi"
    },
    "زردهشت": {
        "root": "farsi"
    },
    "زرمهر": {
        "root": "farsi"
    },
    "زروان": {
        "root": "farsi"
    },
    "زروانداد": {
        "root": "farsi"
    },
    "زروانمهر": {
        "root": "farsi"
    },
    "زرینکلاه": {
        "root": "farsi"
    },
    "زریون": {
        "root": "farsi"
    },
    "زعیم": {
        "root": "farsi"
    },
    "زعیمالدین": {
        "root": "farsi"
    },
    "زکریا": {
        "root": "farsi"
    },
    "زکی": {
        "root": "farsi"
    },
    "زکیالدین": {
        "root": "farsi"
    },
    "زلفعلی": {
        "root": "farsi"
    },
    "زمان": {
        "root": "farsi"
    },
    "زمران": {
        "root": "farsi"
    },
    "زنگنه": {
        "root": "farsi"
    },
    "زنگو": {
        "root": "farsi"
    },
    "زنگه": {
        "root": "farsi"
    },
    "زوپیر": {
        "root": "farsi"
    },
    "زوپین": {
        "root": "farsi"
    },
    "زوران": {
        "root": "farsi"
    },
    "زویین": {
        "root": "farsi"
    },
    "زهید": {
        "root": "farsi"
    },
    "زیا": {
        "root": "farsi"
    },
    "زیار": {
        "root": "farsi"
    },
    "زیبامحمد": {
        "root": "farsi"
    },
    "زید": {
        "root": "farsi"
    },
    "زیدان": {
        "root": "farsi"
    },
    "زیدعلی": {
        "root": "farsi"
    },
    "زیرک": {
        "root": "farsi"
    },
    "زیگ": {
        "root": "farsi"
    },
    "زینالدین": {
        "root": "farsi"
    },
    "زینالعابدین": {
        "root": "farsi"
    },
    "زینال": {
        "root": "farsi"
    },
    "زیناوند": {
        "root": "farsi"
    },
    "زینعلی": {
        "root": "farsi"
    },
    "ژابیز": {
        "root": "farsi"
    },
    "ژافه": {
        "root": "farsi"
    },
    "ژاماسب": {
        "root": "farsi"
    },
    "ژاو": {
        "root": "farsi"
    },
    "ژاییز": {
        "root": "farsi"
    },
    "ژرف": {
        "root": "farsi"
    },
    "ژکور": {
        "root": "farsi"
    },
    "ژم": {
        "root": "farsi"
    },
    "ژنگ": {
        "root": "farsi"
    },
    "ژنوا": {
        "root": "farsi"
    },
    "ژوبین": {
        "root": "farsi"
    },
    "ژوپین": {
        "root": "farsi"
    },
    "ژورک": {
        "root": "farsi"
    },
    "ژیار": {
        "root": "farsi"
    },
    "ژیان": {
        "root": "farsi"
    },
    "ژیگس": {
        "root": "farsi"
    },
    "ژیلوان": {
        "root": "farsi"
    },
    "سپرنگ": {
        "root": "farsi"
    },
    "سلم": {
        "root": "farsi"
    },
    "سرایش": {
        "root": "farsi"
    },
    "سابق": {
        "root": "farsi"
    },
    "سابقالدین": {
        "root": "farsi"
    },
    "ساتکین": {
        "root": "farsi"
    },
    "ساتگین": {
        "root": "farsi"
    },
    "ساتیار": {
        "root": "farsi"
    },
    "سارنگ": {
        "root": "farsi"
    },
    "سارو": {
        "root": "farsi"
    },
    "سارین": {
        "root": "farsi"
    },
    "ساسان": {
        "root": "farsi"
    },
    "ساعد": {
        "root": "farsi"
    },
    "ساعی": {
        "root": "farsi"
    },
    "ساکو": {
        "root": "farsi"
    },
    "سالار": {
        "root": "farsi"
    },
    "سالداش": {
        "root": "farsi"
    },
    "سالم": {
        "root": "farsi"
    },
    "سام": {
        "root": "farsi"
    },
    "ساما": {
        "root": "farsi"
    },
    "سامان": {
        "root": "farsi"
    },
    "سامر": {
        "root": "farsi"
    },
    "سامرند": {
        "root": "farsi"
    },
    "سامیا": {
        "root": "farsi"
    },
    "سامیار": {
        "root": "farsi"
    },
    "سامیان": {
        "root": "farsi"
    },
    "سامین": {
        "root": "farsi"
    },
    "سانا": {
        "root": "farsi"
    },
    "سانان": {
        "root": "farsi"
    },
    "سانیار": {
        "root": "farsi"
    },
    "ساوان": {
        "root": "farsi"
    },
    "ساورا": {
        "root": "farsi"
    },
    "ساونگ": {
        "root": "farsi"
    },
    "ساوه": {
        "root": "farsi"
    },
    "ساهر": {
        "root": "farsi"
    },
    "سایر": {
        "root": "farsi"
    },
    "سایروس": {
        "root": "farsi"
    },
    "سباک": {
        "root": "farsi"
    },
    "سبحان": {
        "root": "farsi"
    },
    "سبحانقلی": {
        "root": "farsi"
    },
    "سبکتین": {
        "root": "farsi"
    },
    "سبلان": {
        "root": "farsi"
    },
    "سپنتامن": {
        "root": "farsi"
    },
    "سپند": {
        "root": "farsi"
    },
    "سپندان": {
        "root": "farsi"
    },
    "سپنسار": {
        "root": "farsi"
    },
    "سپهر": {
        "root": "farsi"
    },
    "سپهراد": {
        "root": "farsi"
    },
    "سپهرار": {
        "root": "farsi"
    },
    "سپهرداد": {
        "root": "farsi"
    },
    "سپهرم": {
        "root": "farsi"
    },
    "سترگ": {
        "root": "farsi"
    },
    "ستار": {
        "root": "farsi"
    },
    "سجاد": {
        "root": "farsi"
    },
    "سحاب": {
        "root": "farsi"
    },
    "سدرا": {
        "root": "farsi"
    },
    "سدیدالدین": {
        "root": "farsi"
    },
    "سدیف": {
        "root": "farsi"
    },
    "سراج": {
        "root": "farsi"
    },
    "سراجالدین": {
        "root": "farsi"
    },
    "سرافراز": {
        "root": "farsi"
    },
    "سرافیل": {
        "root": "farsi"
    },
    "سرخه": {
        "root": "farsi"
    },
    "سردار": {
        "root": "farsi"
    },
    "سرکب": {
        "root": "farsi"
    },
    "سرکش": {
        "root": "farsi"
    },
    "سروش": {
        "root": "farsi"
    },
    "سروشان": {
        "root": "farsi"
    },
    "سریتا": {
        "root": "farsi"
    },
    "سزاوار": {
        "root": "farsi"
    },
    "سعد": {
        "root": "farsi"
    },
    "سعدالدین": {
        "root": "farsi"
    },
    "سعدی": {
        "root": "farsi"
    },
    "سعید": {
        "root": "farsi"
    },
    "سفندارمذ": {
        "root": "farsi"
    },
    "سقراط": {
        "root": "farsi"
    },
    "سکندر": {
        "root": "farsi"
    },
    "سلجوق": {
        "root": "farsi"
    },
    "سلدوز": {
        "root": "farsi"
    },
    "سلطان": {
        "root": "farsi"
    },
    "سلمان": {
        "root": "farsi"
    },
    "سلیم": {
        "root": "farsi"
    },
    "سلیمان": {
        "root": "farsi"
    },
    "سمک": {
        "root": "farsi"
    },
    "سمکنان": {
        "root": "farsi"
    },
    "سموئیل": {
        "root": "farsi"
    },
    "سمیح": {
        "root": "farsi"
    },
    "سمیر": {
        "root": "farsi"
    },
    "سمیع": {
        "root": "farsi"
    },
    "سناالدین": {
        "root": "farsi"
    },
    "سنانالدین": {
        "root": "farsi"
    },
    "سنباد": {
        "root": "farsi"
    },
    "سنجر": {
        "root": "farsi"
    },
    "سنجه": {
        "root": "farsi"
    },
    "سوبیتای": {
        "root": "farsi"
    },
    "سوران": {
        "root": "farsi"
    },
    "سورن": {
        "root": "farsi"
    },
    "سورنا": {
        "root": "farsi"
    },
    "سورین": {
        "root": "farsi"
    },
    "سوشا": {
        "root": "farsi"
    },
    "سوشیا": {
        "root": "farsi"
    },
    "سوشیان": {
        "root": "farsi"
    },
    "سوشیانت": {
        "root": "farsi"
    },
    "سوشیانس": {
        "root": "farsi"
    },
    "سوفرا": {
        "root": "farsi"
    },
    "سوما": {
        "root": "farsi"
    },
    "سهام": {
        "root": "farsi"
    },
    "سهامالدین": {
        "root": "farsi"
    },
    "سهراب": {
        "root": "farsi"
    },
    "سهره": {
        "root": "farsi"
    },
    "سهند": {
        "root": "farsi"
    },
    "سهیل": {
        "root": "farsi"
    },
    "سیسیماک": {
        "root": "farsi"
    },
    "سیامک": {
        "root": "farsi"
    },
    "سیامند": {
        "root": "farsi"
    },
    "سیاوخش": {
        "root": "farsi"
    },
    "سیاوش": {
        "root": "farsi"
    },
    "سیاووش": {
        "root": "farsi"
    },
    "سیبویه": {
        "root": "farsi"
    },
    "سیتاک": {
        "root": "farsi"
    },
    "سیحون": {
        "root": "farsi"
    },
    "سیرخ": {
        "root": "farsi"
    },
    "سیروان": {
        "root": "farsi"
    },
    "سیروس": {
        "root": "farsi"
    },
    "سیفالدین": {
        "root": "farsi"
    },
    "سیفالله": {
        "root": "farsi"
    },
    "سیکا": {
        "root": "farsi"
    },
    "سیمک": {
        "root": "farsi"
    },
    "سینا": {
        "root": "farsi"
    },
    "سینار": {
        "root": "farsi"
    },
    "سیناک": {
        "root": "farsi"
    },
    "سیوان": {
        "root": "farsi"
    },
    "شابرزین": {
        "root": "farsi"
    },
    "شابهار": {
        "root": "farsi"
    },
    "شاپور": {
        "root": "farsi"
    },
    "شادانبرزین": {
        "root": "farsi"
    },
    "شادانهرمز": {
        "root": "farsi"
    },
    "شادبه": {
        "root": "farsi"
    },
    "شادتگین": {
        "root": "farsi"
    },
    "شادکان": {
        "root": "farsi"
    },
    "شادلی": {
        "root": "farsi"
    },
    "شادمهر": {
        "root": "farsi"
    },
    "شادن": {
        "root": "farsi"
    },
    "شادیار": {
        "root": "farsi"
    },
    "شار": {
        "root": "farsi"
    },
    "شارو": {
        "root": "farsi"
    },
    "شاروسین": {
        "root": "farsi"
    },
    "شارویه": {
        "root": "farsi"
    },
    "شاعی": {
        "root": "farsi"
    },
    "شاکر": {
        "root": "farsi"
    },
    "شاکل": {
        "root": "farsi"
    },
    "شامل": {
        "root": "farsi"
    },
    "شانلی": {
        "root": "farsi"
    },
    "شانیا": {
        "root": "farsi"
    },
    "شاور": {
        "root": "farsi"
    },
    "شاوران": {
        "root": "farsi"
    },
    "شاوگ": {
        "root": "farsi"
    },
    "شاویس": {
        "root": "farsi"
    },
    "شاهبرزین": {
        "root": "farsi"
    },
    "شاهبهرام": {
        "root": "farsi"
    },
    "شاهپر": {
        "root": "farsi"
    },
    "شاهسرور": {
        "root": "farsi"
    },
    "شاهمحمد": {
        "root": "farsi"
    },
    "شاهمراد": {
        "root": "farsi"
    },
    "شاهموبد": {
        "root": "farsi"
    },
    "شاههژبر": {
        "root": "farsi"
    },
    "شاهارا": {
        "root": "farsi"
    },
    "شاهپور": {
        "root": "farsi"
    },
    "شاهد": {
        "root": "farsi"
    },
    "شاهدیس": {
        "root": "farsi"
    },
    "شاهر": {
        "root": "farsi"
    },
    "شاهرخ": {
        "root": "farsi"
    },
    "شاهروز": {
        "root": "farsi"
    },
    "شاهسار": {
        "root": "farsi"
    },
    "شاهسون": {
        "root": "farsi"
    },
    "شاهفور": {
        "root": "farsi"
    },
    "شاهقلی": {
        "root": "farsi"
    },
    "شاهک": {
        "root": "farsi"
    },
    "شاهکار": {
        "root": "farsi"
    },
    "شاهکام": {
        "root": "farsi"
    },
    "شاهمیر": {
        "root": "farsi"
    },
    "شاهو": {
        "root": "farsi"
    },
    "شاهوش": {
        "root": "farsi"
    },
    "شاهوی": {
        "root": "farsi"
    },
    "شاهیار": {
        "root": "farsi"
    },
    "شاهین": {
        "root": "farsi"
    },
    "شایار": {
        "root": "farsi"
    },
    "شایان": {
        "root": "farsi"
    },
    "شایگان": {
        "root": "farsi"
    },
    "شایورد": {
        "root": "farsi"
    },
    "شبان": {
        "root": "farsi"
    },
    "شباویز": {
        "root": "farsi"
    },
    "شبلی": {
        "root": "farsi"
    },
    "شبنا": {
        "root": "farsi"
    },
    "شبیب": {
        "root": "farsi"
    },
    "شبیر": {
        "root": "farsi"
    },
    "شجاعالدین": {
        "root": "farsi"
    },
    "شجاعالملک": {
        "root": "farsi"
    },
    "شداد": {
        "root": "farsi"
    },
    "شراکیم": {
        "root": "farsi"
    },
    "شرف": {
        "root": "farsi"
    },
    "شرفالدین": {
        "root": "farsi"
    },
    "شرفالزمان": {
        "root": "farsi"
    },
    "شروان": {
        "root": "farsi"
    },
    "شروین": {
        "root": "farsi"
    },
    "شریف": {
        "root": "farsi"
    },
    "شریفالدین": {
        "root": "farsi"
    },
    "شعبان": {
        "root": "farsi"
    },
    "شعیب": {
        "root": "farsi"
    },
    "شغاد": {
        "root": "farsi"
    },
    "شفا": {
        "root": "farsi"
    },
    "شفروه": {
        "root": "farsi"
    },
    "شفیع": {
        "root": "farsi"
    },
    "شقیق": {
        "root": "farsi"
    },
    "شکرالله": {
        "root": "farsi"
    },
    "شکرعلی": {
        "root": "farsi"
    },
    "شکور": {
        "root": "farsi"
    },
    "شکیب": {
        "root": "farsi"
    },
    "شکیل": {
        "root": "farsi"
    },
    "شلیخا": {
        "root": "farsi"
    },
    "شماخ": {
        "root": "farsi"
    },
    "شماس": {
        "root": "farsi"
    },
    "شماساس": {
        "root": "farsi"
    },
    "شمس": {
        "root": "farsi"
    },
    "شمسالدین": {
        "root": "farsi"
    },
    "شمسالهدی": {
        "root": "farsi"
    },
    "شمشیر": {
        "root": "farsi"
    },
    "شمعون": {
        "root": "farsi"
    },
    "شمیران": {
        "root": "farsi"
    },
    "شمیل": {
        "root": "farsi"
    },
    "شمینه": {
        "root": "farsi"
    },
    "شنتیا": {
        "root": "farsi"
    },
    "شنطوس": {
        "root": "farsi"
    },
    "شنگان": {
        "root": "farsi"
    },
    "شنگل": {
        "root": "farsi"
    },
    "شوان": {
        "root": "farsi"
    },
    "شورعلی": {
        "root": "farsi"
    },
    "شوقعلی": {
        "root": "farsi"
    },
    "شهموبد": {
        "root": "farsi"
    },
    "شهاب": {
        "root": "farsi"
    },
    "شهابالدین": {
        "root": "farsi"
    },
    "شهباز": {
        "root": "farsi"
    },
    "شهبال": {
        "root": "farsi"
    },
    "شهبان": {
        "root": "farsi"
    },
    "شهبد": {
        "root": "farsi"
    },
    "شهداد": {
        "root": "farsi"
    },
    "شهراد": {
        "root": "farsi"
    },
    "شهرام": {
        "root": "farsi"
    },
    "شهران": {
        "root": "farsi"
    },
    "شهرآزاد": {
        "root": "farsi"
    },
    "شهرآگیم": {
        "root": "farsi"
    },
    "شهربان": {
        "root": "farsi"
    },
    "شهرتاش": {
        "root": "farsi"
    },
    "شهرخواست": {
        "root": "farsi"
    },
    "شهرداد": {
        "root": "farsi"
    },
    "شهرسپ": {
        "root": "farsi"
    },
    "شهرگان": {
        "root": "farsi"
    },
    "شهرگیر": {
        "root": "farsi"
    },
    "شهروان": {
        "root": "farsi"
    },
    "شهروز": {
        "root": "farsi"
    },
    "شهروین": {
        "root": "farsi"
    },
    "شهریار": {
        "root": "farsi"
    },
    "شهرین": {
        "root": "farsi"
    },
    "شهریور": {
        "root": "farsi"
    },
    "شهسان": {
        "root": "farsi"
    },
    "شهفور": {
        "root": "farsi"
    },
    "شهمردان": {
        "root": "farsi"
    },
    "شهمیر": {
        "root": "farsi"
    },
    "شهنام": {
        "root": "farsi"
    },
    "شهنوش": {
        "root": "farsi"
    },
    "شهیاد": {
        "root": "farsi"
    },
    "شهیار": {
        "root": "farsi"
    },
    "شهیر": {
        "root": "farsi"
    },
    "شیانا": {
        "root": "farsi"
    },
    "شیبان": {
        "root": "farsi"
    },
    "شیبت": {
        "root": "farsi"
    },
    "شیث": {
        "root": "farsi"
    },
    "شیداب": {
        "root": "farsi"
    },
    "شیدرنگ": {
        "root": "farsi"
    },
    "شیدسب": {
        "root": "farsi"
    },
    "شیدوش": {
        "root": "farsi"
    },
    "شیراحمد": {
        "root": "farsi"
    },
    "شیراک": {
        "root": "farsi"
    },
    "شیران": {
        "root": "farsi"
    },
    "شیرآزاد": {
        "root": "farsi"
    },
    "شیرخون": {
        "root": "farsi"
    },
    "شیردل": {
        "root": "farsi"
    },
    "شیرزاد": {
        "root": "farsi"
    },
    "شیرزیل": {
        "root": "farsi"
    },
    "شیرعلی": {
        "root": "farsi"
    },
    "شیرمحمد": {
        "root": "farsi"
    },
    "شیرو": {
        "root": "farsi"
    },
    "شیرویه": {
        "root": "farsi"
    },
    "صابر": {
        "root": "farsi"
    },
    "صاحب": {
        "root": "farsi"
    },
    "صادق": {
        "root": "farsi"
    },
    "صارم": {
        "root": "farsi"
    },
    "صاعد": {
        "root": "farsi"
    },
    "صالح": {
        "root": "farsi"
    },
    "صانع": {
        "root": "farsi"
    },
    "صایب": {
        "root": "farsi"
    },
    "صاین": {
        "root": "farsi"
    },
    "صائب": {
        "root": "farsi"
    },
    "صائم": {
        "root": "farsi"
    },
    "صائن": {
        "root": "farsi"
    },
    "صائنالدین": {
        "root": "farsi"
    },
    "صباح": {
        "root": "farsi"
    },
    "صبار": {
        "root": "farsi"
    },
    "صدر": {
        "root": "farsi"
    },
    "صدرا": {
        "root": "farsi"
    },
    "صدرالدین": {
        "root": "farsi"
    },
    "صدران": {
        "root": "farsi"
    },
    "صدوق": {
        "root": "farsi"
    },
    "صدیده": {
        "root": "farsi"
    },
    "صدیق": {
        "root": "farsi"
    },
    "صدیقا": {
        "root": "farsi"
    },
    "صفا": {
        "root": "farsi"
    },
    "صفار": {
        "root": "farsi"
    },
    "صفاعلی": {
        "root": "farsi"
    },
    "صفدر": {
        "root": "farsi"
    },
    "صفر": {
        "root": "farsi"
    },
    "صفی": {
        "root": "farsi"
    },
    "صفیالدین": {
        "root": "farsi"
    },
    "صفیالله": {
        "root": "farsi"
    },
    "صفیعلی": {
        "root": "farsi"
    },
    "صلات": {
        "root": "farsi"
    },
    "صلاح": {
        "root": "farsi"
    },
    "صلاحالدین": {
        "root": "farsi"
    },
    "صمد": {
        "root": "farsi"
    },
    "صمدالله": {
        "root": "farsi"
    },
    "صمصام": {
        "root": "farsi"
    },
    "صمیم": {
        "root": "farsi"
    },
    "صنعان": {
        "root": "farsi"
    },
    "صنمبر": {
        "root": "farsi"
    },
    "صیاد": {
        "root": "farsi"
    },
    "صیام": {
        "root": "farsi"
    },
    "ضحاک": {
        "root": "farsi"
    },
    "ضرغام": {
        "root": "farsi"
    },
    "ضیا": {
        "root": "farsi"
    },
    "ضیاالدین": {
        "root": "farsi"
    },
    "ضیافت": {
        "root": "farsi"
    },
    "ضیغم": {
        "root": "farsi"
    },
    "طارق": {
        "root": "farsi"
    },
    "طالب": {
        "root": "farsi"
    },
    "طالع": {
        "root": "farsi"
    },
    "طالوت": {
        "root": "farsi"
    },
    "طاها": {
        "root": "farsi"
    },
    "طاهر": {
        "root": "farsi"
    },
    "طائر": {
        "root": "farsi"
    },
    "طباطبا": {
        "root": "farsi"
    },
    "طرحان": {
        "root": "farsi"
    },
    "طرخان": {
        "root": "farsi"
    },
    "طرق": {
        "root": "farsi"
    },
    "طرهان": {
        "root": "farsi"
    },
    "طغاتیمور": {
        "root": "farsi"
    },
    "طغان": {
        "root": "farsi"
    },
    "طغرل": {
        "root": "farsi"
    },
    "طلبعلی": {
        "root": "farsi"
    },
    "طلحه": {
        "root": "farsi"
    },
    "طمغاج": {
        "root": "farsi"
    },
    "طورگ": {
        "root": "farsi"
    },
    "طوس": {
        "root": "farsi"
    },
    "طوش": {
        "root": "farsi"
    },
    "طوطیانوش": {
        "root": "farsi"
    },
    "طوفان": {
        "root": "farsi"
    },
    "طه": {
        "root": "farsi"
    },
    "طهماسپ": {
        "root": "farsi"
    },
    "طهمورث": {
        "root": "farsi"
    },
    "طهور": {
        "root": "farsi"
    },
    "طیب": {
        "root": "farsi"
    },
    "طیفور": {
        "root": "farsi"
    },
    "طینوش": {
        "root": "farsi"
    },
    "طیهوج": {
        "root": "farsi"
    },
    "ظافر": {
        "root": "farsi"
    },
    "ظفر": {
        "root": "farsi"
    },
    "ظفرداد": {
        "root": "farsi"
    },
    "ظهور": {
        "root": "farsi"
    },
    "ظهیرالدین": {
        "root": "farsi"
    },
    "عابد": {
        "root": "farsi"
    },
    "عابس": {
        "root": "farsi"
    },
    "عاد": {
        "root": "farsi"
    },
    "عادل": {
        "root": "farsi"
    },
    "عارف": {
        "root": "farsi"
    },
    "عارفپاشا": {
        "root": "farsi"
    },
    "عاشق": {
        "root": "farsi"
    },
    "عاشور": {
        "root": "farsi"
    },
    "عاصم": {
        "root": "farsi"
    },
    "عاطف": {
        "root": "farsi"
    },
    "عاکف": {
        "root": "farsi"
    },
    "عامر": {
        "root": "farsi"
    },
    "عاموس": {
        "root": "farsi"
    },
    "عباد": {
        "root": "farsi"
    },
    "عبادالله": {
        "root": "farsi"
    },
    "عباس": {
        "root": "farsi"
    },
    "عبدالامین": {
        "root": "farsi"
    },
    "عبدالباسط": {
        "root": "farsi"
    },
    "عبدالباقی": {
        "root": "farsi"
    },
    "عبدالجبار": {
        "root": "farsi"
    },
    "عبدالجلیل": {
        "root": "farsi"
    },
    "عبدالجواد": {
        "root": "farsi"
    },
    "عبدالحسن": {
        "root": "farsi"
    },
    "عبدالحسین": {
        "root": "farsi"
    },
    "عبدالحق": {
        "root": "farsi"
    },
    "عبدالحلیم": {
        "root": "farsi"
    },
    "عبدالحمید": {
        "root": "farsi"
    },
    "عبدالحی": {
        "root": "farsi"
    },
    "عبدالخالق": {
        "root": "farsi"
    },
    "عبدالرحمان": {
        "root": "farsi"
    },
    "عبدالرحمن": {
        "root": "farsi"
    },
    "عبدالرحیم": {
        "root": "farsi"
    },
    "عبدالرزاق": {
        "root": "farsi"
    },
    "عبدالرسول": {
        "root": "farsi"
    },
    "عبدالرشید": {
        "root": "farsi"
    },
    "عبدالرضا": {
        "root": "farsi"
    },
    "عبدالرفیع": {
        "root": "farsi"
    },
    "عبدالستار": {
        "root": "farsi"
    },
    "عبدالصمد": {
        "root": "farsi"
    },
    "عبدالعزیز": {
        "root": "farsi"
    },
    "عبدالعظیم": {
        "root": "farsi"
    },
    "عبدالعلی": {
        "root": "farsi"
    },
    "عبدالغفار": {
        "root": "farsi"
    },
    "عبدالغفور": {
        "root": "farsi"
    },
    "عبدالغنی": {
        "root": "farsi"
    },
    "عبدالفتاح": {
        "root": "farsi"
    },
    "عبدالقادر": {
        "root": "farsi"
    },
    "عبدالقاهر": {
        "root": "farsi"
    },
    "عبدالکریم": {
        "root": "farsi"
    },
    "عبداللطیف": {
        "root": "farsi"
    },
    "عبدالله": {
        "root": "farsi"
    },
    "عبدالمجید": {
        "root": "farsi"
    },
    "عبدالمحمد": {
        "root": "farsi"
    },
    "عبدالملک": {
        "root": "farsi"
    },
    "عبدالناصر": {
        "root": "farsi"
    },
    "عبدالنبی": {
        "root": "farsi"
    },
    "عبدالواحد": {
        "root": "farsi"
    },
    "عبدالوهاب": {
        "root": "farsi"
    },
    "عبدالهادی": {
        "root": "farsi"
    },
    "عبیدالله": {
        "root": "farsi"
    },
    "عثمان": {
        "root": "farsi"
    },
    "عدل": {
        "root": "farsi"
    },
    "عدن": {
        "root": "farsi"
    },
    "عدنان": {
        "root": "farsi"
    },
    "عرشیا": {
        "root": "farsi"
    },
    "عرفان": {
        "root": "farsi"
    },
    "عروج": {
        "root": "farsi"
    },
    "عزالدین": {
        "root": "farsi"
    },
    "عزتالله": {
        "root": "farsi"
    },
    "عزرا": {
        "root": "farsi"
    },
    "عزیز": {
        "root": "farsi"
    },
    "عزیزالدین": {
        "root": "farsi"
    },
    "عزیزالله": {
        "root": "farsi"
    },
    "عسکر": {
        "root": "farsi"
    },
    "عصار": {
        "root": "farsi"
    },
    "عضد": {
        "root": "farsi"
    },
    "عضدالدین": {
        "root": "farsi"
    },
    "عضدالملک": {
        "root": "farsi"
    },
    "عطا": {
        "root": "farsi"
    },
    "عطاالله": {
        "root": "farsi"
    },
    "عطارد": {
        "root": "farsi"
    },
    "عظیم": {
        "root": "farsi"
    },
    "عفیفالدین": {
        "root": "farsi"
    },
    "عقیل": {
        "root": "farsi"
    },
    "علا": {
        "root": "farsi"
    },
    "علوان": {
        "root": "farsi"
    },
    "علی": {
        "root": "farsi"
    },
    "علیاصغر": {
        "root": "farsi"
    },
    "علیاکبر": {
        "root": "farsi"
    },
    "علیداد": {
        "root": "farsi"
    },
    "علیمراد": {
        "root": "farsi"
    },
    "علیمردان": {
        "root": "farsi"
    },
    "علینقی": {
        "root": "farsi"
    },
    "علییار": {
        "root": "farsi"
    },
    "علیرضا": {
        "root": "farsi"
    },
    "علیم": {
        "root": "farsi"
    },
    "عماد": {
        "root": "farsi"
    },
    "عمادالدین": {
        "root": "farsi"
    },
    "عمادالملک": {
        "root": "farsi"
    },
    "عمار": {
        "root": "farsi"
    },
    "عمران": {
        "root": "farsi"
    },
    "عمرو": {
        "root": "farsi"
    },
    "عمید": {
        "root": "farsi"
    },
    "عمیدالدین": {
        "root": "farsi"
    },
    "عنایت": {
        "root": "farsi"
    },
    "عنایتالله": {
        "root": "farsi"
    },
    "عندلیب": {
        "root": "farsi"
    },
    "عیار": {
        "root": "farsi"
    },
    "عیسا": {
        "root": "farsi"
    },
    "عیسی": {
        "root": "farsi"
    },
    "عینالدین": {
        "root": "farsi"
    },
    "عینالزمان": {
        "root": "farsi"
    },
    "عینالله": {
        "root": "farsi"
    },
    "عینعلی": {
        "root": "farsi"
    },
    "غاتفر": {
        "root": "farsi"
    },
    "غاثر": {
        "root": "farsi"
    },
    "غازان": {
        "root": "farsi"
    },
    "غازی": {
        "root": "farsi"
    },
    "غالب": {
        "root": "farsi"
    },
    "غباد": {
        "root": "farsi"
    },
    "غدیر": {
        "root": "farsi"
    },
    "غضنفر": {
        "root": "farsi"
    },
    "غفار": {
        "root": "farsi"
    },
    "غفور": {
        "root": "farsi"
    },
    "غلام": {
        "root": "farsi"
    },
    "غلامرضا": {
        "root": "farsi"
    },
    "غلامعلی": {
        "root": "farsi"
    },
    "غیاث": {
        "root": "farsi"
    },
    "غیاثالدین": {
        "root": "farsi"
    },
    "فروشی": {
        "root": "farsi"
    },
    "فرهود": {
        "root": "farsi"
    },
    "فاتح": {
        "root": "farsi"
    },
    "فاتک": {
        "root": "farsi"
    },
    "فارد": {
        "root": "farsi"
    },
    "فارناس": {
        "root": "farsi"
    },
    "فارناسس": {
        "root": "farsi"
    },
    "فارناک": {
        "root": "farsi"
    },
    "فاروق": {
        "root": "farsi"
    },
    "فاریاب": {
        "root": "farsi"
    },
    "فاضل": {
        "root": "farsi"
    },
    "فاطر": {
        "root": "farsi"
    },
    "فاطن": {
        "root": "farsi"
    },
    "فایز": {
        "root": "farsi"
    },
    "فایض": {
        "root": "farsi"
    },
    "فایق": {
        "root": "farsi"
    },
    "فائز": {
        "root": "farsi"
    },
    "فائض": {
        "root": "farsi"
    },
    "فتاح": {
        "root": "farsi"
    },
    "فتحالدین": {
        "root": "farsi"
    },
    "فتحالله": {
        "root": "farsi"
    },
    "فتحعلی": {
        "root": "farsi"
    },
    "فتوت": {
        "root": "farsi"
    },
    "فخرالدین": {
        "root": "farsi"
    },
    "فخرالملک": {
        "root": "farsi"
    },
    "فخیم": {
        "root": "farsi"
    },
    "فداک": {
        "root": "farsi"
    },
    "فرابرز": {
        "root": "farsi"
    },
    "فرادخت": {
        "root": "farsi"
    },
    "فراراد": {
        "root": "farsi"
    },
    "فرازان": {
        "root": "farsi"
    },
    "فرازمان": {
        "root": "farsi"
    },
    "فرازمند": {
        "root": "farsi"
    },
    "فراست": {
        "root": "farsi"
    },
    "فراسیاک": {
        "root": "farsi"
    },
    "فرام": {
        "root": "farsi"
    },
    "فرامرز": {
        "root": "farsi"
    },
    "فرانسیس": {
        "root": "farsi"
    },
    "فراوک": {
        "root": "farsi"
    },
    "فراهل": {
        "root": "farsi"
    },
    "فراهیم": {
        "root": "farsi"
    },
    "فراهین": {
        "root": "farsi"
    },
    "فراییم": {
        "root": "farsi"
    },
    "فرایین": {
        "root": "farsi"
    },
    "فربد": {
        "root": "farsi"
    },
    "فربود": {
        "root": "farsi"
    },
    "فربین": {
        "root": "farsi"
    },
    "فرتاش": {
        "root": "farsi"
    },
    "فرتوس": {
        "root": "farsi"
    },
    "فرج": {
        "root": "farsi"
    },
    "فرجاد": {
        "root": "farsi"
    },
    "فرجام": {
        "root": "farsi"
    },
    "فرجود": {
        "root": "farsi"
    },
    "فرحان": {
        "root": "farsi"
    },
    "فرحت": {
        "root": "farsi"
    },
    "فرخ": {
        "root": "farsi"
    },
    "فرخبد": {
        "root": "farsi"
    },
    "فرخبه": {
        "root": "farsi"
    },
    "فرخپی": {
        "root": "farsi"
    },
    "فرختاش": {
        "root": "farsi"
    },
    "فرخداد": {
        "root": "farsi"
    },
    "فرخزات": {
        "root": "farsi"
    },
    "فرخزند": {
        "root": "farsi"
    },
    "فرخشاد": {
        "root": "farsi"
    },
    "فرخیار": {
        "root": "farsi"
    },
    "فرخیسار": {
        "root": "farsi"
    },
    "فرخزاد": {
        "root": "farsi"
    },
    "فرخندهپی": {
        "root": "farsi"
    },
    "فرداد": {
        "root": "farsi"
    },
    "فردادمنش": {
        "root": "farsi"
    },
    "فردان": {
        "root": "farsi"
    },
    "فردین": {
        "root": "farsi"
    },
    "فرزاد": {
        "root": "farsi"
    },
    "فرزام": {
        "root": "farsi"
    },
    "فرزان": {
        "root": "farsi"
    },
    "فرزن": {
        "root": "farsi"
    },
    "فرزنه": {
        "root": "farsi"
    },
    "فرزیان": {
        "root": "farsi"
    },
    "فرزین": {
        "root": "farsi"
    },
    "فرساد": {
        "root": "farsi"
    },
    "فرسام": {
        "root": "farsi"
    },
    "فرسمن": {
        "root": "farsi"
    },
    "فرشآورد": {
        "root": "farsi"
    },
    "فرشاد": {
        "root": "farsi"
    },
    "فرشاسب": {
        "root": "farsi"
    },
    "فرشوشتر": {
        "root": "farsi"
    },
    "فرشید": {
        "root": "farsi"
    },
    "فرشیدورد": {
        "root": "farsi"
    },
    "فرشیم": {
        "root": "farsi"
    },
    "فرصت": {
        "root": "farsi"
    },
    "فرض": {
        "root": "farsi"
    },
    "فرطوس": {
        "root": "farsi"
    },
    "فرغار": {
        "root": "farsi"
    },
    "فرغان": {
        "root": "farsi"
    },
    "فرقان": {
        "root": "farsi"
    },
    "فرقد": {
        "root": "farsi"
    },
    "فرمان": {
        "root": "farsi"
    },
    "فرمد": {
        "root": "farsi"
    },
    "فرمند": {
        "root": "farsi"
    },
    "فرمنش": {
        "root": "farsi"
    },
    "فرمین": {
        "root": "farsi"
    },
    "فرناد": {
        "root": "farsi"
    },
    "فرناس": {
        "root": "farsi"
    },
    "فرناک": {
        "root": "farsi"
    },
    "فرنام": {
        "root": "farsi"
    },
    "فرند": {
        "root": "farsi"
    },
    "فرنود": {
        "root": "farsi"
    },
    "فرنور": {
        "root": "farsi"
    },
    "فرواک": {
        "root": "farsi"
    },
    "فرود": {
        "root": "farsi"
    },
    "فرورتیش": {
        "root": "farsi"
    },
    "فروزانفر": {
        "root": "farsi"
    },
    "فروهر": {
        "root": "farsi"
    },
    "فروهل": {
        "root": "farsi"
    },
    "فرهاد": {
        "root": "farsi"
    },
    "فرهام": {
        "root": "farsi"
    },
    "فرهان": {
        "root": "farsi"
    },
    "فرهمند": {
        "root": "farsi"
    },
    "فرهوش": {
        "root": "farsi"
    },
    "فرهوشداد": {
        "root": "farsi"
    },
    "فرهومند": {
        "root": "farsi"
    },
    "فریتوس": {
        "root": "farsi"
    },
    "فریان": {
        "root": "farsi"
    },
    "فریبرز": {
        "root": "farsi"
    },
    "فریتون": {
        "root": "farsi"
    },
    "فرید": {
        "root": "farsi"
    },
    "فریدالدین": {
        "root": "farsi"
    },
    "فریدالزمان": {
        "root": "farsi"
    },
    "فریدون": {
        "root": "farsi"
    },
    "فریشاد": {
        "root": "farsi"
    },
    "فریمان": {
        "root": "farsi"
    },
    "فریمن": {
        "root": "farsi"
    },
    "فریمند": {
        "root": "farsi"
    },
    "فرینام": {
        "root": "farsi"
    },
    "فرینوش": {
        "root": "farsi"
    },
    "فریین": {
        "root": "farsi"
    },
    "فصیح": {
        "root": "farsi"
    },
    "فصیحالدین": {
        "root": "farsi"
    },
    "فصیحالزمان": {
        "root": "farsi"
    },
    "فصیحالملک": {
        "root": "farsi"
    },
    "فضل": {
        "root": "farsi"
    },
    "فضلالله": {
        "root": "farsi"
    },
    "فضیل": {
        "root": "farsi"
    },
    "فغانیش": {
        "root": "farsi"
    },
    "فکرعلی": {
        "root": "farsi"
    },
    "فلق": {
        "root": "farsi"
    },
    "فلکالدین": {
        "root": "farsi"
    },
    "فور": {
        "root": "farsi"
    },
    "فوکا": {
        "root": "farsi"
    },
    "فوگان": {
        "root": "farsi"
    },
    "فؤاد": {
        "root": "farsi"
    },
    "فیاض": {
        "root": "farsi"
    },
    "فیروز": {
        "root": "farsi"
    },
    "فیروزان": {
        "root": "farsi"
    },
    "فیض": {
        "root": "farsi"
    },
    "فیضالله": {
        "root": "farsi"
    },
    "قابل": {
        "root": "farsi"
    },
    "قابوس": {
        "root": "farsi"
    },
    "قابیل": {
        "root": "farsi"
    },
    "قادر": {
        "root": "farsi"
    },
    "قارن": {
        "root": "farsi"
    },
    "قارون": {
        "root": "farsi"
    },
    "قازان": {
        "root": "farsi"
    },
    "قاسم": {
        "root": "farsi"
    },
    "قالوس": {
        "root": "farsi"
    },
    "قاهر": {
        "root": "farsi"
    },
    "قائد": {
        "root": "farsi"
    },
    "قائم": {
        "root": "farsi"
    },
    "قباد": {
        "root": "farsi"
    },
    "قبیله": {
        "root": "farsi"
    },
    "قدرت": {
        "root": "farsi"
    },
    "قدرتالله": {
        "root": "farsi"
    },
    "قدیر": {
        "root": "farsi"
    },
    "قدیس": {
        "root": "farsi"
    },
    "قراتکین": {
        "root": "farsi"
    },
    "قربان": {
        "root": "farsi"
    },
    "قربانعلی": {
        "root": "farsi"
    },
    "قطبالدین": {
        "root": "farsi"
    },
    "قلندر": {
        "root": "farsi"
    },
    "قلیچ": {
        "root": "farsi"
    },
    "قمرالدین": {
        "root": "farsi"
    },
    "قنبر": {
        "root": "farsi"
    },
    "قوامالدین": {
        "root": "farsi"
    },
    "قوامالملک": {
        "root": "farsi"
    },
    "قهار": {
        "root": "farsi"
    },
    "قهرمان": {
        "root": "farsi"
    },
    "قیصر": {
        "root": "farsi"
    },
    "قیطون": {
        "root": "farsi"
    },
    "قیوم": {
        "root": "farsi"
    },
    "کابی": {
        "root": "farsi"
    },
    "کاد": {
        "root": "farsi"
    },
    "کارانوس": {
        "root": "farsi"
    },
    "کاردار": {
        "root": "farsi"
    },
    "کارن": {
        "root": "farsi"
    },
    "کارنگ": {
        "root": "farsi"
    },
    "کاروند": {
        "root": "farsi"
    },
    "کارینا": {
        "root": "farsi"
    },
    "کاظم": {
        "root": "farsi"
    },
    "کافور": {
        "root": "farsi"
    },
    "کافی": {
        "root": "farsi"
    },
    "کافیالدین": {
        "root": "farsi"
    },
    "کاکله": {
        "root": "farsi"
    },
    "کاکو": {
        "root": "farsi"
    },
    "کاکی": {
        "root": "farsi"
    },
    "کال": {
        "root": "farsi"
    },
    "کالو": {
        "root": "farsi"
    },
    "کامبوزیا": {
        "root": "farsi"
    },
    "کامبیز": {
        "root": "farsi"
    },
    "کامجو": {
        "root": "farsi"
    },
    "کامداد": {
        "root": "farsi"
    },
    "کامدین": {
        "root": "farsi"
    },
    "کامران": {
        "root": "farsi"
    },
    "کامشاد": {
        "root": "farsi"
    },
    "کامکار": {
        "root": "farsi"
    },
    "کامگار": {
        "root": "farsi"
    },
    "کامنوش": {
        "root": "farsi"
    },
    "کاموس": {
        "root": "farsi"
    },
    "کامیاب": {
        "root": "farsi"
    },
    "کامیار": {
        "root": "farsi"
    },
    "کانبیدار": {
        "root": "farsi"
    },
    "کاوان": {
        "root": "farsi"
    },
    "کاوک": {
        "root": "farsi"
    },
    "کاووس": {
        "root": "farsi"
    },
    "کاووش": {
        "root": "farsi"
    },
    "کاوه": {
        "root": "farsi"
    },
    "کاویان": {
        "root": "farsi"
    },
    "کایوس": {
        "root": "farsi"
    },
    "کبوجیه": {
        "root": "farsi"
    },
    "کبوده": {
        "root": "farsi"
    },
    "کتماره": {
        "root": "farsi"
    },
    "کدمان": {
        "root": "farsi"
    },
    "کدیور": {
        "root": "farsi"
    },
    "کراخان": {
        "root": "farsi"
    },
    "کرامالدین": {
        "root": "farsi"
    },
    "کرامت": {
        "root": "farsi"
    },
    "کردعلی": {
        "root": "farsi"
    },
    "کرم": {
        "root": "farsi"
    },
    "کرمالله": {
        "root": "farsi"
    },
    "کروخان": {
        "root": "farsi"
    },
    "کریشنا": {
        "root": "farsi"
    },
    "کریم": {
        "root": "farsi"
    },
    "کسا": {
        "root": "farsi"
    },
    "کسرا": {
        "root": "farsi"
    },
    "کسری": {
        "root": "farsi"
    },
    "کشواد": {
        "root": "farsi"
    },
    "کلاهور": {
        "root": "farsi"
    },
    "کلباد": {
        "root": "farsi"
    },
    "کلیمالله": {
        "root": "farsi"
    },
    "کمال": {
        "root": "farsi"
    },
    "کمالالدین": {
        "root": "farsi"
    },
    "کمالالملک": {
        "root": "farsi"
    },
    "کمانگیر": {
        "root": "farsi"
    },
    "کمبوجیه": {
        "root": "farsi"
    },
    "کمیل": {
        "root": "farsi"
    },
    "کنارنگ": {
        "root": "farsi"
    },
    "کندر": {
        "root": "farsi"
    },
    "کندرو": {
        "root": "farsi"
    },
    "کوت": {
        "root": "farsi"
    },
    "کوچک": {
        "root": "farsi"
    },
    "کورش": {
        "root": "farsi"
    },
    "کورنگ": {
        "root": "farsi"
    },
    "کوروس": {
        "root": "farsi"
    },
    "کوروش": {
        "root": "farsi"
    },
    "کوش": {
        "root": "farsi"
    },
    "کوشا": {
        "root": "farsi"
    },
    "کوشاد": {
        "root": "farsi"
    },
    "کوشان": {
        "root": "farsi"
    },
    "کوشیار": {
        "root": "farsi"
    },
    "کولیار": {
        "root": "farsi"
    },
    "کوهرنگ": {
        "root": "farsi"
    },
    "کوهسار": {
        "root": "farsi"
    },
    "کوهشاد": {
        "root": "farsi"
    },
    "کوهیار": {
        "root": "farsi"
    },
    "کوهین": {
        "root": "farsi"
    },
    "کهار": {
        "root": "farsi"
    },
    "کهرم": {
        "root": "farsi"
    },
    "کهیلا": {
        "root": "farsi"
    },
    "کیآذر": {
        "root": "farsi"
    },
    "کیآرمین": {
        "root": "farsi"
    },
    "کیپیشین": {
        "root": "farsi"
    },
    "کیراد": {
        "root": "farsi"
    },
    "کیزاد": {
        "root": "farsi"
    },
    "کیگشتاسپ": {
        "root": "farsi"
    },
    "کیمنوش": {
        "root": "farsi"
    },
    "کیا": {
        "root": "farsi"
    },
    "کیاجور": {
        "root": "farsi"
    },
    "کیاچهر": {
        "root": "farsi"
    },
    "کیاراد": {
        "root": "farsi"
    },
    "کیارخ": {
        "root": "farsi"
    },
    "کیارزم": {
        "root": "farsi"
    },
    "کیارس": {
        "root": "farsi"
    },
    "کیارش": {
        "root": "farsi"
    },
    "کیازند": {
        "root": "farsi"
    },
    "کیاشا": {
        "root": "farsi"
    },
    "کیان": {
        "root": "farsi"
    },
    "کیانشیر": {
        "root": "farsi"
    },
    "کیانمهر": {
        "root": "farsi"
    },
    "کیانوش": {
        "root": "farsi"
    },
    "کیاوش": {
        "root": "farsi"
    },
    "کیخسرو": {
        "root": "farsi"
    },
    "کیسان": {
        "root": "farsi"
    },
    "کیقباد": {
        "root": "farsi"
    },
    "کیکاووس": {
        "root": "farsi"
    },
    "کیوان": {
        "root": "farsi"
    },
    "کیوس": {
        "root": "farsi"
    },
    "کیومرث": {
        "root": "farsi"
    },
    "کیهان": {
        "root": "farsi"
    },
    "گرشاسب": {
        "root": "farsi"
    },
    "گارنیک": {
        "root": "farsi"
    },
    "گالوس": {
        "root": "farsi"
    },
    "گایار": {
        "root": "farsi"
    },
    "گباد": {
        "root": "farsi"
    },
    "گرامی": {
        "root": "farsi"
    },
    "گرانخوار": {
        "root": "farsi"
    },
    "گرانمایه": {
        "root": "farsi"
    },
    "گراهون": {
        "root": "farsi"
    },
    "گرایش": {
        "root": "farsi"
    },
    "گرداب": {
        "root": "farsi"
    },
    "گردآزاد": {
        "root": "farsi"
    },
    "گردگیر": {
        "root": "farsi"
    },
    "گردو": {
        "root": "farsi"
    },
    "گرزم": {
        "root": "farsi"
    },
    "گرزن": {
        "root": "farsi"
    },
    "گرستون": {
        "root": "farsi"
    },
    "گرسیوز": {
        "root": "farsi"
    },
    "گرگین": {
        "root": "farsi"
    },
    "گرمانک": {
        "root": "farsi"
    },
    "گرمایل": {
        "root": "farsi"
    },
    "گروخان": {
        "root": "farsi"
    },
    "گروی": {
        "root": "farsi"
    },
    "گژدهم": {
        "root": "farsi"
    },
    "گژگین": {
        "root": "farsi"
    },
    "گستهم": {
        "root": "farsi"
    },
    "گشتاسب": {
        "root": "farsi"
    },
    "گشتاسپ": {
        "root": "farsi"
    },
    "گشسپ": {
        "root": "farsi"
    },
    "گشواد": {
        "root": "farsi"
    },
    "گلبالا": {
        "root": "farsi"
    },
    "گلشاه": {
        "root": "farsi"
    },
    "گلگله": {
        "root": "farsi"
    },
    "گوارا": {
        "root": "farsi"
    },
    "گودرز": {
        "root": "farsi"
    },
    "گورنگ": {
        "root": "farsi"
    },
    "گوزل": {
        "root": "farsi"
    },
    "گوشیار": {
        "root": "farsi"
    },
    "گهار": {
        "root": "farsi"
    },
    "گیل": {
        "root": "farsi"
    },
    "گیلو": {
        "root": "farsi"
    },
    "گیو": {
        "root": "farsi"
    },
    "لابان": {
        "root": "farsi"
    },
    "لاوان": {
        "root": "farsi"
    },
    "لاوین": {
        "root": "farsi"
    },
    "لبیب": {
        "root": "farsi"
    },
    "لسانالدین": {
        "root": "farsi"
    },
    "لطفالدین": {
        "root": "farsi"
    },
    "لطفالله": {
        "root": "farsi"
    },
    "لطفعلی": {
        "root": "farsi"
    },
    "لطیف": {
        "root": "farsi"
    },
    "لقمان": {
        "root": "farsi"
    },
    "لنا": {
        "root": "farsi"
    },
    "لنبک": {
        "root": "farsi"
    },
    "لواده": {
        "root": "farsi"
    },
    "لهاک": {
        "root": "farsi"
    },
    "لهراسب": {
        "root": "farsi"
    },
    "لهراسپ": {
        "root": "farsi"
    },
    "لیث": {
        "root": "farsi"
    },
    "لیوه": {
        "root": "farsi"
    },
    "مهراب": {
        "root": "farsi"
    },
    "ماتیار": {
        "root": "farsi"
    },
    "ماتیکان": {
        "root": "farsi"
    },
    "ماجد": {
        "root": "farsi"
    },
    "ماحوز": {
        "root": "farsi"
    },
    "ماخ": {
        "root": "farsi"
    },
    "مادیس": {
        "root": "farsi"
    },
    "ماراسپند": {
        "root": "farsi"
    },
    "ماراسفند": {
        "root": "farsi"
    },
    "مارتیک": {
        "root": "farsi"
    },
    "مارتین": {
        "root": "farsi"
    },
    "ماردین": {
        "root": "farsi"
    },
    "ماروسپند": {
        "root": "farsi"
    },
    "مازار": {
        "root": "farsi"
    },
    "مازنه": {
        "root": "farsi"
    },
    "مازیار": {
        "root": "farsi"
    },
    "ماشاالله": {
        "root": "farsi"
    },
    "ماکان": {
        "root": "farsi"
    },
    "مالک": {
        "root": "farsi"
    },
    "ماناسه": {
        "root": "farsi"
    },
    "مانای": {
        "root": "farsi"
    },
    "ماندا": {
        "root": "farsi"
    },
    "ماندگار": {
        "root": "farsi"
    },
    "مانوش": {
        "root": "farsi"
    },
    "مانی": {
        "root": "farsi"
    },
    "ماونداد": {
        "root": "farsi"
    },
    "ماهبرزین": {
        "root": "farsi"
    },
    "ماهبنداد": {
        "root": "farsi"
    },
    "ماهفرزین": {
        "root": "farsi"
    },
    "ماهگشسپ": {
        "root": "farsi"
    },
    "ماهمهر": {
        "root": "farsi"
    },
    "ماهان": {
        "root": "farsi"
    },
    "ماهانداد": {
        "root": "farsi"
    },
    "ماهد": {
        "root": "farsi"
    },
    "ماهداد": {
        "root": "farsi"
    },
    "ماهر": {
        "root": "farsi"
    },
    "ماهو": {
        "root": "farsi"
    },
    "ماهونداد": {
        "root": "farsi"
    },
    "ماهیار": {
        "root": "farsi"
    },
    "مأمون": {
        "root": "farsi"
    },
    "مبارزالدین": {
        "root": "farsi"
    },
    "مبارک": {
        "root": "farsi"
    },
    "مبین": {
        "root": "farsi"
    },
    "متی": {
        "root": "farsi"
    },
    "متین": {
        "root": "farsi"
    },
    "مجتبی": {
        "root": "farsi"
    },
    "مجد": {
        "root": "farsi"
    },
    "مجدالدین": {
        "root": "farsi"
    },
    "مجدود": {
        "root": "farsi"
    },
    "مجید": {
        "root": "farsi"
    },
    "مجیر": {
        "root": "farsi"
    },
    "مجیرالدین": {
        "root": "farsi"
    },
    "محبالدین": {
        "root": "farsi"
    },
    "محتشم": {
        "root": "farsi"
    },
    "محدث": {
        "root": "farsi"
    },
    "محراب": {
        "root": "farsi"
    },
    "محرم": {
        "root": "farsi"
    },
    "محسن": {
        "root": "farsi"
    },
    "محمد": {
        "root": "farsi"
    },
    "محمدصالح": {
        "root": "farsi"
    },
    "محمدکیا": {
        "root": "farsi"
    },
    "محمدهادی": {
        "root": "farsi"
    },
    "محمدامین": {
        "root": "farsi"
    },
    "محمدآئین": {
        "root": "farsi"
    },
    "محمدپارسا": {
        "root": "farsi"
    },
    "محمدجواد": {
        "root": "farsi"
    },
    "محمدحسین": {
        "root": "farsi"
    },
    "محمدرضا": {
        "root": "farsi"
    },
    "محمدطاها": {
        "root": "farsi"
    },
    "محمدعباس": {
        "root": "farsi"
    },
    "محمدعلی": {
        "root": "farsi"
    },
    "محمدمتین": {
        "root": "farsi"
    },
    "محمدمهدی": {
        "root": "farsi"
    },
    "محمدیار": {
        "root": "farsi"
    },
    "محمدیاسین": {
        "root": "farsi"
    },
    "محمود": {
        "root": "farsi"
    },
    "محیالدین": {
        "root": "farsi"
    },
    "محیط": {
        "root": "farsi"
    },
    "محیی": {
        "root": "farsi"
    },
    "مختار": {
        "root": "farsi"
    },
    "مدریک": {
        "root": "farsi"
    },
    "مدیوماه": {
        "root": "farsi"
    },
    "مراد": {
        "root": "farsi"
    },
    "مرتضی": {
        "root": "farsi"
    },
    "مرداس": {
        "root": "farsi"
    },
    "مردافکن": {
        "root": "farsi"
    },
    "مردانشه": {
        "root": "farsi"
    },
    "مرداویج": {
        "root": "farsi"
    },
    "مردو": {
        "root": "farsi"
    },
    "مرسا": {
        "root": "farsi"
    },
    "مرسل": {
        "root": "farsi"
    },
    "مرشد": {
        "root": "farsi"
    },
    "مرصاد": {
        "root": "farsi"
    },
    "مروان": {
        "root": "farsi"
    },
    "مزدا": {
        "root": "farsi"
    },
    "مزدک": {
        "root": "farsi"
    },
    "مسباد": {
        "root": "farsi"
    },
    "مسعود": {
        "root": "farsi"
    },
    "مسلم": {
        "root": "farsi"
    },
    "مسیب": {
        "root": "farsi"
    },
    "مسیح": {
        "root": "farsi"
    },
    "مشتاق": {
        "root": "farsi"
    },
    "مشرف": {
        "root": "farsi"
    },
    "مشرفالدین": {
        "root": "farsi"
    },
    "مشکان": {
        "root": "farsi"
    },
    "مشهود": {
        "root": "farsi"
    },
    "مشهور": {
        "root": "farsi"
    },
    "مشی": {
        "root": "farsi"
    },
    "مشیا": {
        "root": "farsi"
    },
    "مشیت": {
        "root": "farsi"
    },
    "مشید": {
        "root": "farsi"
    },
    "مشیر": {
        "root": "farsi"
    },
    "مشیرالدین": {
        "root": "farsi"
    },
    "مصباح": {
        "root": "farsi"
    },
    "مصطفی": {
        "root": "farsi"
    },
    "مصفا": {
        "root": "farsi"
    },
    "مصلح": {
        "root": "farsi"
    },
    "مصلحالدین": {
        "root": "farsi"
    },
    "مصیب": {
        "root": "farsi"
    },
    "مطهر": {
        "root": "farsi"
    },
    "مطیب": {
        "root": "farsi"
    },
    "مطیعالله": {
        "root": "farsi"
    },
    "مظاهر": {
        "root": "farsi"
    },
    "مظفر": {
        "root": "farsi"
    },
    "مظفرالدین": {
        "root": "farsi"
    },
    "مظفرعلی": {
        "root": "farsi"
    },
    "مظهر": {
        "root": "farsi"
    },
    "معاد": {
        "root": "farsi"
    },
    "معتصم": {
        "root": "farsi"
    },
    "معتضد": {
        "root": "farsi"
    },
    "معتقد": {
        "root": "farsi"
    },
    "معتمد": {
        "root": "farsi"
    },
    "معراج": {
        "root": "farsi"
    },
    "معزالدین": {
        "root": "farsi"
    },
    "معطی": {
        "root": "farsi"
    },
    "معمر": {
        "root": "farsi"
    },
    "معید": {
        "root": "farsi"
    },
    "معین": {
        "root": "farsi"
    },
    "معینالدین": {
        "root": "farsi"
    },
    "مقبل": {
        "root": "farsi"
    },
    "مقتدر": {
        "root": "farsi"
    },
    "مقداد": {
        "root": "farsi"
    },
    "مقصد": {
        "root": "farsi"
    },
    "مقصود": {
        "root": "farsi"
    },
    "مقیما": {
        "root": "farsi"
    },
    "مکابیز": {
        "root": "farsi"
    },
    "مگابیز": {
        "root": "farsi"
    },
    "ملکا": {
        "root": "farsi"
    },
    "ملکان": {
        "root": "farsi"
    },
    "منجیک": {
        "root": "farsi"
    },
    "مندا": {
        "root": "farsi"
    },
    "مندی": {
        "root": "farsi"
    },
    "منذر": {
        "root": "farsi"
    },
    "منشور": {
        "root": "farsi"
    },
    "منصور": {
        "root": "farsi"
    },
    "منوچهر": {
        "root": "farsi"
    },
    "منوش": {
        "root": "farsi"
    },
    "منوشان": {
        "root": "farsi"
    },
    "منوشچهر": {
        "root": "farsi"
    },
    "منوشفر": {
        "root": "farsi"
    },
    "موسی": {
        "root": "farsi"
    },
    "موشا": {
        "root": "farsi"
    },
    "مویز": {
        "root": "farsi"
    },
    "مهابت": {
        "root": "farsi"
    },
    "مهام": {
        "root": "farsi"
    },
    "مهان": {
        "root": "farsi"
    },
    "مهباد": {
        "root": "farsi"
    },
    "مهبد": {
        "root": "farsi"
    },
    "مهبود": {
        "root": "farsi"
    },
    "مهداد": {
        "root": "farsi"
    },
    "مهدی": {
        "root": "farsi"
    },
    "مهدیار": {
        "root": "farsi"
    },
    "مهذبالدین": {
        "root": "farsi"
    },
    "مهراج": {
        "root": "farsi"
    },
    "مهراد": {
        "root": "farsi"
    },
    "مهراز": {
        "root": "farsi"
    },
    "مهراس": {
        "root": "farsi"
    },
    "مهراسپند": {
        "root": "farsi"
    },
    "مهرام": {
        "root": "farsi"
    },
    "مهران": {
        "root": "farsi"
    },
    "مهرانستاد": {
        "root": "farsi"
    },
    "مهرآزاد": {
        "root": "farsi"
    },
    "مهربرزین": {
        "root": "farsi"
    },
    "مهربد": {
        "root": "farsi"
    },
    "مهربنداد": {
        "root": "farsi"
    },
    "مهرپرور": {
        "root": "farsi"
    },
    "مهرپوی": {
        "root": "farsi"
    },
    "مهرپویا": {
        "root": "farsi"
    },
    "مهرپیکر": {
        "root": "farsi"
    },
    "مهرتاش": {
        "root": "farsi"
    },
    "مهرجو": {
        "root": "farsi"
    },
    "مهرداد": {
        "root": "farsi"
    },
    "مهردار": {
        "root": "farsi"
    },
    "مهرسام": {
        "root": "farsi"
    },
    "مهرشاد": {
        "root": "farsi"
    },
    "مهرمس": {
        "root": "farsi"
    },
    "مهرماه": {
        "root": "farsi"
    },
    "مهرنرسه": {
        "root": "farsi"
    },
    "مهرنیا": {
        "root": "farsi"
    },
    "مهریاد": {
        "root": "farsi"
    },
    "مهریار": {
        "root": "farsi"
    },
    "مهزیار": {
        "root": "farsi"
    },
    "مهست": {
        "root": "farsi"
    },
    "مهنام": {
        "root": "farsi"
    },
    "مهند": {
        "root": "farsi"
    },
    "مهیاد": {
        "root": "farsi"
    },
    "مهیار": {
        "root": "farsi"
    },
    "میثاق": {
        "root": "farsi"
    },
    "میثم": {
        "root": "farsi"
    },
    "میحاد": {
        "root": "farsi"
    },
    "میخائیل": {
        "root": "farsi"
    },
    "میران": {
        "root": "farsi"
    },
    "میرو": {
        "root": "farsi"
    },
    "میرین": {
        "root": "farsi"
    },
    "میشان": {
        "root": "farsi"
    },
    "میشواک": {
        "root": "farsi"
    },
    "میشه": {
        "root": "farsi"
    },
    "میعاد": {
        "root": "farsi"
    },
    "میکاییل": {
        "root": "farsi"
    },
    "میکائیل": {
        "root": "farsi"
    },
    "میکسا": {
        "root": "farsi"
    },
    "میلاد": {
        "root": "farsi"
    },
    "میلان": {
        "root": "farsi"
    },
    "مینوس": {
        "root": "farsi"
    },
    "میهنیار": {
        "root": "farsi"
    },
    "نستور": {
        "root": "farsi"
    },
    "نادر": {
        "root": "farsi"
    },
    "نادعلی": {
        "root": "farsi"
    },
    "نادینوس": {
        "root": "farsi"
    },
    "ناشا": {
        "root": "farsi"
    },
    "ناصحالدین": {
        "root": "farsi"
    },
    "ناصر": {
        "root": "farsi"
    },
    "ناصرالدین": {
        "root": "farsi"
    },
    "ناضر": {
        "root": "farsi"
    },
    "ناظم": {
        "root": "farsi"
    },
    "نامجو": {
        "root": "farsi"
    },
    "نامدار": {
        "root": "farsi"
    },
    "نامور": {
        "root": "farsi"
    },
    "نامی": {
        "root": "farsi"
    },
    "ناورز": {
        "root": "farsi"
    },
    "ناهیرا": {
        "root": "farsi"
    },
    "نایب": {
        "root": "farsi"
    },
    "نبرزین": {
        "root": "farsi"
    },
    "نبوت": {
        "root": "farsi"
    },
    "نبی": {
        "root": "farsi"
    },
    "نجات": {
        "root": "farsi"
    },
    "نجاتالله": {
        "root": "farsi"
    },
    "نجف": {
        "root": "farsi"
    },
    "نجمالدین": {
        "root": "farsi"
    },
    "نجیب": {
        "root": "farsi"
    },
    "نجیبالدین": {
        "root": "farsi"
    },
    "ندیم": {
        "root": "farsi"
    },
    "نرداگشسپ": {
        "root": "farsi"
    },
    "نرسی": {
        "root": "farsi"
    },
    "نریمان": {
        "root": "farsi"
    },
    "نستار": {
        "root": "farsi"
    },
    "نستود": {
        "root": "farsi"
    },
    "نستوه": {
        "root": "farsi"
    },
    "نستهین": {
        "root": "farsi"
    },
    "نشاط": {
        "root": "farsi"
    },
    "نشواد": {
        "root": "farsi"
    },
    "نصر": {
        "root": "farsi"
    },
    "نصرالدین": {
        "root": "farsi"
    },
    "نصرالله": {
        "root": "farsi"
    },
    "نصرتالله": {
        "root": "farsi"
    },
    "نصیر": {
        "root": "farsi"
    },
    "نصیرا": {
        "root": "farsi"
    },
    "نصیرالدین": {
        "root": "farsi"
    },
    "نضیر": {
        "root": "farsi"
    },
    "نظام": {
        "root": "farsi"
    },
    "نظامالدین": {
        "root": "farsi"
    },
    "نظامالملک": {
        "root": "farsi"
    },
    "نظرعلی": {
        "root": "farsi"
    },
    "نعمان": {
        "root": "farsi"
    },
    "نعمت": {
        "root": "farsi"
    },
    "نعمتالله": {
        "root": "farsi"
    },
    "نعیم": {
        "root": "farsi"
    },
    "نعیمالدین": {
        "root": "farsi"
    },
    "نعیما": {
        "root": "farsi"
    },
    "نقدعلی": {
        "root": "farsi"
    },
    "نقی": {
        "root": "farsi"
    },
    "نمایان": {
        "root": "farsi"
    },
    "نواب": {
        "root": "farsi"
    },
    "نوبخت": {
        "root": "farsi"
    },
    "نوتاش": {
        "root": "farsi"
    },
    "نوتریکا": {
        "root": "farsi"
    },
    "نوح": {
        "root": "farsi"
    },
    "نوذر": {
        "root": "farsi"
    },
    "نورالدین": {
        "root": "farsi"
    },
    "نورالله": {
        "root": "farsi"
    },
    "نوراهان": {
        "root": "farsi"
    },
    "نوروز": {
        "root": "farsi"
    },
    "نورهان": {
        "root": "farsi"
    },
    "نوش": {
        "root": "farsi"
    },
    "نوشآذر": {
        "root": "farsi"
    },
    "نوشاب": {
        "root": "farsi"
    },
    "نوشی": {
        "root": "farsi"
    },
    "نوشیار": {
        "root": "farsi"
    },
    "نوشیروان": {
        "root": "farsi"
    },
    "نویان": {
        "root": "farsi"
    },
    "نوید": {
        "root": "farsi"
    },
    "نوین": {
        "root": "farsi"
    },
    "نهاد": {
        "root": "farsi"
    },
    "نهام": {
        "root": "farsi"
    },
    "نیاتور": {
        "root": "farsi"
    },
    "نیاسان": {
        "root": "farsi"
    },
    "نیاطوس": {
        "root": "farsi"
    },
    "نیاک": {
        "root": "farsi"
    },
    "نیاوش": {
        "root": "farsi"
    },
    "نیاوند": {
        "root": "farsi"
    },
    "نیسان": {
        "root": "farsi"
    },
    "نیک": {
        "root": "farsi"
    },
    "نیکپی": {
        "root": "farsi"
    },
    "نیکرای": {
        "root": "farsi"
    },
    "نیکان": {
        "root": "farsi"
    },
    "نیکاو": {
        "root": "farsi"
    },
    "نیکدل": {
        "root": "farsi"
    },
    "نیکروز": {
        "root": "farsi"
    },
    "نیکزاد": {
        "root": "farsi"
    },
    "نیکنام": {
        "root": "farsi"
    },
    "نیکوکار": {
        "root": "farsi"
    },
    "نیما": {
        "root": "farsi"
    },
    "نیو": {
        "root": "farsi"
    },
    "نیوتش": {
        "root": "farsi"
    },
    "نیوتیش": {
        "root": "farsi"
    },
    "نیوزاد": {
        "root": "farsi"
    },
    "نیوزار": {
        "root": "farsi"
    },
    "نیهاد": {
        "root": "farsi"
    },
    "ورهرام": {
        "root": "farsi"
    },
    "وسپار": {
        "root": "farsi"
    },
    "وسنه": {
        "root": "farsi"
    },
    "ولخش": {
        "root": "farsi"
    },
    "وهمنش": {
        "root": "farsi"
    },
    "وهومن": {
        "root": "farsi"
    },
    "واته": {
        "root": "farsi"
    },
    "واتیار": {
        "root": "farsi"
    },
    "واجد": {
        "root": "farsi"
    },
    "واحد": {
        "root": "farsi"
    },
    "وادا": {
        "root": "farsi"
    },
    "وادان": {
        "root": "farsi"
    },
    "وادگان": {
        "root": "farsi"
    },
    "وادیار": {
        "root": "farsi"
    },
    "واران": {
        "root": "farsi"
    },
    "وارتان": {
        "root": "farsi"
    },
    "واردان": {
        "root": "farsi"
    },
    "وارش": {
        "root": "farsi"
    },
    "وارونا": {
        "root": "farsi"
    },
    "واسپور": {
        "root": "farsi"
    },
    "واسپوهر": {
        "root": "farsi"
    },
    "واصف": {
        "root": "farsi"
    },
    "وافی": {
        "root": "farsi"
    },
    "والا": {
        "root": "farsi"
    },
    "والی": {
        "root": "farsi"
    },
    "وامق": {
        "root": "farsi"
    },
    "وانان": {
        "root": "farsi"
    },
    "وانتیار": {
        "root": "farsi"
    },
    "واهب": {
        "root": "farsi"
    },
    "وتار": {
        "root": "farsi"
    },
    "وثوق": {
        "root": "farsi"
    },
    "وجاسب": {
        "root": "farsi"
    },
    "وجیهالله": {
        "root": "farsi"
    },
    "وحدت": {
        "root": "farsi"
    },
    "وحید": {
        "root": "farsi"
    },
    "وحیدالدین": {
        "root": "farsi"
    },
    "وخش": {
        "root": "farsi"
    },
    "وخشداد": {
        "root": "farsi"
    },
    "وخشور": {
        "root": "farsi"
    },
    "ودود": {
        "root": "farsi"
    },
    "ودیع": {
        "root": "farsi"
    },
    "وراز": {
        "root": "farsi"
    },
    "ورازبنده": {
        "root": "farsi"
    },
    "ورازپیروز": {
        "root": "farsi"
    },
    "ورازتیرداد": {
        "root": "farsi"
    },
    "ورازمهر": {
        "root": "farsi"
    },
    "ورازنرسی": {
        "root": "farsi"
    },
    "ورجاوند": {
        "root": "farsi"
    },
    "وردانشاه": {
        "root": "farsi"
    },
    "وردین": {
        "root": "farsi"
    },
    "ورزا": {
        "root": "farsi"
    },
    "ورزاک": {
        "root": "farsi"
    },
    "ورزان": {
        "root": "farsi"
    },
    "ورزگمهر": {
        "root": "farsi"
    },
    "ورزم": {
        "root": "farsi"
    },
    "ورزمیار": {
        "root": "farsi"
    },
    "ورزیار": {
        "root": "farsi"
    },
    "ورزیر": {
        "root": "farsi"
    },
    "ورساز": {
        "root": "farsi"
    },
    "ورشاد": {
        "root": "farsi"
    },
    "ورشنگ": {
        "root": "farsi"
    },
    "ورگر": {
        "root": "farsi"
    },
    "ورگیر": {
        "root": "farsi"
    },
    "ورونیکا": {
        "root": "farsi"
    },
    "وریا": {
        "root": "farsi"
    },
    "وژاسپ": {
        "root": "farsi"
    },
    "وساک": {
        "root": "farsi"
    },
    "وسپور": {
        "root": "farsi"
    },
    "وسپوهر": {
        "root": "farsi"
    },
    "وستوی": {
        "root": "farsi"
    },
    "وستهم": {
        "root": "farsi"
    },
    "وشمگیر": {
        "root": "farsi"
    },
    "وفااندیش": {
        "root": "farsi"
    },
    "وفادار": {
        "root": "farsi"
    },
    "وقار": {
        "root": "farsi"
    },
    "ولا": {
        "root": "farsi"
    },
    "ولام": {
        "root": "farsi"
    },
    "ولی": {
        "root": "farsi"
    },
    "ولیالله": {
        "root": "farsi"
    },
    "ولید": {
        "root": "farsi"
    },
    "ولیداد": {
        "root": "farsi"
    },
    "ونداد": {
        "root": "farsi"
    },
    "ونن": {
        "root": "farsi"
    },
    "ونون": {
        "root": "farsi"
    },
    "وهپناه": {
        "root": "farsi"
    },
    "وهوران": {
        "root": "farsi"
    },
    "وهاب": {
        "root": "farsi"
    },
    "وهامان": {
        "root": "farsi"
    },
    "وهب": {
        "root": "farsi"
    },
    "وهبرز": {
        "root": "farsi"
    },
    "وهرام": {
        "root": "farsi"
    },
    "وهرامشاپور": {
        "root": "farsi"
    },
    "وهرامگشسب": {
        "root": "farsi"
    },
    "وهزاد": {
        "root": "farsi"
    },
    "وهسود": {
        "root": "farsi"
    },
    "وهشاپور": {
        "root": "farsi"
    },
    "وهمن": {
        "root": "farsi"
    },
    "وهمهر": {
        "root": "farsi"
    },
    "وهنیا": {
        "root": "farsi"
    },
    "ویارش": {
        "root": "farsi"
    },
    "ویراب": {
        "root": "farsi"
    },
    "ویریا": {
        "root": "farsi"
    },
    "ویسپار": {
        "root": "farsi"
    },
    "ویسپرد": {
        "root": "farsi"
    },
    "ویستور": {
        "root": "farsi"
    },
    "ویستهم": {
        "root": "farsi"
    },
    "ویسه": {
        "root": "farsi"
    },
    "ویشتاسب": {
        "root": "farsi"
    },
    "ویگن": {
        "root": "farsi"
    },
    "ویناسب": {
        "root": "farsi"
    },
    "ویو": {
        "root": "farsi"
    },
    "ویوان": {
        "root": "farsi"
    },
    "ویهان": {
        "root": "farsi"
    },
    "هخامنش": {
        "root": "farsi"
    },
    "هردار": {
        "root": "farsi"
    },
    "هژیر": {
        "root": "farsi"
    },
    "هرمز": {
        "root": "farsi"
    },
    "هزوارش": {
        "root": "farsi"
    },
    "هژبر": {
        "root": "farsi"
    },
    "هابیل": {
        "root": "farsi"
    },
    "هاتف": {
        "root": "farsi"
    },
    "هادان": {
        "root": "farsi"
    },
    "هادی": {
        "root": "farsi"
    },
    "هارپارک": {
        "root": "farsi"
    },
    "هارپاک": {
        "root": "farsi"
    },
    "هارون": {
        "root": "farsi"
    },
    "هاشم": {
        "root": "farsi"
    },
    "هامان": {
        "root": "farsi"
    },
    "هامر": {
        "root": "farsi"
    },
    "هامرز": {
        "root": "farsi"
    },
    "هامن": {
        "root": "farsi"
    },
    "هامون": {
        "root": "farsi"
    },
    "هامویه": {
        "root": "farsi"
    },
    "هامی": {
        "root": "farsi"
    },
    "هامین": {
        "root": "farsi"
    },
    "هانی": {
        "root": "farsi"
    },
    "هانیبال": {
        "root": "farsi"
    },
    "هاوار": {
        "root": "farsi"
    },
    "هاوش": {
        "root": "farsi"
    },
    "هاون": {
        "root": "farsi"
    },
    "هاونی": {
        "root": "farsi"
    },
    "هاووش": {
        "root": "farsi"
    },
    "هایکا": {
        "root": "farsi"
    },
    "هباسپ": {
        "root": "farsi"
    },
    "هبیةلله": {
        "root": "farsi"
    },
    "هجیر": {
        "root": "farsi"
    },
    "هدایت": {
        "root": "farsi"
    },
    "هدایتالله": {
        "root": "farsi"
    },
    "هرمان": {
        "root": "farsi"
    },
    "هرمزد": {
        "root": "farsi"
    },
    "هرمزدیار": {
        "root": "farsi"
    },
    "هرمس": {
        "root": "farsi"
    },
    "هزاره": {
        "root": "farsi"
    },
    "هزبر": {
        "root": "farsi"
    },
    "هستیار": {
        "root": "farsi"
    },
    "هشام": {
        "root": "farsi"
    },
    "هفال": {
        "root": "farsi"
    },
    "هلاکو": {
        "root": "farsi"
    },
    "هلبژارده": {
        "root": "farsi"
    },
    "هلبژیر": {
        "root": "farsi"
    },
    "هلبست": {
        "root": "farsi"
    },
    "هلدیر": {
        "root": "farsi"
    },
    "هلکو": {
        "root": "farsi"
    },
    "هلکوت": {
        "root": "farsi"
    },
    "هلگر": {
        "root": "farsi"
    },
    "هلگورد": {
        "root": "farsi"
    },
    "هلمت": {
        "root": "farsi"
    },
    "هلموت": {
        "root": "farsi"
    },
    "هلورین": {
        "root": "farsi"
    },
    "هلیوس": {
        "root": "farsi"
    },
    "همام": {
        "root": "farsi"
    },
    "همامالدین": {
        "root": "farsi"
    },
    "هماوند": {
        "root": "farsi"
    },
    "همایون": {
        "root": "farsi"
    },
    "همت": {
        "root": "farsi"
    },
    "همگون": {
        "root": "farsi"
    },
    "همنواد": {
        "root": "farsi"
    },
    "هنرمند": {
        "root": "farsi"
    },
    "هنگام": {
        "root": "farsi"
    },
    "هنی": {
        "root": "farsi"
    },
    "هوار": {
        "root": "farsi"
    },
    "هوال": {
        "root": "farsi"
    },
    "هوبر": {
        "root": "farsi"
    },
    "هوتخش": {
        "root": "farsi"
    },
    "هوتک": {
        "root": "farsi"
    },
    "هوتن": {
        "root": "farsi"
    },
    "هود": {
        "root": "farsi"
    },
    "هودین": {
        "root": "farsi"
    },
    "هورا": {
        "root": "farsi"
    },
    "هوراد": {
        "root": "farsi"
    },
    "هوراز": {
        "root": "farsi"
    },
    "هورامان": {
        "root": "farsi"
    },
    "هورمز": {
        "root": "farsi"
    },
    "هورمزد": {
        "root": "farsi"
    },
    "هورمک": {
        "root": "farsi"
    },
    "هوریار": {
        "root": "farsi"
    },
    "هوسکر": {
        "root": "farsi"
    },
    "هوشمند": {
        "root": "farsi"
    },
    "هوشنگ": {
        "root": "farsi"
    },
    "هوشیار": {
        "root": "farsi"
    },
    "هوشیدر": {
        "root": "farsi"
    },
    "هوکرپ": {
        "root": "farsi"
    },
    "هوگر": {
        "root": "farsi"
    },
    "هولان": {
        "root": "farsi"
    },
    "هوم": {
        "root": "farsi"
    },
    "هومت": {
        "root": "farsi"
    },
    "هومن": {
        "root": "farsi"
    },
    "هونام": {
        "root": "farsi"
    },
    "هونیاک": {
        "root": "farsi"
    },
    "هیبت": {
        "root": "farsi"
    },
    "هیبتالله": {
        "root": "farsi"
    },
    "هیتاسب": {
        "root": "farsi"
    },
    "هیدی": {
        "root": "farsi"
    },
    "هیرا": {
        "root": "farsi"
    },
    "هیراب": {
        "root": "farsi"
    },
    "هیراد": {
        "root": "farsi"
    },
    "هیربد": {
        "root": "farsi"
    },
    "هیرسا": {
        "root": "farsi"
    },
    "هیرش": {
        "root": "farsi"
    },
    "هیرمند": {
        "root": "farsi"
    },
    "هیرو": {
        "root": "farsi"
    },
    "هیرود": {
        "root": "farsi"
    },
    "هیژا": {
        "root": "farsi"
    },
    "هیشنگ": {
        "root": "farsi"
    },
    "هیشوی": {
        "root": "farsi"
    },
    "هیمن": {
        "root": "farsi"
    },
    "هیمه": {
        "root": "farsi"
    },
    "هیئت": {
        "root": "farsi"
    },
    "یادگار": {
        "root": "farsi"
    },
    "یار": {
        "root": "farsi"
    },
    "یارا": {
        "root": "farsi"
    },
    "یارتا": {
        "root": "farsi"
    },
    "یارعلی": {
        "root": "farsi"
    },
    "یارمحمد": {
        "root": "farsi"
    },
    "یارور": {
        "root": "farsi"
    },
    "یاره": {
        "root": "farsi"
    },
    "یاسان": {
        "root": "farsi"
    },
    "یاسر": {
        "root": "farsi"
    },
    "یاسین": {
        "root": "farsi"
    },
    "یاشا": {
        "root": "farsi"
    },
    "یاشار": {
        "root": "farsi"
    },
    "یاقوت": {
        "root": "farsi"
    },
    "یاور": {
        "root": "farsi"
    },
    "یحیی": {
        "root": "farsi"
    },
    "یدالله": {
        "root": "farsi"
    },
    "یرمیا": {
        "root": "farsi"
    },
    "یزداد": {
        "root": "farsi"
    },
    "یزدان": {
        "root": "farsi"
    },
    "یزدانآفرید": {
        "root": "farsi"
    },
    "یزدانبخت": {
        "root": "farsi"
    },
    "یزدانمهر": {
        "root": "farsi"
    },
    "یزدانشاه": {
        "root": "farsi"
    },
    "یزدانیار": {
        "root": "farsi"
    },
    "یزدجرد": {
        "root": "farsi"
    },
    "یزدگرد": {
        "root": "farsi"
    },
    "یزدیار": {
        "root": "farsi"
    },
    "یعقوب": {
        "root": "farsi"
    },
    "یلانسینه": {
        "root": "farsi"
    },
    "یمینالدین": {
        "root": "farsi"
    },
    "ینال": {
        "root": "farsi"
    },
    "یوحنا": {
        "root": "farsi"
    },
    "یورام": {
        "root": "farsi"
    },
    "یوزارسیف": {
        "root": "farsi"
    },
    "یوسف": {
        "root": "farsi"
    },
    "یوشع": {
        "root": "farsi"
    },
    "یوشیج": {
        "root": "farsi"
    },
    "یونا": {
        "root": "farsi"
    },
    "یونس": {
        "root": "farsi"
    },
    "یهودا": {
        "root": "farsi"
    }
}

const nameInfo = (name) => {
    return male[name] ? { gender: 'male', root: male[name].root } : female[name] ? { gender: 'female', root: female[name].root } : { gender: 'unkown' }
}

module.exports = {
    nameInfo
};